/** This file has been generated by @workleap/create-schemas (https://github.com/workleap/wl-openapi-typescript). Do not modify manually. */
export interface paths {
    "/bff/auth/login": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["Login"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/auth/logout": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["LogOut"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/auth/getWorkspaceTenantConsentRequestToken": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetWorkspaceTenantConsentRequestToken"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/auth/getWorkspaceTenantReconsentRequestToken": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetWorkspaceTenantReconsentRequestToken"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/auth/getWorkspaceConsentStatus": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetWorkspaceConsentStatus"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/automations/{automationId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["Get"];
        put: operations["Update"];
        post?: never;
        delete: operations["Delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/automations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["Create"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/automations/{automationId}/toggle": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["Toggle"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/remediation/bulk/odata/plan": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["ODataPlan"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/remediation/bulk/sharePointEntities/plan": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["SharePointEntityPlan"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/remediation/bulk/{bulkId}/start": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["Start"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/remediation/bulk/{bulkId}/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetSummary"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/remediation/bulk/{bulkId}/items": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["GetBulkItems"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/remediation/bulk": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetAllSummaries"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/remediation/bulk/search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["SearchBulkOperations"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/remediation/bulk/{bulkId}/dismiss": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["Dismiss"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/remediation/bulk/checkArchivingEnabled": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["CheckArchivingEnabled"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/remediation/consent/getStatus": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetStatus"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/consent-requests/pending": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetConsentRequestStatus"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/consent-requests": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["SendConsentRequest"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/getCrawlingStatusesV2": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetCrawlingStatusesV2"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/remediation/groups/updateVisibility": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["UpdateGroupVisibility"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/remediation/groups/addOwner": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["AddGroupOwner"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/remediation/groups/removeOwner": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["RemoveGroupOwner"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/initial-crawl-overview": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetInitialCrawlOverview"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/insights/categories": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetInsightCategories"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/insights/categoriesOverview": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetInsightCategoriesOverview"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/insights/insight/{insightTemplateKey}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetInsightV2"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/governance/overview/getTenantOverview": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetTenantOverviewV2"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/licenses": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetLicenses"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/activityLogs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataActivityLogs"];
        put?: never;
        post: operations["ExportODataActivityLogs"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/archivedSiteCollections": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataArchivedSiteCollections"];
        put?: never;
        post: operations["ExportODataArchivedSiteCollections"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/archivedSiteCollections/$query": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["QueryODataArchivedSiteCollections"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/automations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataAutomations"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/brokenInheritanceEntities": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataBrokenInheritanceEntities"];
        put?: never;
        post: operations["ExportODataBrokenInheritanceEntities"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/bulkOperations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataBulkOperations"];
        put?: never;
        post: operations["ExportODataBulkOperations"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/customReports": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataCustomReports"];
        put?: never;
        post: operations["CreateCustomReport"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/customReports/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataCustomReport"];
        put: operations["UpdateCustomReport"];
        post?: never;
        delete: operations["DeleteCustomReport"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/documentLibraries": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataDocumentLibraries"];
        put?: never;
        post: operations["ExportODataDocumentLibraries"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/documentLibraries/$query": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["QueryODataDocumentLibraries"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/doNotDisturbUsers": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataDoNotDisturbUsers"];
        put?: never;
        post: operations["ExportODataDoNotDisturbUsers"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/doNotDisturbWorkspaces": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataDoNotDisturbWorkspaces"];
        put?: never;
        post: operations["ExportODataDoNotDisturbWorkspaces"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/groupPrincipals": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataGroupPrincipals"];
        put?: never;
        post: operations["ExportODataGroupPrincipals"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/groupPrincipals/$query": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["QueryODataGroupPrincipals"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/groups": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataGroups"];
        put?: never;
        post: operations["ExportODataGroups"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/groups/$query": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["QueryODataGroups"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/licenses": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataLicenses"];
        put?: never;
        post: operations["ExportODataLicenses"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/metadata": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataMetadata"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/oneDrives": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataOneDrives"];
        put?: never;
        post: operations["ExportODataOneDrives"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/oneDrives/$query": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["QueryODataOneDrives"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/reportShares": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataReportShares"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/reportShares/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataReportShare"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/reviewAnswerFiles": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataReviewAnswerFiles"];
        put?: never;
        post: operations["ExportODataReviewAnswerFiles"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/reviewAnswerMembership": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataReviewAnswerMembership"];
        put?: never;
        post: operations["ExportODataReviewAnswerMembership"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/reviewAnswerSharedLinkRecipients": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataReviewAnswerSharedLinkRecipients"];
        put?: never;
        post: operations["ExportODataReviewAnswerSharedLinkRecipients"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/reviewAnswerSharedLinks": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataReviewAnswerSharedLinks"];
        put?: never;
        post: operations["ExportODataReviewAnswerSharedLinks"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/reviewItems": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataReviewItems"];
        put?: never;
        post: operations["ExportODataReviewItems"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/reviewNotificationRecipients": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Returns the distinct users that will be notified when a review is activated, each annotated with
         *     the number of the review's workspaces they own and their UPN. Scope to a review with
         *     `$filter=reviewId eq {guid}`; supports $filter/$search/$orderby/$top/$skip/$count (search
         *     matches Name or UPN). Backed by a cross-schema database view, so it all runs in one query.
         */
        get: operations["GetODataReviewNotificationRecipients"];
        put?: never;
        post: operations["ExportODataReviewNotificationRecipients"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/reviewReviewers": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataReviewReviewers"];
        put?: never;
        post: operations["ExportODataReviewReviewers"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/reviews": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataReviews"];
        put?: never;
        post: operations["ExportODataReviews"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/reviewSelectedWorkspaces": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataReviewSelectedWorkspaces"];
        put?: never;
        post: operations["ExportODataReviewSelectedWorkspaces"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/securityGroups": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataSecurityGroups"];
        put?: never;
        post: operations["ExportODataSecurityGroups"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/sensitivityLabels": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataSensitivityLabels"];
        put?: never;
        post: operations["ExportODataSensitivityLabels"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/sharedLinkInvitations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataSharedLinkInvitations"];
        put?: never;
        post: operations["ExportODataSharedLinkInvitations"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/sharedLinks": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataSharedLinks"];
        put?: never;
        post: operations["ExportODataSharedLinks"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/sharedLinks/$query": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["QueryODataSharedLinks"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/siteCollections": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataSiteCollections"];
        put?: never;
        post: operations["ExportODataSiteCollections"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/siteCollections/$query": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["QueryODataSiteCollections"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/tenantSettings": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataTenantSettings"];
        put?: never;
        post: operations["ExportODataTenantSettings"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/userLicenses": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataUserLicenses"];
        put?: never;
        post: operations["ExportODataUserLicenses"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/userLicenses/$query": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["QueryODataUserLicenses"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/users": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataUsers"];
        put?: never;
        post: operations["ExportODataUsers"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/users/$query": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["QueryODataUsers"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/workspaces": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetODataWorkspaces"];
        put?: never;
        post: operations["ExportODataWorkspaces"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/odata/workspaces/$query": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["QueryODataWorkspaces"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/onboarding/trial-reason": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["SubmitTrialReason"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/overview/remediationMetrics": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetRemediationImpactOverview"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/permissions/getSharePointHierarchy": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetSharePointHierarchy"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/permissions/getChildrenEntities": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetChildrenOfSharePointEntity"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/permissions/getChildrenPermissions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetChildrenPermissions"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/permissions/getPrincipalAccessibleSiteCollections": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * The site collections the principal can reach.
         * @description A site collection is listed when the principal has an assignment on its root or on anything below it. Site
         *     collections are ordered by siteCollectionId, not by name.
         */
        get: operations["GetPrincipalAccessibleSiteCollections"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/permissions/getPrincipalAccessibleChildren": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * The entities directly under a parent entity, filtered to what the principal can reach.
         * @description Mirrors getChildrenEntities, scoped to one principal: children are filtered to the branches that contain
         *     something the principal reaches.
         */
        get: operations["GetPrincipalAccessibleChildren"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/permissions/getPrincipalMembershipPaths": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * The membership paths from a principal up to a granting node.
         * @description Explains an access: every chain of group memberships that puts the principal in the granting node, shortest
         *     first. A principal holding the grant on its own node has one path of one node; no path at all returns an empty
         *     page.
         */
        get: operations["GetPrincipalMembershipPaths"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/permissions/getPrincipalSiteCollectionAdminPaths": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * The membership paths from a principal up to the admins of a site collection.
         * @description Explains a site collection admin access: every chain of group memberships that puts the principal in any of the
         *     site's admins, shortest first. A path ends at an admin node, and may pass through another admin on its way. A
         *     principal that is itself an admin has one path of one node; a principal that is not an admin gets an empty page.
         */
        get: operations["GetPrincipalSiteCollectionAdminPaths"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/pricing": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetPricing"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/remediation/recommendations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetAll"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/remediation/recommendations/{id}/actions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["PerformAction"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/remediation/recommendations/goal-summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["GenerateGoalSummary"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/remediation/recommendations/org-context": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * What this workspace resolves to. An unseeded workspace is a 200 with `source: "none"` and the
         *     workspace id it looked up, not a 404: the UI has to be able to say which workspace it asked about,
         *     and a 404 reads as a broken endpoint.
         */
        get: operations["GetOrgContext"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/remediation/recommendations/correlated-context": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Measures the sheet on the fly through the same provider a run uses, so what this returns is what a
         *     run started right now would be given. Nothing is stored, so it costs what the run's own context
         *     costs and can take seconds.
         */
        get: operations["GetCorrelatedContext"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/remediation/recommendations/run": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["StartRun"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/reports/generate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["GenerateReport"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/report-shares": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["CreateReportShare"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/report-shares/{shareId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete: operations["DeleteReportShare"];
        options?: never;
        head?: never;
        patch: operations["UpdateReportShare"];
        trace?: never;
    };
    "/bff/report-shares/{shareId}/revoke": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["RevokeReportShare"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/reviews/{reviewId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetReview"];
        put?: never;
        post?: never;
        delete: operations["DeleteReview"];
        options?: never;
        head?: never;
        patch: operations["PatchReview"];
        trace?: never;
    };
    "/bff/reviews/{reviewId}/materializationState": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetReviewMaterializationState"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/reviews/{reviewId}/activationState": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetReviewActivationState"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/reviews/{reviewId}/items/{reviewItemId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetReviewItemDetails"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/reviews": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["CreateDraftReview"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/reviews/getAffectedWorkspaces": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["GetAffectedWorkspaces"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/reviews/{reviewId}/activate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["ActivateReview"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/reviews/{reviewId}/close": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["CloseReview"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/reviews/{reviewId}/items": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["AddReviewItems"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/reviews/{reviewId}/items/remove": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["RemoveReviewItems"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/reviews/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetReviewsSummary"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/reviews/{reviewId}/typeCounts": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetReviewTypeCounts"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/reviews/doNotDisturbUsers": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["AddDoNotDisturbUsers"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/reviews/doNotDisturbWorkspaces/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete: operations["RemoveDoNotDisturbWorkspace"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/reviews/doNotDisturbWorkspaces": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["AddDoNotDisturbWorkspaces"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/reviews/doNotDisturbUsers/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete: operations["RemoveDoNotDisturbUser"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/reviews/doNotDisturbSummary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetDoNotDisturbSummary"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/reviews/resendNotification": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["ResendNotification"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/reviews/sendTestEmail": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["SendTestEmail"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/sensitivity-labels/search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["SearchSensitivityLabels"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/sensitivity-labels/export": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["ExportSensitivityLabels"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/session": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetSession"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/setup/primary-tenant-info": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetPrimaryTenantInfo"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/remediation/sites/deleteSite": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["DeleteSite"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/insights/insight/{insightTemplateKey}/recommendations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetByInsight"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/subscription/protect-profile": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetProtectProfile"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/subscription/protect-profile/region": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["SetRegion"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/subscription/workspaces": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetWorkspaces"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/telemetry/track-event": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["TrackTelemetryEvents"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/telemetry/track-single-event": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["TrackSingleTelemetryEvent"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/tenant/getInfo": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetTenantInfo"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/tenant-assessment/getOverview": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetOverview"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/trials/start/{productIdentifier}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["StartProductTrial"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/user/batch": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetUsersBatch"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/workspace-tenant-consent-request": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetTenantConsentRequest"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/bff/workspace-tenant-reconsent-request": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["GetWorkspaceTenantReconsentRequest"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        /**
         * @description One grant that gives the reported principal access to an entity, discriminated by grantedTo: a principal (the
         *     reported principal's own node, or a group it is a transitive member of) or a shared link.
         */
        AccessDto: {
            grantedTo: string;
        } & (components["schemas"]["PrincipalAccessDto"] | components["schemas"]["SharedLinkAccessDto"]);
        /** @description The fields every grant carries, whatever it was granted to. */
        AccessGrantDto: {
            /**
             * Format: int64
             * @description The permission node holding the assignment.
             */
            nodeId: number;
            /** @description The permission levels this node grants, deduplicated. */
            permissionLevels: components["schemas"]["PermissionLevel"][];
        };
        /** @enum {string} */
        AccessLevel: "unknown" | "none" | "read" | "limited" | "fullControl" | "contribute" | "viewOnly" | "design" | "custom";
        AccessSettings: {
            defaultAccessSettingsType: components["schemas"]["DefaultAccessSettingsType"];
            defaultAccessSettingsAppliedTo: components["schemas"]["DefaultAccessSettingsAppliedTo"];
            defaultAccessSettingsStatus: components["schemas"]["DefaultAccessSettingsStatus"];
        };
        /** @description A SharePoint entity the principal reaches, or one on the path to something the principal reaches. */
        AccessibleEntityDto: {
            /**
             * Format: int64
             * @description The entity id. Pass it as parentEntityId to getPrincipalAccessibleChildren to drill into this entity.
             */
            id: number;
            type: components["schemas"]["SharePointEntityType"];
            displayName: string;
            url: string;
            /** Format: uuid */
            siteCollectionId: string;
            /**
             * @description The resource types of the site collection, the same values as the site collections OData types: a site can have
             *     several, such as a Teams site that is also a group. Set on site collection rows only, and empty when the site
             *     collection is not crawled; children belong to the site collection of the row they were drilled from.
             */
            siteCollectionTypes?: components["schemas"]["ODataResourceType"][] | null;
            siteCollectionKind?: components["schemas"]["SiteCollectionKind"];
            /** @description True when the entity has its own permissions instead of inheriting its parent's. */
            hasBrokenInheritance: boolean;
            /**
             * @description The grants that give the principal access to this entity, one per granting node and kind of grant: a node that is
             *     both a site collection admin and explicitly assigned carries one of each, the admin grant first. Empty when the
             *     principal cannot reach this entity itself but reaches at least one descendant: the row is a drill-down target on
             *     the path to an accessible descendant, not an accessible entity.
             */
            accesses: (components["schemas"]["PrincipalAccessDto"] | components["schemas"]["SharedLinkAccessDto"])[];
            /**
             * Format: int32
             * @description How many descendants of this entity the principal reaches, capped at 100 by default. A site collection admin
             *     reaches every descendant.
             */
            accessibleDescendantCount: number;
            /** @description True when the real number of reachable descendants exceeds the cap on accessibleDescendantCount. */
            hasMoreAccessibleDescendants: boolean;
        };
        AccessibleEntityDtoPaginated: {
            data: components["schemas"]["AccessibleEntityDto"][];
            pagination: components["schemas"]["PaginationInfo"];
        };
        ActivityLogPayload: {
            $type: string;
        } & (components["schemas"]["ArchivedSiteDeletedPayload"] | components["schemas"]["GroupDeletedPayload"] | components["schemas"]["GroupGuestRemovedPayload"] | components["schemas"]["GroupMemberAddedPayload"] | components["schemas"]["GroupMemberRemovedPayload"] | components["schemas"]["GroupOwnerAddedPayload"] | components["schemas"]["GroupOwnerRemovedPayload"] | components["schemas"]["GroupVisibilityUpdatedPayload"] | components["schemas"]["SharingLinkDeletedPayload"] | components["schemas"]["SiteArchivedPayload"] | components["schemas"]["SiteDeletedPayload"] | components["schemas"]["UserLicenseUnassignedPayload"] | components["schemas"]["EveryoneExceptExternalUsersPermissionRemovedPayload"] | components["schemas"]["SiteSharingCapabilityUpdatedPayload"] | components["schemas"]["SiteFileVersionsTrimmedPayload"] | components["schemas"]["SiteFileVersionPolicyUpdatedPayload"] | components["schemas"]["TenantFileVersionPolicyUpdatedPayload"] | components["schemas"]["PrincipalRemovedFromSPGroupPayload"] | components["schemas"]["DocumentLibraryFileVersionPolicyUpdatedPayload"] | components["schemas"]["DirectPermissionRemovedPayload"] | components["schemas"]["DocumentLibraryFileVersionsTrimmedPayload"] | components["schemas"]["SiteCollectionAdminRemovedPayload"] | components["schemas"]["ReportShareCreatedPayload"] | components["schemas"]["FileArchivedPayload"] | components["schemas"]["FileDeletedPayload"] | components["schemas"]["SharingLinkRecipientRemovedPayload"] | components["schemas"]["ReportShareRecipientsAddedPayload"] | components["schemas"]["ReportShareRecipientsRemovedPayload"] | components["schemas"]["ReportShareRevokedPayload"] | components["schemas"]["ReportShareExpiryChangedPayload"] | components["schemas"]["ReportShareRenamedPayload"] | components["schemas"]["ReportShareDeletedPayload"]);
        AddDoNotDisturbUsersRequest: {
            users: string[];
        };
        AddDoNotDisturbUsersResponse: {
            added: string[];
        };
        AddDoNotDisturbWorkspacesRequest: {
            workspaces: string[];
        };
        AddDoNotDisturbWorkspacesResponse: {
            added: string[];
        };
        AddGroupOwnerRequest: {
            groupId: string;
            ownerId: string;
        };
        AddGroupUsersParameters: {
            addOwnersIds: string[];
            addMembersIds: string[];
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "AddGroupUsersParameters";
        };
        AddMemberToGroupOwnersSelectionParameters: components["schemas"]["GroupUserSelectionParameters"] & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "AddMemberToGroupOwnersSelectionParameters";
        };
        AddOwnerToGroupMembersSelectionParameters: components["schemas"]["GroupUserSelectionParameters"] & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "AddOwnerToGroupMembersSelectionParameters";
        };
        AddReviewItemsRequest: {
            workspaces: components["schemas"]["EntitySelection"];
        };
        /** @enum {string} */
        AllowInvitesFrom: "none" | "adminsAndGuestInviters" | "adminsGuestInvitersAndAllMembers" | "everyone" | "unknownFutureValue";
        /** @enum {string} */
        AnonymousLinkType: "none" | "view" | "edit" | "viewUpload";
        /** @enum {string} */
        AnyoneFolderLinkType: "none" | "view" | "viewEditUpload" | "viewUpload";
        ArchiveSiteMetadata: {
            /** Format: int64 */
            totalContentSizeInBytes: number;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "ArchiveSiteMetadata";
        };
        ArchivedSiteDeletedPayload: {
            siteId: string;
            displayName: string;
            webUrl: string;
            types: components["schemas"]["ResourceType"][];
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "ArchivedSiteDeletedPayload";
        };
        ArchivingEnabledResponse: {
            isEnabled: boolean;
            errorCode?: string | null;
        };
        /** @enum {string} */
        AuthorizationFailureReasons: "unknown" | "notConsented" | "missingShareGateLicense" | "invalidMsalToken" | "missingMsalUserRole" | "invalidGoogleToken" | "invalidGoogleAccessStatus" | "missingMsalAdminRole" | "invalidSgWorkspace" | "noSgWorkspaceProductAccess" | "missingRemediationAddOn" | "invalidSgTenant" | "notWorkspaceAdmin" | "noMigrationProjectsEntitlement" | "noMigrationProjectsSubscription" | "notAPartner" | "missingPartnerCreationAddOn";
        AutomationAction: {
            actionType: components["schemas"]["AutomationActionType"];
            actionParameter?: (components["schemas"]["RemoveEeeuActionParameter"] | components["schemas"]["TrimSiteFileVersionsActionParameter"] | components["schemas"]["UpdateSiteFileVersionPolicyActionParameter"]) | null;
        };
        AutomationActionParameter: {
            $type: string;
        } & (components["schemas"]["RemoveEeeuActionParameter"] | components["schemas"]["TrimSiteFileVersionsActionParameter"] | components["schemas"]["UpdateSiteFileVersionPolicyActionParameter"]);
        /** @enum {string} */
        AutomationActionType: "deleteSharingLink" | "deleteSite" | "archiveSite" | "removeEveryoneExceptExternalUsersPermission" | "trimSiteFileVersions" | "updateSiteFileVersionPolicy";
        BooleanDataPoint: {
            value: boolean;
            status: components["schemas"]["DataPointStatus"];
        };
        BooleanNullableDataPoint: {
            value?: boolean | null;
            status: components["schemas"]["DataPointStatus"];
        };
        BrokenInheritanceStats: {
            /** Format: int64 */
            sitesWithBrokenEntitiesCount: number;
            /** Format: int64 */
            totalSitesCount: number;
            /** Format: int64 */
            totalBrokenEntityCount: number;
            /** Format: int64 */
            brokenSubsiteCount: number;
            /** Format: int64 */
            brokenDocumentLibraryCount: number;
            /** Format: int64 */
            brokenListCount: number;
        };
        BrokenInheritanceStatsDataPoint: {
            value?: components["schemas"]["BrokenInheritanceStats"];
            status: components["schemas"]["DataPointStatus"];
        };
        /** @enum {string} */
        BulkAction: "deleteSharingLink" | "addGroupOwner" | "removeGroupOwner" | "manageGroupOwners" | "deleteGroup" | "removeGroupGuest" | "updateGroupVisibility" | "deleteSite" | "archiveSite" | "deleteArchivedSite" | "unassignUserLicense" | "removeEveryoneExceptExternalUsersPermission" | "updateSiteSharingCapability" | "trimSiteFileVersions" | "updateSiteFileVersionPolicy" | "updateTenantFileVersionPolicy" | "addGroupMember" | "manageGroupUsers" | "removeGroupMember" | "removeDirectPermission" | "removePrincipalFromSPGroup" | "updateDocumentLibraryFileVersionPolicy" | "addGroupUsers" | "trimDocumentLibraryFileVersions" | "removeSiteCollectionAdmin" | "archiveFile" | "deleteFile" | "removeSharingLinkRecipient";
        BulkActionDetails: {
            action: components["schemas"]["BulkAction"];
            entitySet: components["schemas"]["EntitySet"];
            filter: string;
            actionParameters?: (components["schemas"]["ManageGroupOwnersParameters"] | components["schemas"]["AddGroupUsersParameters"] | components["schemas"]["AddMemberToGroupOwnersSelectionParameters"] | components["schemas"]["AddOwnerToGroupMembersSelectionParameters"] | components["schemas"]["RemoveGroupUsersSelectionParameters"] | components["schemas"]["RemoveGroupMembersSelectionParameters"] | components["schemas"]["RemoveGroupOwnersSelectionParameters"] | components["schemas"]["OneGroupOwnerParameter"] | components["schemas"]["OneGroupMemberParameter"] | components["schemas"]["GroupVisibilityParameter"] | components["schemas"]["RemoveGroupGuestParameter"] | components["schemas"]["OneGroupGuestParameter"] | components["schemas"]["SharingCapabilityParameter"] | components["schemas"]["RemoveEeeuOptions"] | components["schemas"]["TrimSiteFileVersionsParameters"] | components["schemas"]["UpdateSiteFileVersionPolicyParameters"] | components["schemas"]["UpdateTenantFileVersionPolicyParameters"] | components["schemas"]["RemovePrincipalFromSPGroupParameter"] | components["schemas"]["UpdateDocumentLibraryFileVersionPolicyParameters"] | components["schemas"]["TrimDocumentLibraryFileVersionsParameters"] | components["schemas"]["RemoveSharingLinkRecipientsParameter"] | components["schemas"]["RemoveSharingLinkRecipientNodesParameter"]) | null;
        };
        BulkActionParameters: {
            $type: string;
        } & (components["schemas"]["ManageGroupOwnersParameters"] | components["schemas"]["AddGroupUsersParameters"] | components["schemas"]["AddMemberToGroupOwnersSelectionParameters"] | components["schemas"]["AddOwnerToGroupMembersSelectionParameters"] | components["schemas"]["RemoveGroupUsersSelectionParameters"] | components["schemas"]["RemoveGroupMembersSelectionParameters"] | components["schemas"]["RemoveGroupOwnersSelectionParameters"] | components["schemas"]["OneGroupOwnerParameter"] | components["schemas"]["OneGroupMemberParameter"] | components["schemas"]["GroupVisibilityParameter"] | components["schemas"]["RemoveGroupGuestParameter"] | components["schemas"]["OneGroupGuestParameter"] | components["schemas"]["SharingCapabilityParameter"] | components["schemas"]["RemoveEeeuOptions"] | components["schemas"]["TrimSiteFileVersionsParameters"] | components["schemas"]["UpdateSiteFileVersionPolicyParameters"] | components["schemas"]["UpdateTenantFileVersionPolicyParameters"] | components["schemas"]["RemovePrincipalFromSPGroupParameter"] | components["schemas"]["UpdateDocumentLibraryFileVersionPolicyParameters"] | components["schemas"]["TrimDocumentLibraryFileVersionsParameters"] | components["schemas"]["RemoveSharingLinkRecipientsParameter"] | components["schemas"]["RemoveSharingLinkRecipientNodesParameter"]);
        BulkCountSummary: {
            bulkId: string;
            action: components["schemas"]["BulkAction"];
            status: components["schemas"]["BulkOperationStatus"];
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            endedAt?: string | null;
            itemCounts: components["schemas"]["BulkItemStatusCounts"];
        };
        BulkItemDto: {
            /** Format: int64 */
            itemId: number;
            status: components["schemas"]["BulkItemStatus"];
            errorDetails?: string | null;
            action: components["schemas"]["BulkAction"];
            workspaceType: components["schemas"]["BulkItemType"];
            workspaceDisplayName: string;
            itemInfo: components["schemas"]["DirectPermissionItemInfo"] | components["schemas"]["GroupItemInfo"] | components["schemas"]["LibraryItemInfo"] | components["schemas"]["SharedLinkItemInfo"] | components["schemas"]["SiteItemInfo"] | components["schemas"]["TenantSettingsItemInfo"] | components["schemas"]["UserItemInfo"] | components["schemas"]["UserLicenseItemInfo"] | components["schemas"]["SPGroupMemberItemInfo"] | components["schemas"]["SiteCollectionAdminItemInfo"] | components["schemas"]["FileItemInfo"] | components["schemas"]["SharingLinkRecipientItemInfo"];
        };
        BulkItemDtoPaginated: {
            data: components["schemas"]["BulkItemDto"][];
            pagination: components["schemas"]["PaginationInfo"];
        };
        /** @enum {string} */
        BulkItemSortableFields: "none" | "status" | "workspaceType";
        BulkItemSortableFieldsSortOrder: {
            field: components["schemas"]["BulkItemSortableFields"];
            direction: components["schemas"]["SortDirection"];
        };
        /** @enum {string} */
        BulkItemStatus: "planned" | "success" | "failure" | "waitingOnCrawlerResponse" | "attempted" | "waitingOnSpoJob";
        BulkItemStatusCounts: {
            /** Format: int32 */
            total: number;
            /** Format: int32 */
            succeeded: number;
            /** Format: int32 */
            failed: number;
        };
        /** @enum {string} */
        BulkItemType: "user" | "group" | "site" | "sharedLink" | "oneDrive" | "team" | "teamsChannel" | "archivedSite" | "userLicense" | "tenantSettings" | "documentLibrary" | "permission" | "spGroup" | "file" | "sharingLinkRecipient";
        BulkOperationDto: {
            bulkId: string;
            status: components["schemas"]["BulkOperationStatus"];
            action: components["schemas"]["BulkAction"];
            actionParameters?: (components["schemas"]["ManageGroupOwnersParameters"] | components["schemas"]["AddGroupUsersParameters"] | components["schemas"]["AddMemberToGroupOwnersSelectionParameters"] | components["schemas"]["AddOwnerToGroupMembersSelectionParameters"] | components["schemas"]["RemoveGroupUsersSelectionParameters"] | components["schemas"]["RemoveGroupMembersSelectionParameters"] | components["schemas"]["RemoveGroupOwnersSelectionParameters"] | components["schemas"]["OneGroupOwnerParameter"] | components["schemas"]["OneGroupMemberParameter"] | components["schemas"]["GroupVisibilityParameter"] | components["schemas"]["RemoveGroupGuestParameter"] | components["schemas"]["OneGroupGuestParameter"] | components["schemas"]["SharingCapabilityParameter"] | components["schemas"]["RemoveEeeuOptions"] | components["schemas"]["TrimSiteFileVersionsParameters"] | components["schemas"]["UpdateSiteFileVersionPolicyParameters"] | components["schemas"]["UpdateTenantFileVersionPolicyParameters"] | components["schemas"]["RemovePrincipalFromSPGroupParameter"] | components["schemas"]["UpdateDocumentLibraryFileVersionPolicyParameters"] | components["schemas"]["TrimDocumentLibraryFileVersionsParameters"] | components["schemas"]["RemoveSharingLinkRecipientsParameter"] | components["schemas"]["RemoveSharingLinkRecipientNodesParameter"]) | null;
        };
        BulkOperationMetadata: {
            $type: string;
        } & (components["schemas"]["ArchiveSiteMetadata"] | components["schemas"]["RemoveEeeuMetadata"]);
        /** @enum {string} */
        BulkOperationStatus: "planned" | "inProgress" | "success" | "failure" | "partialFailure" | "skipped";
        BulkOperationSummary: {
            bulkId: string;
            action: components["schemas"]["BulkAction"];
            status: components["schemas"]["BulkOperationStatus"];
            itemSummaries: components["schemas"]["ItemSummary"][];
            metadata?: (components["schemas"]["ArchiveSiteMetadata"] | components["schemas"]["RemoveEeeuMetadata"]) | null;
            actionParameters?: (components["schemas"]["ManageGroupOwnersParameters"] | components["schemas"]["AddGroupUsersParameters"] | components["schemas"]["AddMemberToGroupOwnersSelectionParameters"] | components["schemas"]["AddOwnerToGroupMembersSelectionParameters"] | components["schemas"]["RemoveGroupUsersSelectionParameters"] | components["schemas"]["RemoveGroupMembersSelectionParameters"] | components["schemas"]["RemoveGroupOwnersSelectionParameters"] | components["schemas"]["OneGroupOwnerParameter"] | components["schemas"]["OneGroupMemberParameter"] | components["schemas"]["GroupVisibilityParameter"] | components["schemas"]["RemoveGroupGuestParameter"] | components["schemas"]["OneGroupGuestParameter"] | components["schemas"]["SharingCapabilityParameter"] | components["schemas"]["RemoveEeeuOptions"] | components["schemas"]["TrimSiteFileVersionsParameters"] | components["schemas"]["UpdateSiteFileVersionPolicyParameters"] | components["schemas"]["UpdateTenantFileVersionPolicyParameters"] | components["schemas"]["RemovePrincipalFromSPGroupParameter"] | components["schemas"]["UpdateDocumentLibraryFileVersionPolicyParameters"] | components["schemas"]["TrimDocumentLibraryFileVersionsParameters"] | components["schemas"]["RemoveSharingLinkRecipientsParameter"] | components["schemas"]["RemoveSharingLinkRecipientNodesParameter"]) | null;
            /** Format: int32 */
            totalAffectedCount: number;
            /** Format: int32 */
            totalSkippedCount: number;
            /** Format: int32 */
            totalItemsCount?: number | null;
        };
        /** @enum {string} */
        CapabilityStatus: "unknown" | "enabled" | "warning" | "suspended" | "deleted" | "lockedOut";
        CategoriesOverviewResponse: {
            categories: components["schemas"]["CategoryOverview"][];
            isStale: boolean;
        };
        CategoryOverview: {
            templateKey: components["schemas"]["CategoryV2TemplateKey"];
            categoryMetric?: components["schemas"]["CategoryOverviewMetric"];
            insights: components["schemas"]["InsightV2"][];
            isStale: boolean;
        };
        CategoryOverviewMetric: {
            /** Format: double */
            value: number;
        };
        /** @enum {string} */
        CategoryV2TemplateKey: "preventOversharing" | "reduceCosts" | "controlSprawl" | "improveCopilotResults";
        ChartData: {
            $type: string;
        } & (components["schemas"]["LicenseChartData"] | components["schemas"]["WorkspaceVersionStorageChartData"]);
        /** @enum {string} */
        ConsentOrigin: "governance" | "migrateAssessment";
        ConsentRequestResponse: {
            consentUrl: string;
        };
        ConsentRequestStatusResponse: {
            isPending: boolean;
            adminEmail?: string | null;
        };
        ConsentStatus: {
            isConsented: boolean;
            missingPermissions: string[];
        };
        /** @enum {string} */
        ContentFormat: "unknown" | "file" | "email" | "site" | "unifiedGroup" | "teamwork" | "notAvailable";
        ContentStats: {
            tenantStorage: components["schemas"]["Int64DataPoint"];
            contentSizePerType: components["schemas"]["WorkspaceContentSizeListDataPoint"];
            storageQuota: components["schemas"]["Int64DataPoint"];
            oneDriveStorageQuota: components["schemas"]["Int64DataPoint"];
        };
        /** @enum {string} */
        ContentWorkspaceType: "sharePointSite" | "group" | "teams" | "oneDrive";
        CorrelatedContextEnvelope: {
            /** Format: date-time */
            generatedAt?: string | null;
            source: string;
            note?: string | null;
            contextJson?: string | null;
        };
        /** @enum {string} */
        CrawlState: "initializing" | "upToDate" | "pendingDeletion";
        /** @enum {string} */
        CrawlerNames: "archivedSiteCollections" | "groups" | "permissions" | "permissionsEnrichment" | "securityGroups" | "sensitivityLabels" | "siteActivity" | "siteSettings" | "tenantLicenses" | "tenantSettings" | "users" | "sharePointGroups";
        CrawlingStatus: {
            crawlState: components["schemas"]["CrawlState"];
            /** Format: date-time */
            crawlEndTime?: string | null;
        };
        CreateAutomationRequest: {
            name: string;
            insightTemplateKey?: components["schemas"]["InsightV2TemplateKey"];
            entitySet?: components["schemas"]["ODataEntitySet"];
            filter?: string | null;
            action: components["schemas"]["AutomationAction"];
            isEnabled: boolean;
        };
        CreateCustomReportRequest: {
            title: string;
            entitySet: components["schemas"]["ODataEntitySet"];
            properties: string[];
            filter?: string | null;
            orderBy?: string | null;
            source: components["schemas"]["ODataCustomReportSource"];
        };
        CreateDraftReviewRequest: {
            title: string;
            customMessage?: string | null;
            reviewTypes: components["schemas"]["ODataReviewType"][];
            /** Format: int32 */
            expireDays: number;
            workspaces: components["schemas"]["EntitySelection"];
            settings?: components["schemas"]["ReviewSettingsRequest"];
        };
        CreateReportShareRequest: {
            name: string;
            report?: components["schemas"]["ReportShareKind"];
            scope: components["schemas"]["ReportShareSelection"];
            recipientIds: string[];
            /** Format: date-time */
            expiresAt: string;
            message?: string | null;
            emailRecipients: boolean;
            timeZone?: string | null;
        };
        CrossTenantAccessSettings: {
            /** Format: int32 */
            numberOfOrganizations: number;
            tenantConfigurations?: components["schemas"]["TenantAccessSettings"][] | null;
        };
        CrossTenantAccessSettingsDataPoint: {
            value?: components["schemas"]["CrossTenantAccessSettings"];
            status: components["schemas"]["DataPointStatus"];
        };
        /** @enum {string} */
        Currency: "usd";
        /** @enum {string} */
        DataPointStatus: "notInitialized" | "completed" | "failed";
        DefaultAccessSettings: {
            inboundAccessSettings: components["schemas"]["AccessSettings"][];
        };
        /** @enum {string} */
        DefaultAccessSettingsAppliedTo: "externalUsersAndGroups" | "applications" | "notAvailable";
        DefaultAccessSettingsDataPoint: {
            value?: components["schemas"]["DefaultAccessSettings"];
            status: components["schemas"]["DataPointStatus"];
        };
        /** @enum {string} */
        DefaultAccessSettingsStatus: "allAllowed" | "someAllowed" | "someBlocked" | "allBlocked" | "disabled" | "enabled";
        /** @enum {string} */
        DefaultAccessSettingsType: "b2bCollaboration" | "b2bDirectConnect" | "trustSettings";
        DeleteSiteRequest: {
            siteId?: string | null;
            /** Format: uuid */
            groupId?: string | null;
        };
        DirectPermissionItemInfo: {
            /** Format: uuid */
            siteCollectionId: string;
            entityType: components["schemas"]["SharePointEntityType"];
            entityDisplayName: string;
            entityUrl: string;
            siteCollectionDisplayName: string;
            siteCollectionTypes?: components["schemas"]["ResourceType"][] | null;
            webUrl: string;
            /** Format: uuid */
            webId?: string | null;
            /** Format: uuid */
            listId?: string | null;
            /** Format: uuid */
            listItemUniqueId?: string | null;
            nodeType: components["schemas"]["PermissionNodeType"];
            nodeDisplayName: string;
            /** Format: uuid */
            entraObjectId?: string | null;
            securityGroupClaimKind?: components["schemas"]["SecurityGroupClaimKind"];
            nonDirectoryObjectLoginName?: string | null;
            externalUserEmail?: string | null;
            /** Format: int32 */
            sharePointGroupUserInfoListId?: number | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "DirectPermissionItemInfo";
        };
        DirectPermissionRemovedPayload: {
            entityType: components["schemas"]["SharePointEntityType"];
            entityDisplayName: string;
            entityUrl: string;
            siteCollectionDisplayName: string;
            siteCollectionTypes?: components["schemas"]["ResourceType"][] | null;
            nodeType: components["schemas"]["PermissionNodeType"];
            nodeDisplayName: string;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "DirectPermissionRemovedPayload";
        };
        /** @enum {string} */
        DisplayFormat: "default" | "filesize" | "sharePointUrl" | "percent";
        DoNotDisturbSummaryResponse: {
            /** Format: int32 */
            users: number;
            /** Format: int32 */
            workspaces: number;
        };
        DocumentLibraryFileVersionPolicyUpdatedPayload: {
            /** Format: uuid */
            listId: string;
            title: string;
            siteCollectionDisplayName: string;
            enableVersioning: boolean;
            enableMinorVersions: boolean;
            enableAutoExpirationVersionTrim: boolean;
            /** Format: int32 */
            majorVersionLimit?: number | null;
            /** Format: int32 */
            majorWithMinorVersionsLimit?: number | null;
            /** Format: int32 */
            expireVersionsAfterDays?: number | null;
            versionLimit: components["schemas"]["VersionLimitPolicy"];
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "DocumentLibraryFileVersionPolicyUpdatedPayload";
        };
        DocumentLibraryFileVersionsTrimmedPayload: {
            /** Format: uuid */
            listId: string;
            title: string;
            siteCollectionDisplayName: string;
            /** Format: int32 */
            targetVersionCount?: number | null;
            /** Format: int32 */
            targetVersionAgeDays?: number | null;
            /** Format: int64 */
            versionsProcessed?: number | null;
            /** Format: int64 */
            versionsDeleted?: number | null;
            /** Format: int64 */
            versionsFailed?: number | null;
            /** Format: int64 */
            storageReleasedInBytes?: number | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "DocumentLibraryFileVersionsTrimmedPayload";
        };
        /** @enum {string} */
        EdmPrimitiveTypeKind: "none" | "binary" | "boolean" | "byte" | "dateTimeOffset" | "decimal" | "double" | "guid" | "int16" | "int32" | "int64" | "sByte" | "single" | "string" | "stream" | "duration" | "geography" | "geographyPoint" | "geographyLineString" | "geographyPolygon" | "geographyCollection" | "geographyMultiPolygon" | "geographyMultiLineString" | "geographyMultiPoint" | "geometry" | "geometryPoint" | "geometryLineString" | "geometryPolygon" | "geometryCollection" | "geometryMultiPolygon" | "geometryMultiLineString" | "geometryMultiPoint" | "date" | "timeOfDay" | "primitiveType";
        /** @enum {string} */
        EdmTypeKind: "none" | "primitive" | "entity" | "complex" | "collection" | "entityReference" | "enum" | "typeDefinition" | "untyped" | "path";
        EncryptedPayload: {
            token: string;
        };
        EntitySelection: {
            query?: string | null;
            includes: string[];
            excludes: string[];
        };
        /** @enum {string} */
        EntitySet: "licenses" | "sensitivityLabels" | "siteCollections" | "groups" | "users" | "sharedLinks" | "securityGroups" | "brokenInheritanceEntities" | "oneDrives" | "workspaces" | "activityLogs" | "sharedLinkInvitations" | "customReports" | "automations" | "archivedSiteCollections" | "userLicenses" | "dynamicGroups" | "reviews" | "reviewItems" | "reviewTasks" | "reviewAnswers" | "doNotDisturbUsers" | "doNotDisturbWorkspaces" | "reviewNotificationRecipients" | "reviewSelectedWorkspaces" | "reviewUsers" | "reviewReviewers" | "reviewAnswerSharedLinks" | "tenantSettings" | "documentLibraries" | "bulkOperations" | "reviewAnswerMembership" | "workspaceReviews" | "groupPrincipals" | "reviewAnswerSharedLinkRecipients" | "reviewAnswerFiles" | "reportShares" | "reportShareRecipients";
        EntitySetEntitySetMetadata: {
            name: components["schemas"]["EntitySet"];
            displayName: string;
            description?: string | null;
            navigationProperties?: components["schemas"]["EntitySetNavigationPropertyMetadata"][] | null;
            properties: components["schemas"]["PropertyMetadata"][];
            defaultProperties?: string[] | null;
            crawledBy: components["schemas"]["CrawlerNames"][];
        };
        EntitySetMetadataModel: {
            entitySets?: components["schemas"]["EntitySetEntitySetMetadata"][] | null;
            enums?: components["schemas"]["EnumMetadata"][] | null;
        };
        EntitySetNavigationPropertyMetadata: {
            name: string;
            entitySet: components["schemas"]["EntitySet"];
            displayName: string;
            description?: string | null;
            multiplicity: components["schemas"]["Multiplicity"];
            filterable: boolean;
            crawledBy: components["schemas"]["CrawlerNames"][];
        };
        EnumMetadata: {
            name: string;
            enumValues?: components["schemas"]["EnumValueMetadata"][] | null;
        };
        EnumValueMetadata: {
            displayName: string;
            value: string;
            filterable: boolean;
        };
        EveryoneExceptExternalUsersPermissionRemovedPayload: {
            siteId: string;
            displayName: string;
            webUrl: string;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "EveryoneExceptExternalUsersPermissionRemovedPayload";
        };
        /** @description The parameters used when exporting data to a CSV file. */
        ExportCsvParameters: {
            /** @description The collection of property names to include as columns in the CSV output in the desired order. */
            properties: string[];
        };
        ExportSensitivityLabelBody: {
            sortOrder?: components["schemas"]["SensitivityLabelSortableFieldsSortOrder"];
        };
        ExternalActionDetails: {
            actionToBeTaken?: string | null;
            proof?: components["schemas"]["ExternalActionProofDto"];
        };
        ExternalActionProofDto: {
            /** Format: date-time */
            completedAt: string;
            note?: string | null;
            reference?: string | null;
        };
        ExternalCollaborationSettings: {
            allowInvitesFrom?: components["schemas"]["AllowInvitesFrom"];
            guestUserRoleId?: components["schemas"]["GuestUserRoleId"];
            isGuestSelfServiceSignUpEnabled?: boolean | null;
            allowExternalIdentitiesToLeave?: boolean | null;
        };
        ExternalCollaborationSettingsDataPoint: {
            value?: components["schemas"]["ExternalCollaborationSettings"];
            status: components["schemas"]["DataPointStatus"];
        };
        ExternalUserPermissionNodeProperties: {
            isGuest: boolean;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "ExternalUserPermissionNodeProperties";
        };
        FileArchivedPayload: {
            driveId: string;
            itemId: string;
            displayName: string;
            folderPath?: string | null;
            createdByDisplayName?: string | null;
            /** Format: int64 */
            size?: number | null;
            /** Format: date-time */
            createdDateTime?: string | null;
            /** Format: date-time */
            lastModifiedDateTime?: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "FileArchivedPayload";
        };
        FileDeletedPayload: {
            driveId: string;
            itemId: string;
            displayName: string;
            folderPath?: string | null;
            createdByDisplayName?: string | null;
            /** Format: int64 */
            size?: number | null;
            /** Format: date-time */
            createdDateTime?: string | null;
            /** Format: date-time */
            lastModifiedDateTime?: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "FileDeletedPayload";
        };
        FileItemInfo: {
            driveId: string;
            itemId: string;
            /** Format: uuid */
            siteCollectionId: string;
            displayName: string;
            folderPath?: string | null;
            createdByDisplayName?: string | null;
            /** Format: int64 */
            size?: number | null;
            /** Format: date-time */
            createdDateTime?: string | null;
            /** Format: date-time */
            lastModifiedDateTime?: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "FileItemInfo";
        };
        GenerateReportErrorResponse: {
            errorCode: string;
            message: string;
        };
        GenerateReportRequest: {
            prompt: string;
        };
        GenerateReportResponse: {
            status: components["schemas"]["ReportGenerationStatus"];
            title: string;
            slug: string;
            entity: components["schemas"]["EntitySet"];
            columns: string[];
            filter: string;
            sortField?: string | null;
            sortOrder?: string | null;
            suggestedNextQueries?: string[] | null;
            promptInvalidSegment?: string | null;
            error?: string | null;
        };
        GetAffectedWorkspacesRequest: {
            workspaces: components["schemas"]["EntitySelection"];
        };
        GetAffectedWorkspacesResponse: {
            /** Format: int32 */
            affectedWorkspaceCount: number;
            excludedByDoNotDisturbWorkspaceIds: string[];
            excludedByDoNotDisturbUsersWorkspaceIds: string[];
            /** @description Workspaces skipped because no owner has an email address to notify. */
            excludedNoEmailableOwnerWorkspaceIds: string[];
        };
        GetBulkItemsParameters: {
            /**
             * Format: int32
             * @default 1
             */
            pageNumber: number;
            /**
             * Format: int32
             * @default 10
             */
            pageSize: number;
            sortOrder?: components["schemas"]["BulkItemSortableFieldsSortOrder"];
            statuses?: components["schemas"]["BulkItemStatus"][] | null;
        };
        GetSgWorkspacesResponse: {
            workspaces: components["schemas"]["SgWorkspace"][];
        };
        GoalSummaryRequest: {
            categoryKey?: components["schemas"]["CategoryV2TemplateKey"];
            includeOrgContext?: boolean | null;
        };
        GoalSummaryResponse: {
            status: components["schemas"]["GoalSummaryStatus"];
            summary?: string | null;
            error?: string | null;
        };
        /** @enum {string} */
        GoalSummaryStatus: "success" | "error";
        GroupDeletedPayload: {
            /** Format: uuid */
            groupId: string;
            displayName: string;
            isTeam: boolean;
            visibility: components["schemas"]["GroupVisibilityStatus"];
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "GroupDeletedPayload";
        };
        GroupExpirationInformation: {
            /** Format: int32 */
            groupLifetimeInDays?: number | null;
            managedGroupTypes?: components["schemas"]["ManagedGroupTypes"];
        };
        GroupExpirationInformationDataPoint: {
            value?: components["schemas"]["GroupExpirationInformation"];
            status: components["schemas"]["DataPointStatus"];
        };
        GroupGuestRemovedPayload: {
            /** Format: uuid */
            groupId: string;
            groupDisplayName: string;
            groupIsTeam: boolean;
            groupVisibility: components["schemas"]["GroupVisibilityStatus"];
            /** Format: uuid */
            guestId: string;
            guestDisplayName: string;
            guestEmail: string;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "GroupGuestRemovedPayload";
        };
        GroupItemInfo: {
            /** Format: uuid */
            id: string;
            displayName: string;
            isTeam: boolean;
            visibility: components["schemas"]["GroupVisibilityStatus"];
            users: components["schemas"]["UserItemInfo"][];
            /** Format: int32 */
            ownersCount: number;
            site?: components["schemas"]["SiteItemInfo"];
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "GroupItemInfo";
        };
        GroupMemberAddedPayload: {
            /** Format: uuid */
            groupId: string;
            groupDisplayName: string;
            groupIsTeam: boolean;
            groupVisibility: components["schemas"]["GroupVisibilityStatus"];
            /** Format: uuid */
            memberId: string;
            memberDisplayName: string;
            memberEmail: string;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "GroupMemberAddedPayload";
        };
        GroupMemberRemovedPayload: {
            /** Format: uuid */
            groupId: string;
            groupDisplayName: string;
            groupIsTeam: boolean;
            groupVisibility: components["schemas"]["GroupVisibilityStatus"];
            /** Format: uuid */
            memberId: string;
            memberDisplayName: string;
            memberEmail: string;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "GroupMemberRemovedPayload";
        };
        GroupOwnerAddedPayload: {
            /** Format: uuid */
            groupId: string;
            groupDisplayName: string;
            groupIsTeam: boolean;
            groupVisibility: components["schemas"]["GroupVisibilityStatus"];
            /** Format: uuid */
            ownerId: string;
            ownerDisplayName: string;
            ownerEmail: string;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "GroupOwnerAddedPayload";
        };
        GroupOwnerRemovedPayload: {
            /** Format: uuid */
            groupId: string;
            groupDisplayName: string;
            groupIsTeam: boolean;
            groupVisibility: components["schemas"]["GroupVisibilityStatus"];
            /** Format: uuid */
            ownerId: string;
            ownerDisplayName: string;
            ownerEmail: string;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "GroupOwnerRemovedPayload";
        };
        GroupStats: {
            teamsCount: components["schemas"]["Int32DataPoint"];
            publicTeamsCount: components["schemas"]["Int32DataPoint"];
            groupsCount: components["schemas"]["Int32DataPoint"];
            publicGroupsCount: components["schemas"]["Int32DataPoint"];
            inactiveGroupsCount: components["schemas"]["Int32DataPoint"];
            securityGroupsCount: components["schemas"]["Int32DataPoint"];
            sharedWithEveryoneExceptExternalUserCount: components["schemas"]["Int32DataPoint"];
            dynamicGroupsCount: components["schemas"]["Int32DataPoint"];
        };
        GroupUserSelectionParameters: {
            query?: string | null;
            includes: string[];
            excludes: string[];
        };
        /** @enum {string} */
        GroupVisibilityOption: "unknown" | "private" | "public";
        GroupVisibilityParameter: {
            visibility: components["schemas"]["GroupVisibilityStatus"];
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "GroupVisibilityParameter";
        };
        /** @enum {string} */
        GroupVisibilityStatus: "unknown" | "public" | "private" | "hiddenMembership";
        GroupVisibilityUpdatedPayload: {
            /** Format: uuid */
            groupId: string;
            displayName: string;
            isTeam: boolean;
            previousVisibility: components["schemas"]["GroupVisibilityStatus"];
            newVisibility: components["schemas"]["GroupVisibilityStatus"];
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "GroupVisibilityUpdatedPayload";
        };
        /** @enum {string} */
        GuestUserRoleId: "user" | "guestUser" | "restrictedGuestUser";
        HttpValidationProblemDetails: {
            type?: string | null;
            title?: string | null;
            /** Format: int32 */
            status?: number | null;
            detail?: string | null;
            instance?: string | null;
            errors: {
                [key: string]: string[];
            };
        } & {
            [key: string]: unknown;
        };
        InitialCrawlOverviewDto: {
            primary?: components["schemas"]["TenantCrawlOverviewDto"];
            migrateAssessments: components["schemas"]["TenantCrawlOverviewDto"][];
        };
        InitiatorDto: {
            sgUserId?: string | null;
            sgUserEmail?: string | null;
            sgUserName?: string | null;
            msUserId?: string | null;
            msUserEmail?: string | null;
            msUserName?: string | null;
            /** Format: uuid */
            automationId?: string | null;
            /** Format: uuid */
            automationVersionId?: string | null;
            source: components["schemas"]["InitiatorSource"];
        };
        /** @enum {string} */
        InitiatorSource: "unknown" | "web" | "automation" | "mcp";
        InsightCategoriesResponse: {
            categories: components["schemas"]["InsightCategorySummary"][];
            isStale: boolean;
        };
        InsightCategorySummary: {
            templateKey: components["schemas"]["CategoryV2TemplateKey"];
            headerData: components["schemas"]["InsightMetric"][];
            insights: components["schemas"]["InsightV2"][];
            isStale: boolean;
        };
        InsightChart: {
            data: components["schemas"]["LicenseChartData"] | components["schemas"]["WorkspaceVersionStorageChartData"];
            entitySet: components["schemas"]["EntitySet"];
            properties: string[];
            filter: string;
            orderBy: string;
        };
        /** @enum {string} */
        InsightDisplayType: "numeric" | "chart" | "graph";
        InsightMetric: {
            templateKey: components["schemas"]["MetricTemplateKey"];
            /** Format: double */
            relativeChange?: number | null;
            /** Format: double */
            value: number;
            measurements: components["schemas"]["Measurement"][];
        };
        InsightV2: {
            templateKey: components["schemas"]["InsightV2TemplateKey"];
            type: components["schemas"]["InsightDisplayType"];
            severity: components["schemas"]["Severity"];
            metrics: components["schemas"]["InsightMetric"][];
            categories: components["schemas"]["CategoryV2TemplateKey"][];
            entitySet: components["schemas"]["EntitySet"];
            properties: string[];
            filter: string;
            orderBy: string;
            chart?: components["schemas"]["InsightChart"] | null;
            /** Format: int32 */
            automationCount: number;
            canHavePolicies: boolean;
            /** Format: double */
            costSavingsPerMonth?: number | null;
            isStale: boolean;
        };
        /** @enum {string} */
        InsightV2TemplateKey: "unknown" | "inactiveLicenses" | "unallocatedLicenses" | "inactiveSites" | "orphanedOneDrives" | "privateGroupsWithEeeuAccess" | "usersWithHighAmountsOfDirectPermissions" | "allWorkspacesWithEeeuAccess" | "siteCollectionObjectsWithBrokenInheritance" | "inactiveWorkspaces" | "inactiveOnedrives" | "externalGuestsWithAccessToLargeNumbersOfWorkspaces" | "documentsSharedUsingPeopleInYourOrgLinks" | "onedriveAccountsWithLargeAmountsOfStorage" | "inactiveCopilotLicenses" | "workspacesWithExcessiveVersionStorage" | "oneDrivesWithHeavyVersionStorage" | "anyoneLinksWithoutExpiration" | "anyoneLinksWithEditAccess" | "specificPeopleLinksWithExternalRecipients" | "expiredSharingLinks" | "sharePointSitesWithNoSensitivityLabel";
        Int32DataPoint: {
            /** Format: int32 */
            value: number;
            status: components["schemas"]["DataPointStatus"];
        };
        Int64DataPoint: {
            /** Format: int64 */
            value: number;
            status: components["schemas"]["DataPointStatus"];
        };
        /** @enum {string} */
        IsEligibleForCopilot: "true" | "false" | "unknown";
        ItemInfo: {
            $type: string;
        } & (components["schemas"]["DirectPermissionItemInfo"] | components["schemas"]["GroupItemInfo"] | components["schemas"]["LibraryItemInfo"] | components["schemas"]["SharedLinkItemInfo"] | components["schemas"]["SiteItemInfo"] | components["schemas"]["TenantSettingsItemInfo"] | components["schemas"]["UserItemInfo"] | components["schemas"]["UserLicenseItemInfo"] | components["schemas"]["SPGroupMemberItemInfo"] | components["schemas"]["SiteCollectionAdminItemInfo"] | components["schemas"]["FileItemInfo"] | components["schemas"]["SharingLinkRecipientItemInfo"]);
        ItemSummary: {
            /** Format: int32 */
            count: number;
            skipped: boolean;
            action: components["schemas"]["BulkAction"];
            itemType: components["schemas"]["BulkItemType"];
            /** Format: int32 */
            succeededCount: number;
            /** Format: int32 */
            failedCount: number;
        };
        LabelStats: {
            count: components["schemas"]["Int32DataPoint"];
            activeCount: components["schemas"]["Int32DataPoint"];
            isSensitivityLabelsEnabledForSharepointAndOneDrive: components["schemas"]["BooleanNullableDataPoint"];
            isSensitivityLabelsEnabledForContainers: components["schemas"]["BooleanDataPoint"];
        };
        LibraryItemInfo: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            listId: string;
            /** Format: uuid */
            webId: string;
            title: string;
            site: components["schemas"]["SiteItemInfo"];
            url: string;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "LibraryItemInfo";
        };
        LicenseChartData: {
            points: components["schemas"]["LicenseChartDataPoint"][];
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "LicenseChartData";
        };
        LicenseChartDataPoint: {
            label: string;
            /** Format: int32 */
            count: number;
            /** Format: double */
            cost: number;
        };
        LicensePricing: {
            /** Format: uuid */
            skuId: string;
            /** Format: double */
            costPerMonth: number;
        };
        LicenseStats: {
            /** Format: uuid */
            skuId: string;
            displayName: string;
            skuPartNumber: string;
            /** Format: int32 */
            availableCount: number;
            /** Format: int32 */
            assignedCount: number;
            /** Format: int32 */
            expiredCount: number;
            containsCopilotPlan: boolean;
            isEligibleForCopilot: components["schemas"]["IsEligibleForCopilot"];
            licenseType: components["schemas"]["LicenseType"];
            capabilityStatus: components["schemas"]["CapabilityStatus"];
        };
        /** @enum {string} */
        LicenseType: "exchangeKiosk" | "exchangePlan1" | "exchangePlan2" | "microsoft365A1" | "microsoft365A3" | "microsoft365A5" | "microsoft365AppsForBusiness" | "microsoft365AppsForEnterprise" | "microsoft365BusinessBasic" | "microsoft365BusinessPremium" | "microsoft365BusinessStandard" | "microsoft365E3" | "microsoft365E5" | "microsoft365F1" | "microsoft365F3" | "microsoftClipChamp" | "microsoftPlannerPlan1" | "microsoftProjectPlan3" | "microsoftProjectPlan5" | "microsoftTeamsEea" | "microsoftTeamsEssentials" | "microsoftTeamsEnterprise" | "office365A1" | "office365A3" | "office365A5" | "office365E1" | "office365E3" | "office365E5" | "office365F3" | "oneDriveForWorkAndSchoolPlan1" | "oneDriveForWorkAndSchoolPlan2" | "projectOnlineEssentials" | "sharePointPlan1" | "sharePointPlan2" | "visioPlan1" | "visioPlan2" | "microsoftCopilot" | "unknown";
        LicensesStats: {
            licenses: components["schemas"]["LicenseStats"][];
        };
        LicensesStatsDataPoint: {
            value?: components["schemas"]["LicensesStats"];
            status: components["schemas"]["DataPointStatus"];
        };
        LinkStats: {
            /** Format: int32 */
            totalLinksCount: number;
            /** Format: int32 */
            anyoneLinksCount: number;
            /** Format: int32 */
            peopleInOrganizationLinksCount: number;
            /** Format: int32 */
            internalPeopleLinksCount: number;
            /** Format: int32 */
            externalPeopleLinksCount: number;
            /** Format: int32 */
            totalPeopleLinksCount: number;
            /** Format: int32 */
            workspacesWithLinksCount: number;
        };
        LinkStatsDataPoint: {
            value?: components["schemas"]["LinkStats"];
            status: components["schemas"]["DataPointStatus"];
        };
        /** @enum {string} */
        LinkPermissionLevel: "unknown" | "view" | "edit" | "review" | "cantDownload" | "uploadOnly";
        /** @enum {string} */
        LinkType: "unknown" | "anyone" | "peopleInYourOrg" | "internalPeople" | "externalPeople" | "bothInternalAndExternalPeople";
        ManageGroupOwnersParameters: {
            addGroupOwnersIds: string[];
            removeGroupOwnersIds: string[];
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "ManageGroupOwnersParameters";
        };
        /** @enum {string} */
        ManagedGroupTypes: "none" | "selected" | "all" | "notAvailable";
        Measurement: {
            /** Format: double */
            value: number;
            /** Format: date-time */
            timestamp: string;
        };
        /** @description One chain of memberships from the reported principal up to a granting node. */
        MembershipPathDto: {
            /**
             * @description The nodes in order: the reported principal first, the granting node last. A principal with the grant on its
             *     own node has a path of one node.
             */
            nodes: (components["schemas"]["PrincipalMembershipPathNodeDto"] | components["schemas"]["SharedLinkMembershipPathNodeDto"])[];
        };
        MembershipPathDtoPaginated: {
            data: components["schemas"]["MembershipPathDto"][];
            pagination: components["schemas"]["PaginationInfo"];
        };
        /**
         * @description One node on a membership path, discriminated by kind: a principal, or a shared link. A shared link is never a
         *     member of anything, so it can only be the last node.
         */
        MembershipPathNodeDto: {
            kind: string;
        } & (components["schemas"]["PrincipalMembershipPathNodeDto"] | components["schemas"]["SharedLinkMembershipPathNodeDto"]);
        /** @description The fields every path node carries, whatever its kind. */
        MembershipPathNodeFieldsDto: {
            /** Format: int64 */
            nodeId: number;
            /** @description For a Microsoft 365 group, it names the claim, members or owners. */
            displayName: string;
        };
        /** @enum {string} */
        MetricTemplateKey: "privateGroupsWithEeeuAccess" | "usersWithHighAmountsOfDirectPermissions" | "allWorkspacesWithEeeuAccess" | "siteCollectionObjectsWithBrokenInheritance" | "inactiveWorkspaces" | "inactiveOnedrives" | "externalGuestsWithAccessToLargeNumbersOfWorkspaces" | "documentsSharedUsingPeopleInYourOrgLinks" | "onedriveAccountsWithLargeAmountsOfStorage" | "teamCount" | "sitesWithAnyoneSharingCapability" | "sitesWithNewAndExistingGuestsSharingCapability" | "sitesWithExistingGuestsSharingCapability" | "sitesWithOrganizationOnlySharingCapability" | "oneDrivesWithAnyoneSharingCapability" | "oneDrivesWithNewAndExistingGuestsSharingCapability" | "oneDrivesWithExistingGuestsSharingCapability" | "oneDrivesWithOrganizationOnlySharingCapability" | "totalSiteCount" | "sharePointSiteCount" | "inactiveSiteCount" | "oneDriveCount" | "workspacesWithGuestsCount" | "sensitivityLabelCount" | "sharePointSiteContentSize" | "teamsContentSize" | "groupContentSize" | "oneDriveContentSize" | "tenantContentSize" | "sitesWithRestrictedAccessControlCount" | "sitesWithRestrictedContentDiscoveryCount" | "nonOneDriveSiteCount" | "sitesWithBrokenEntitiesCount" | "totalBrokenEntityCount" | "brokenSubsiteCount" | "brokenDocumentLibraryCount" | "brokenListCount" | "totalLinkCount" | "anyoneLinkCount" | "peopleInOrganizationLinkCount" | "internalPeopleLinkCount" | "externalPeopleLinkCount" | "totalPeopleLinkCount" | "workspacesWithLinksCount" | "inactiveUserCount" | "guestCount" | "userCount" | "publicTeamsCount" | "publicGroupsCount" | "dynamicGroupCount" | "groupCount" | "inactiveWorkspacesCount" | "securityGroupCount" | "inactiveGroupCount" | "workspacesSharedOrgWide" | "externalSharingLinks" | "anyoneSharingLinks" | "ownerlessGroups" | "workspaceStorageUsed" | "inactiveLicensesCount" | "unallocatedLicensesCount" | "inactiveSitesContentSize" | "orphanedOneDrivesCount" | "orphanedOneDrivesContentSize" | "inactiveLicensesTotalCost" | "unallocatedLicensesTotalCost" | "purchasedSharePointStorageLicenses" | "inactiveCopilotLicensesCount" | "inactiveCopilotLicensesTotalCost" | "unlicensedUsersCount" | "oneDrivesWithLargeContentSizeCount" | "oneDrivesWithManyFilesCount" | "teamsCount" | "teamsLargeContentSizeCount" | "teamsTooManyMembersCount" | "teamsInactiveCount" | "teamsOrphanedCount" | "sharePointSitesWithLargeContentSizeCount" | "sharePointSitesWithManyFilesCount" | "sharePointSitesInactiveCount" | "licensedUsersCount" | "versionStorageSize" | "workspacesWithExcessiveVersionStorageCount" | "oneDrivesWithHeavyVersionStorageCount" | "oneDriveVersionStorageSize" | "anyoneLinksWithoutExpiration" | "anyoneLinksWithEditAccess" | "specificPeopleLinksWithExternalRecipients" | "expiredSharingLinks" | "sharePointSitesWithNoSensitivityLabel" | "teamsWithManyFilesCount";
        MigrateProduct: {
            hasAccess: boolean;
            canStartTrial: boolean;
            subscription?: components["schemas"]["MigrateSubscription"] | null;
        };
        MigrateSubscription: {
            isTrial: boolean;
            /** Format: date-time */
            endDate?: string | null;
            isValid: boolean;
            state?: string | null;
            isPartnerPerk: boolean;
            isBlocked: boolean;
            /** Format: date-time */
            startDate?: string | null;
            isNfr: boolean;
        };
        MigrationProjectSubscription: {
            isTrial: boolean;
            isValid: boolean;
            state: string;
            /** Format: date-time */
            endDate?: string | null;
        };
        MigrationProjects: {
            hasAccess: boolean;
            isEnabled: boolean;
            /** Format: int32 */
            projectsCountLimit: number | null;
            canDeleteProjects: boolean;
            subscription?: components["schemas"]["MigrationProjectSubscription"] | null;
        };
        /** @enum {string} */
        Multiplicity: "one" | "zeroOrOne" | "many";
        /** @enum {string} */
        ODataAccessLevel: "unknown" | "none" | "read" | "limited" | "fullControl" | "contribute" | "viewOnly" | "design" | "custom";
        ODataActivityLog: {
            /** Format: int64 */
            id: number;
            /** Format: uuid */
            siteCollectionId?: string | null;
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            completedAt?: string | null;
            status: components["schemas"]["ODataActivityStatus"];
            type: components["schemas"]["ODataActivityType"];
            initiatorId?: string | null;
            initiatorEmail?: string | null;
            initiatorName?: string | null;
            initiatorIsAutomation: boolean;
            source: components["schemas"]["ODataActivityLogSource"];
            /** Format: uuid */
            initiatorAutomationId?: string | null;
            /** Format: uuid */
            initiatorAutomationVersionId?: string | null;
            initiatorAutomationName?: string | null;
            /** Format: int64 */
            bulkActionId?: number | null;
            /** Format: int64 */
            fromReportId?: number | null;
            payload?: (components["schemas"]["ArchivedSiteDeletedPayload"] | components["schemas"]["GroupDeletedPayload"] | components["schemas"]["GroupGuestRemovedPayload"] | components["schemas"]["GroupMemberAddedPayload"] | components["schemas"]["GroupMemberRemovedPayload"] | components["schemas"]["GroupOwnerAddedPayload"] | components["schemas"]["GroupOwnerRemovedPayload"] | components["schemas"]["GroupVisibilityUpdatedPayload"] | components["schemas"]["SharingLinkDeletedPayload"] | components["schemas"]["SiteArchivedPayload"] | components["schemas"]["SiteDeletedPayload"] | components["schemas"]["UserLicenseUnassignedPayload"] | components["schemas"]["EveryoneExceptExternalUsersPermissionRemovedPayload"] | components["schemas"]["SiteSharingCapabilityUpdatedPayload"] | components["schemas"]["SiteFileVersionsTrimmedPayload"] | components["schemas"]["SiteFileVersionPolicyUpdatedPayload"] | components["schemas"]["TenantFileVersionPolicyUpdatedPayload"] | components["schemas"]["PrincipalRemovedFromSPGroupPayload"] | components["schemas"]["DocumentLibraryFileVersionPolicyUpdatedPayload"] | components["schemas"]["DirectPermissionRemovedPayload"] | components["schemas"]["DocumentLibraryFileVersionsTrimmedPayload"] | components["schemas"]["SiteCollectionAdminRemovedPayload"] | components["schemas"]["ReportShareCreatedPayload"] | components["schemas"]["FileArchivedPayload"] | components["schemas"]["FileDeletedPayload"] | components["schemas"]["SharingLinkRecipientRemovedPayload"] | components["schemas"]["ReportShareRecipientsAddedPayload"] | components["schemas"]["ReportShareRecipientsRemovedPayload"] | components["schemas"]["ReportShareRevokedPayload"] | components["schemas"]["ReportShareExpiryChangedPayload"] | components["schemas"]["ReportShareRenamedPayload"] | components["schemas"]["ReportShareDeletedPayload"]) | null;
            summary: string;
            errorCode?: string | null;
            errorMessage?: string | null;
            metadata?: components["schemas"]["ODataActivityLogMetadata"];
            associatedRemediationImpactTemplateKeys: components["schemas"]["ODataRemediationImpactTemplateKey"][];
            /** Format: uuid */
            reviewId?: string | null;
            review?: components["schemas"]["ODataReview"];
        };
        ODataActivityLogMetadata: {
            /** Format: int64 */
            activityLogId: number;
            /** Format: int32 */
            groupOwnersCount?: number | null;
            groupVisibility?: components["schemas"]["ODataGroupVisibility"];
            sharedLinkLinkType?: components["schemas"]["ODataLinkType"];
            /** Format: int64 */
            siteContentSizeInBytes?: number | null;
            siteEveryoneExceptExternalUsersAccessLevels?: components["schemas"]["ODataAccessLevel"][] | null;
            /** Format: int64 */
            versionStorageReleasedInBytes?: number | null;
        };
        ODataActivityLogODataCollectionResponse: {
            "@odata.context"?: string | null;
            value?: components["schemas"]["ODataActivityLog"][] | null;
            /** Format: int64 */
            "@odata.count"?: number | null;
            "@odata.nextLink"?: string | null;
        };
        /** @enum {string} */
        ODataActivityLogSource: "user" | "automation" | "mcp" | "review";
        /** @enum {string} */
        ODataActivityStatus: "pending" | "done" | "failed";
        /** @enum {string} */
        ODataActivityType: "unknown" | "sharingLinkDeleted" | "groupOwnerAdded" | "groupOwnerRemoved" | "groupDeleted" | "groupGuestRemoved" | "groupVisibilityUpdated" | "siteDeleted" | "siteArchived" | "archivedSiteDeleted" | "userLicenseUnassigned" | "everyoneExceptExternalUsersPermissionRemoved" | "siteSharingCapabilityUpdated" | "siteFileVersionsTrimmed" | "siteFileVersionPolicyUpdated" | "tenantFileVersionPolicyUpdated" | "groupMemberAdded" | "groupMemberRemoved" | "principalRemovedFromSPGroup" | "documentLibraryFileVersionPolicyUpdated" | "directPermissionRemoved" | "documentLibraryFileVersionsTrimmed" | "siteCollectionAdminRemoved" | "reportShareCreated" | "fileArchived" | "fileDeleted" | "sharingLinkRecipientRemoved" | "reportShareRecipientsAdded" | "reportShareRecipientsRemoved" | "reportShareRevoked" | "reportShareExpiryChanged" | "reportShareRenamed" | "reportShareDeleted";
        /** @enum {string} */
        ODataArchiveStatus: "unknown" | "archiving" | "archived";
        ODataArchivedSiteCollection: {
            /** Format: uuid */
            id: string;
            siteId?: string | null;
            displayName?: string | null;
            webUrl?: string | null;
            template?: string | null;
            types: components["schemas"]["ODataResourceType"][];
            /** Format: int64 */
            contentSizeInBytes: number;
            archiveStatus: components["schemas"]["ODataArchiveStatus"];
            /** Format: date-time */
            createdInMicrosoftAt?: string | null;
            /** Format: date-time */
            archivedAt: string;
            /** Format: uuid */
            parentId?: string | null;
            parent?: components["schemas"]["ODataGroup"];
        };
        ODataArchivedSiteCollectionODataCollectionResponse: {
            "@odata.context"?: string | null;
            value?: components["schemas"]["ODataArchivedSiteCollection"][] | null;
            /** Format: int64 */
            "@odata.count"?: number | null;
            "@odata.nextLink"?: string | null;
        };
        ODataAutomation: {
            /** Format: uuid */
            id: string;
            name: string;
            entitySet: components["schemas"]["ODataAutomationEntitySet"];
            isEnabled: boolean;
            status: components["schemas"]["ODataAutomationStatus"];
            action: components["schemas"]["ODataAutomationActionType"];
            actionParameter?: (components["schemas"]["RemoveEeeuActionParameter"] | components["schemas"]["TrimSiteFileVersionsActionParameter"] | components["schemas"]["UpdateSiteFileVersionPolicyActionParameter"]) | null;
            /** Format: date-time */
            createdAt: string;
            insightTemplateKey?: components["schemas"]["InsightV2TemplateKey"] | null;
            immutableFilter: string;
            filter?: string | null;
            /** Format: date-time */
            lastRunAt?: string | null;
            lastRunStatus?: components["schemas"]["ODataAutomationRunState"];
            /** Format: int32 */
            lastRunSuccessCount?: number | null;
            /** Format: int32 */
            totalSuccessCount: number;
            /** Format: uuid */
            versionId: string;
            /** Format: date-time */
            versionCreatedAt: string;
        };
        /** @enum {string} */
        ODataAutomationActionType: "deleteSharingLink" | "deleteSite" | "archiveSite" | "removeEveryoneExceptExternalUsersPermission" | "trimSiteFileVersions" | "updateSiteFileVersionPolicy" | "unknown";
        /** @enum {string} */
        ODataAutomationEntitySet: "sharedLinks" | "oneDrives" | "workspaces" | "unknown";
        ODataAutomationODataCollectionResponse: {
            "@odata.context"?: string | null;
            value?: components["schemas"]["ODataAutomation"][] | null;
            /** Format: int64 */
            "@odata.count"?: number | null;
            "@odata.nextLink"?: string | null;
        };
        /** @enum {string} */
        ODataAutomationRunState: "success" | "failure" | "partialFailure" | "inProgress" | "unknown";
        /** @enum {string} */
        ODataAutomationStatus: "disabled" | "enabled";
        ODataBrokenInheritanceEntity: {
            id: string;
            /** Format: uuid */
            siteCollectionId: string;
            /** Format: int64 */
            entityId: number;
            type: components["schemas"]["ODataEntityType"];
            title: string;
            url: string;
            siteCollection?: components["schemas"]["ODataSiteCollection"];
        };
        ODataBrokenInheritanceEntityODataCollectionResponse: {
            "@odata.context"?: string | null;
            value?: components["schemas"]["ODataBrokenInheritanceEntity"][] | null;
            /** Format: int64 */
            "@odata.count"?: number | null;
            "@odata.nextLink"?: string | null;
        };
        /** @enum {string} */
        ODataBulkAction: "deleteSharingLink" | "addGroupOwner" | "removeGroupOwner" | "manageGroupOwners" | "deleteGroup" | "removeGroupGuest" | "updateGroupVisibility" | "deleteSite" | "archiveSite" | "deleteArchivedSite" | "unassignUserLicense" | "removeEveryoneExceptExternalUsersPermission" | "updateSiteSharingCapability" | "trimSiteFileVersions" | "updateSiteFileVersionPolicy" | "updateTenantFileVersionPolicy" | "addGroupMember" | "manageGroupUsers" | "removeGroupMember" | "removeDirectPermission" | "removePrincipalFromSPGroup" | "updateDocumentLibraryFileVersionPolicy" | "addGroupUsers" | "trimDocumentLibraryFileVersions" | "removeSiteCollectionAdmin" | "archiveFile" | "deleteFile" | "removeSharingLinkRecipient";
        ODataBulkOperation: {
            /** Format: int64 */
            bulkId: number;
            action: components["schemas"]["ODataBulkAction"];
            status: components["schemas"]["ODataBulkOperationStatus"];
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            endedAt?: string | null;
            /** Format: int32 */
            totalAffectedCount: number;
            /** Format: int32 */
            totalSkippedCount: number;
            /** Format: int32 */
            totalItemsCount: number;
            /** Format: int32 */
            inProgressCount: number;
            /** Format: int32 */
            succeededCount: number;
            /** Format: int32 */
            failedCount: number;
            errorMessage?: string | null;
            targetDisplayName?: string | null;
            isDismissed: boolean;
            initiatorId?: string | null;
            initiatorEmail?: string | null;
            initiatorName?: string | null;
            initiatorIsAutomation: boolean;
            source: components["schemas"]["ODataActivityLogSource"];
            /** Format: uuid */
            initiatorAutomationId?: string | null;
            /** Format: uuid */
            initiatorAutomationVersionId?: string | null;
            initiatorAutomationName?: string | null;
            /** Format: uuid */
            reviewId?: string | null;
            review?: components["schemas"]["ODataReview"];
        };
        ODataBulkOperationODataCollectionResponse: {
            "@odata.context"?: string | null;
            value?: components["schemas"]["ODataBulkOperation"][] | null;
            /** Format: int64 */
            "@odata.count"?: number | null;
            "@odata.nextLink"?: string | null;
        };
        /** @enum {string} */
        ODataBulkOperationStatus: "planned" | "inProgress" | "success" | "failure" | "partialFailure" | "skipped";
        ODataBulkRequest: {
            entitySet: components["schemas"]["EntitySet"];
            query: string;
            action: components["schemas"]["BulkAction"];
            parameters?: (components["schemas"]["ManageGroupOwnersParameters"] | components["schemas"]["AddGroupUsersParameters"] | components["schemas"]["AddMemberToGroupOwnersSelectionParameters"] | components["schemas"]["AddOwnerToGroupMembersSelectionParameters"] | components["schemas"]["RemoveGroupUsersSelectionParameters"] | components["schemas"]["RemoveGroupMembersSelectionParameters"] | components["schemas"]["RemoveGroupOwnersSelectionParameters"] | components["schemas"]["OneGroupOwnerParameter"] | components["schemas"]["OneGroupMemberParameter"] | components["schemas"]["GroupVisibilityParameter"] | components["schemas"]["RemoveGroupGuestParameter"] | components["schemas"]["OneGroupGuestParameter"] | components["schemas"]["SharingCapabilityParameter"] | components["schemas"]["RemoveEeeuOptions"] | components["schemas"]["TrimSiteFileVersionsParameters"] | components["schemas"]["UpdateSiteFileVersionPolicyParameters"] | components["schemas"]["UpdateTenantFileVersionPolicyParameters"] | components["schemas"]["RemovePrincipalFromSPGroupParameter"] | components["schemas"]["UpdateDocumentLibraryFileVersionPolicyParameters"] | components["schemas"]["TrimDocumentLibraryFileVersionsParameters"] | components["schemas"]["RemoveSharingLinkRecipientsParameter"] | components["schemas"]["RemoveSharingLinkRecipientNodesParameter"]) | null;
            includes: string[];
            excludes: string[];
        };
        /** @enum {string} */
        ODataCapabilityStatus: "unknown" | "enabled" | "warning" | "suspended" | "deleted" | "lockedOut";
        /** @enum {string} */
        ODataContentFormat: "unknown" | "file" | "email" | "site" | "unifiedGroup" | "teamwork" | "notAvailable";
        /** @enum {string} */
        ODataCopilotIncluded: "no" | "yes";
        ODataCustomReport: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            sgAccountId: string;
            title: string;
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            updatedAt: string;
            source: components["schemas"]["ODataCustomReportSource"];
            entitySet: components["schemas"]["ODataEntitySet"];
            filter: string;
            orderBy: string;
            properties: string[];
        };
        ODataCustomReportODataCollectionResponse: {
            "@odata.context"?: string | null;
            value?: components["schemas"]["ODataCustomReport"][] | null;
            /** Format: int64 */
            "@odata.count"?: number | null;
            "@odata.nextLink"?: string | null;
        };
        /** @enum {string} */
        ODataCustomReportSource: "user" | "template" | "ai";
        ODataDoNotDisturbUser: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            userId: string;
            displayName?: string | null;
            jobTitle?: string | null;
            /** Format: date-time */
            createdAt: string;
            /** Format: int32 */
            ownedWorkspacesCount: number;
        };
        ODataDoNotDisturbUserODataCollectionResponse: {
            "@odata.context"?: string | null;
            value?: components["schemas"]["ODataDoNotDisturbUser"][] | null;
            /** Format: int64 */
            "@odata.count"?: number | null;
            "@odata.nextLink"?: string | null;
        };
        ODataDoNotDisturbWorkspace: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            siteCollectionId: string;
            displayName?: string | null;
            /** Format: date-time */
            createdAt: string;
            /** Format: int32 */
            ownersCount: number;
        };
        ODataDoNotDisturbWorkspaceODataCollectionResponse: {
            "@odata.context"?: string | null;
            value?: components["schemas"]["ODataDoNotDisturbWorkspace"][] | null;
            /** Format: int64 */
            "@odata.count"?: number | null;
            "@odata.nextLink"?: string | null;
        };
        ODataDocumentLibrary: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            siteCollectionId: string;
            /** Format: uuid */
            webId?: string | null;
            isSubsite: boolean;
            relativeUrl?: string | null;
            path?: string | null;
            /** Format: uuid */
            listId: string;
            title?: string | null;
            url?: string | null;
            enableVersioning: boolean;
            enableMinorVersions: boolean;
            /** Format: int32 */
            majorVersionLimit?: number | null;
            /** Format: int32 */
            majorWithMinorVersionsLimit: number;
            defaultTrimMode: components["schemas"]["ODataVersionTrimMode"];
            /** Format: int32 */
            defaultExpireAfterDays?: number | null;
            versionLimit: components["schemas"]["ODataDocumentLibraryVersionLimitPolicy"];
            /** Format: int64 */
            contentSizeInBytes?: number | null;
            /** Format: int64 */
            versionStorageBytes?: number | null;
            /** Format: int64 */
            fileCount?: number | null;
            /** Format: double */
            versionStorageContentPercent?: number | null;
            /** Format: date-time */
            lastUpdatedAt: string;
            siteCollection: components["schemas"]["ODataSiteCollection"];
        };
        ODataDocumentLibraryODataCollectionResponse: {
            "@odata.context"?: string | null;
            value?: components["schemas"]["ODataDocumentLibrary"][] | null;
            /** Format: int64 */
            "@odata.count"?: number | null;
            "@odata.nextLink"?: string | null;
        };
        /** @enum {string} */
        ODataDocumentLibraryVersionLimitPolicy: "unknown" | "automatic" | "custom" | "deactivated";
        /** @enum {string} */
        ODataEligibleForCopilot: "alreadyIncluded" | "no" | "yes";
        /** @enum {string} */
        ODataEligibleForOneDrive: "no" | "yes";
        /** @enum {string} */
        ODataEntitySet: "licenses" | "sensitivityLabels" | "siteCollections" | "groups" | "users" | "sharedLinks" | "securityGroups" | "brokenInheritanceEntities" | "oneDrives" | "workspaces" | "activityLogs" | "sharedLinkInvitations" | "customReports" | "automations" | "archivedSiteCollections" | "userLicenses" | "reviews" | "reviewItems" | "reviewTasks" | "reviewAnswers" | "doNotDisturbUsers" | "doNotDisturbWorkspaces" | "reviewNotificationRecipients" | "reviewSelectedWorkspaces" | "reviewUsers" | "reviewReviewers" | "reviewAnswerSharedLinks" | "tenantSettings" | "documentLibraries" | "bulkOperations" | "reviewAnswerMembership" | "workspaceReviews" | "groupPrincipals" | "reviewAnswerSharedLinkRecipients" | "reviewAnswerFiles" | "reportShares";
        /** @enum {string} */
        ODataEntityType: "unknown" | "siteCollection" | "subsite" | "list" | "documentLibrary" | "folder" | "file";
        ODataError: {
            code?: string | null;
            message?: string | null;
            target?: string | null;
            details?: components["schemas"]["ODataError"][] | null;
        };
        ODataErrorResponse: {
            error?: components["schemas"]["ODataError"];
        };
        /** @enum {string} */
        ODataFileType: "unknown" | "root" | "folder" | "file";
        ODataGroup: {
            /** Format: uuid */
            id: string;
            displayName?: string | null;
            visibility: components["schemas"]["ODataGroupVisibility"];
            isTeam: boolean;
            ownerUsers: components["schemas"]["ODataUser"][];
            memberUsers: components["schemas"]["ODataUser"][];
            guestUsers: components["schemas"]["ODataUser"][];
            /** Format: int32 */
            ownersCount: number;
            /** Format: int32 */
            membersCount: number;
            /** Format: int32 */
            guestsCount: number;
            rootSite?: components["schemas"]["ODataSiteCollection"];
        };
        ODataGroupODataCollectionResponse: {
            "@odata.context"?: string | null;
            value?: components["schemas"]["ODataGroup"][] | null;
            /** Format: int64 */
            "@odata.count"?: number | null;
            "@odata.nextLink"?: string | null;
        };
        ODataGroupPrincipal: {
            id: string;
            displayName?: string | null;
            type: components["schemas"]["ODataGroupPrincipalType"];
            membershipType?: components["schemas"]["ODataGroupPrincipalMembershipType"] | null;
            isMailEnabled?: boolean | null;
            hasTeam?: boolean | null;
        };
        /** @enum {string} */
        ODataGroupPrincipalMembershipType: "assigned" | "dynamic";
        ODataGroupPrincipalODataCollectionResponse: {
            "@odata.context"?: string | null;
            value?: components["schemas"]["ODataGroupPrincipal"][] | null;
            /** Format: int64 */
            "@odata.count"?: number | null;
            "@odata.nextLink"?: string | null;
        };
        /** @enum {string} */
        ODataGroupPrincipalType: "m365" | "securityGroup" | "builtIn";
        /** @enum {string} */
        ODataGroupVisibility: "unknown" | "private" | "public" | "hiddenMembership";
        /** @enum {string} */
        ODataInviteeKind: "unknown" | "user" | "group" | "externalUser";
        ODataLicense: {
            /** Format: uuid */
            id: string;
            partNumber?: string | null;
            /** Format: int32 */
            purchasedCount: number;
            /** Format: int32 */
            assignedCount: number;
            /** Format: int32 */
            unassignedCount: number;
            /** Format: int32 */
            expiredCount: number;
            /** Format: int32 */
            directlyAssignedCount: number;
            /** Format: int32 */
            groupAssignedCount: number;
            containsCopilotPlan: components["schemas"]["ODataCopilotIncluded"];
            isEligibleForCopilot: components["schemas"]["ODataEligibleForCopilot"];
            capabilityStatus: components["schemas"]["ODataCapabilityStatus"];
            licenseProductName?: string | null;
            userLicenses: components["schemas"]["ODataUserLicense"][];
        };
        ODataLicenseODataCollectionResponse: {
            "@odata.context"?: string | null;
            value?: components["schemas"]["ODataLicense"][] | null;
            /** Format: int64 */
            "@odata.count"?: number | null;
            "@odata.nextLink"?: string | null;
        };
        /** @enum {string} */
        ODataLinkKind: "unknown" | "direct" | "organizationView" | "organizationEdit" | "anonymousView" | "anonymousEdit" | "flexible";
        /** @enum {string} */
        ODataLinkPermissionLevel: "unknown" | "view" | "edit" | "review" | "cantDownload" | "uploadOnly";
        /** @enum {string} */
        ODataLinkType: "unknown" | "anyone" | "peopleInYourOrg" | "internalPeople" | "externalPeople" | "bothInternalAndExternalPeople";
        ODataOneDrive: {
            /** Format: uuid */
            id: string;
            siteId?: string | null;
            displayName?: string | null;
            webUrl?: string | null;
            /** Format: int64 */
            contentSizeInBytes: number;
            /** Format: int64 */
            fileCount?: number | null;
            /** Format: int64 */
            storageQuotaTotalBytes?: number | null;
            /** Format: int64 */
            versionStorageBytes?: number | null;
            /** Format: double */
            versionStorageQuotaPercent?: number | null;
            /** Format: double */
            versionStorageSitePercent?: number | null;
            /** Format: date-time */
            lastActivity?: string | null;
            types: components["schemas"]["ODataResourceType"][];
            sharingCapability: components["schemas"]["ODataSharingCapabilities"];
            links: components["schemas"]["ODataSharedLink"][];
            ownerUsers: components["schemas"]["ODataUser"][];
            ownerUser?: components["schemas"]["ODataUser"];
            /** Format: uuid */
            provisionedForUserId?: string | null;
            brokenInheritanceEntities: components["schemas"]["ODataBrokenInheritanceEntity"][];
            /** Format: int32 */
            brokenInheritanceEntitiesCount: number;
            /** Format: int32 */
            sharedLinksCount: number;
            /** Format: int32 */
            anyoneLinksCount: number;
            /** Format: int32 */
            peopleInYourOrgLinksCount: number;
            /** Format: int32 */
            internalPeopleLinksCount: number;
            /** Format: int32 */
            externalPeopleLinksCount: number;
            inheritVersionPolicyFromTenant?: boolean | null;
            enableAutoExpirationVersionTrim?: boolean | null;
            versionLimit: components["schemas"]["ODataVersionLimitPolicy"];
            /** Format: int32 */
            majorVersionLimit?: number | null;
            /** Format: int32 */
            expireVersionsAfterDays?: number | null;
        };
        ODataOneDriveODataCollectionResponse: {
            "@odata.context"?: string | null;
            value?: components["schemas"]["ODataOneDrive"][] | null;
            /** Format: int64 */
            "@odata.count"?: number | null;
            "@odata.nextLink"?: string | null;
        };
        /** @enum {string} */
        ODataPermissionCrawlStatus: "pending" | "inProgress" | "done";
        /** @enum {string} */
        ODataRemediationImpactTemplateKey: "unknown" | "workspacesSharedOrgWide" | "externalSharingLinks" | "anyoneSharingLinks" | "ownerlessGroups" | "workspaceStorageUsed";
        ODataReportShare: {
            /** Format: uuid */
            id: string;
            name: string;
            reportKind: components["schemas"]["ODataReportShareKind"];
            status: components["schemas"]["ODataReportShareStatus"];
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            expiresAt: string;
            /** Format: date-time */
            revokedAt?: string | null;
            /** Format: uuid */
            initiatorId?: string | null;
            initiatorEmail?: string | null;
            initiatorName?: string | null;
            /** Format: int32 */
            recipientsCount: number;
            recipients?: components["schemas"]["ODataReportShareRecipient"][] | null;
        };
        /** @enum {string} */
        ODataReportShareKind: "unknown" | "pmr" | "userAccess" | "groupAccess";
        ODataReportShareODataCollectionResponse: {
            "@odata.context"?: string | null;
            value?: components["schemas"]["ODataReportShare"][] | null;
            /** Format: int64 */
            "@odata.count"?: number | null;
            "@odata.nextLink"?: string | null;
        };
        ODataReportShareRecipient: {
            /** Format: uuid */
            id: string;
            displayName?: string | null;
            email: string;
            isGuest?: boolean | null;
            user?: components["schemas"]["ODataUser"] | null;
        };
        /** @enum {string} */
        ODataReportShareStatus: "active" | "expired" | "stopped";
        /** @enum {string} */
        ODataResourceType: "unknown" | "oneDrive" | "group" | "sharePointSite" | "teamsChannel" | "teams";
        /** @enum {string} */
        ODataRestrictedAccessControl: "disabled" | "enabled";
        /** @enum {string} */
        ODataRestrictedContentDiscovery: "disabled" | "enabled";
        ODataReview: {
            /** Format: uuid */
            id: string;
            status: components["schemas"]["ODataReviewStatus"];
            title: string;
            reviewTypes: components["schemas"]["ODataReviewType"][];
            customMessage?: string | null;
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            startedAt?: string | null;
            /** Format: date-time */
            expireAt?: string | null;
            /** Format: int32 */
            expireDays: number;
            /** Format: date-time */
            completedAt?: string | null;
            /** Format: date-time */
            closedAt?: string | null;
            /** Format: int32 */
            completedReviewItemsCount: number;
            /** Format: int32 */
            inProgressReviewItemsCount: number;
            /** Format: int32 */
            totalReviewItemsCount: number;
            /** Format: int32 */
            totalReviewersCount: number;
            initiatorId?: string | null;
            initiatorEmail?: string | null;
            initiatorName?: string | null;
            initiatorIsAutomation: boolean;
            /** Format: uuid */
            initiatorAutomationId?: string | null;
            /** Format: uuid */
            initiatorAutomationVersionId?: string | null;
            initiatorAutomationName?: string | null;
        };
        /** @enum {string} */
        ODataReviewAction: "unknown" | "keepWorkspace" | "archiveWorkspace" | "deleteWorkspace" | "deleteSharedLink" | "removeGuest" | "deferWorkspaceToAnotherReviewer" | "removeMembership" | "archiveFile" | "deleteFile" | "removeSharedLinkRecipients";
        ODataReviewAnswerFile: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            reviewTaskId: string;
            fileName?: string | null;
            folderPath?: string | null;
            createdByDisplayName?: string | null;
            /** Format: int64 */
            size?: number | null;
            /** Format: date-time */
            lastModifiedDateTime?: string | null;
            action: components["schemas"]["ODataReviewAction"];
        };
        ODataReviewAnswerFileODataCollectionResponse: {
            "@odata.context"?: string | null;
            value?: components["schemas"]["ODataReviewAnswerFile"][] | null;
            /** Format: int64 */
            "@odata.count"?: number | null;
            "@odata.nextLink"?: string | null;
        };
        ODataReviewAnswerMembership: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            reviewTaskId: string;
            /** Format: uuid */
            userId?: string | null;
            displayName?: string | null;
            email?: string | null;
            action: components["schemas"]["ODataReviewAction"];
            type?: components["schemas"]["ODataUserType"];
        };
        ODataReviewAnswerMembershipODataCollectionResponse: {
            "@odata.context"?: string | null;
            value?: components["schemas"]["ODataReviewAnswerMembership"][] | null;
            /** Format: int64 */
            "@odata.count"?: number | null;
            "@odata.nextLink"?: string | null;
        };
        /** @enum {string} */
        ODataReviewAnswerReason: "unknown" | "notProvided" | "other" | "noLongerNeeded" | "securityRisk" | "leftOrganization" | "excessivePermissions" | "sharedInError" | "stillActivelyUsed" | "neededForReference" | "sharedWithExternalPartners" | "noLongerUsed" | "projectOrInitiativeEnded" | "replacedWithSomethingElse" | "duplicateWorkspace" | "createdInError";
        ODataReviewAnswerSharedLink: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            reviewTaskId: string;
            fileName?: string | null;
            sharerDisplayName?: string | null;
            sharerEmail?: string | null;
            /** Format: uuid */
            sharerId?: string | null;
            linkType?: components["schemas"]["ODataLinkType"];
        };
        ODataReviewAnswerSharedLinkODataCollectionResponse: {
            "@odata.context"?: string | null;
            value?: components["schemas"]["ODataReviewAnswerSharedLink"][] | null;
            /** Format: int64 */
            "@odata.count"?: number | null;
            "@odata.nextLink"?: string | null;
        };
        ODataReviewAnswerSharedLinkRecipient: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            reviewTaskId: string;
            /** Format: int64 */
            sharedLinkId: number;
            fileName?: string | null;
            linkType?: components["schemas"]["ODataLinkType"];
            inviteeId: string;
            displayName: string;
            email?: string | null;
            kind: components["schemas"]["ODataInviteeKind"];
            isGuest?: boolean | null;
        };
        ODataReviewAnswerSharedLinkRecipientODataCollectionResponse: {
            "@odata.context"?: string | null;
            value?: components["schemas"]["ODataReviewAnswerSharedLinkRecipient"][] | null;
            /** Format: int64 */
            "@odata.count"?: number | null;
            "@odata.nextLink"?: string | null;
        };
        ODataReviewItem: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            reviewId: string;
            workspaceDisplayName: string;
            workspaceDescription?: string | null;
            workspaceAssociatedWorkloads: components["schemas"]["ODataWorkspaceType"][];
            reviewers: components["schemas"]["ODataReviewUser"][];
            status: components["schemas"]["ODataReviewItemStatus"];
            /** Format: date-time */
            completedAt?: string | null;
            /** Format: uuid */
            siteCollectionId: string;
        };
        ODataReviewItemODataCollectionResponse: {
            "@odata.context"?: string | null;
            value?: components["schemas"]["ODataReviewItem"][] | null;
            /** Format: int64 */
            "@odata.count"?: number | null;
            "@odata.nextLink"?: string | null;
        };
        /** @enum {string} */
        ODataReviewItemStatus: "unknown" | "pending" | "completed" | "inProgress";
        ODataReviewNotificationRecipient: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            reviewId: string;
            displayName?: string | null;
            userPrincipalName?: string | null;
            email?: string | null;
            /** Format: int32 */
            workspaceCount: number;
            /** Format: date-time */
            lastSentAt?: string | null;
            isDoNotDisturb: boolean;
            /** Format: uuid */
            doNotDisturbUserId?: string | null;
        };
        ODataReviewNotificationRecipientODataCollectionResponse: {
            "@odata.context"?: string | null;
            value?: components["schemas"]["ODataReviewNotificationRecipient"][] | null;
            /** Format: int64 */
            "@odata.count"?: number | null;
            "@odata.nextLink"?: string | null;
        };
        ODataReviewODataCollectionResponse: {
            "@odata.context"?: string | null;
            value?: components["schemas"]["ODataReview"][] | null;
            /** Format: int64 */
            "@odata.count"?: number | null;
            "@odata.nextLink"?: string | null;
        };
        ODataReviewReviewer: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            reviewId: string;
            displayName?: string | null;
            jobTitle?: string | null;
            /** Format: int32 */
            assignedWorkspacesCount: number;
            /** Format: int32 */
            completedWorkspacesCount: number;
            hasCompletedAllTasks: boolean;
            /** Format: date-time */
            lastNotifiedAt?: string | null;
            hasBeenReminded: boolean;
            wasPreviouslyNotified: boolean;
        };
        ODataReviewReviewerODataCollectionResponse: {
            "@odata.context"?: string | null;
            value?: components["schemas"]["ODataReviewReviewer"][] | null;
            /** Format: int64 */
            "@odata.count"?: number | null;
            "@odata.nextLink"?: string | null;
        };
        ODataReviewSelectedWorkspace: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            reviewId: string;
            displayName?: string | null;
            associatedWorkloads: components["schemas"]["ODataWorkspaceType"][];
            /** Format: date-time */
            lastActivity?: string | null;
            /** Format: int32 */
            sharedLinksCount: number;
            /** Format: int32 */
            membersCount: number;
            /** Format: int32 */
            guestsCount: number;
            /** Format: int64 */
            largeFileCount?: number | null;
            /** Format: int64 */
            inactiveFileCount?: number | null;
            /** Format: int64 */
            oldFileCount?: number | null;
            hasNoEmailableOwner: boolean;
            isDoNotDisturb: boolean;
            /** Format: uuid */
            doNotDisturbWorkspaceId?: string | null;
        };
        ODataReviewSelectedWorkspaceODataCollectionResponse: {
            "@odata.context"?: string | null;
            value?: components["schemas"]["ODataReviewSelectedWorkspace"][] | null;
            /** Format: int64 */
            "@odata.count"?: number | null;
            "@odata.nextLink"?: string | null;
        };
        /** @enum {string} */
        ODataReviewStatus: "unknown" | "active" | "draft" | "closed" | "deleting";
        /** @enum {string} */
        ODataReviewType: "unknown" | "lifecycle" | "externalSharing" | "guests" | "internalSharing" | "members" | "files";
        ODataReviewUser: {
            /** Format: uuid */
            userId: string;
            displayName?: string | null;
            email: string;
            jobTitle?: string | null;
        };
        ODataSecurityGroup: {
            /** Format: uuid */
            id: string;
            displayName?: string | null;
            isO365GroupLinked: boolean;
            isSecurityEnabled: boolean;
            hasDynamicMembership: boolean;
            isMailEnabled: boolean;
        };
        ODataSecurityGroupODataCollectionResponse: {
            "@odata.context"?: string | null;
            value?: components["schemas"]["ODataSecurityGroup"][] | null;
            /** Format: int64 */
            "@odata.count"?: number | null;
            "@odata.nextLink"?: string | null;
        };
        ODataSensitivityLabel: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            parentId?: string | null;
            name?: string | null;
            description?: string | null;
            status: components["schemas"]["ODataSensitivityLabelStatus"];
            /** Format: int32 */
            priority: number;
            contentFormats: components["schemas"]["ODataContentFormat"][];
        };
        ODataSensitivityLabelODataCollectionResponse: {
            "@odata.context"?: string | null;
            value?: components["schemas"]["ODataSensitivityLabel"][] | null;
            /** Format: int64 */
            "@odata.count"?: number | null;
            "@odata.nextLink"?: string | null;
        };
        /** @enum {string} */
        ODataSensitivityLabelStatus: "unknown" | "disabled" | "enabled";
        ODataSharedLink: {
            /** Format: int64 */
            id: number;
            /** Format: uuid */
            siteCollectionId: string;
            driveId?: string | null;
            driveItemId?: string | null;
            /** Format: uuid */
            shareId: string;
            fileUrl?: string | null;
            fileName?: string | null;
            fileType: components["schemas"]["ODataFileType"];
            linkType: components["schemas"]["ODataLinkType"];
            linkKind: components["schemas"]["ODataLinkKind"];
            linkPermissionLevel: components["schemas"]["ODataLinkPermissionLevel"];
            hasPassword: boolean;
            allowsAnonymousAccess: boolean;
            preventsDownload: boolean;
            /** Format: date-time */
            expirationDate?: string | null;
            hasExpiration: boolean;
            /** Format: date-time */
            sharedDate?: string | null;
            createdBy?: components["schemas"]["ODataUser"];
            sharedBy?: components["schemas"]["ODataUser"][] | null;
            /** Format: int32 */
            invitationsCount: number;
            invitations: components["schemas"]["ODataSharedLinkInvitation"][];
            siteCollection: components["schemas"]["ODataSiteCollection"];
        };
        ODataSharedLinkInvitation: {
            id: string;
            /** Format: int64 */
            linkId: number;
            inviteeId: string;
            email?: string | null;
            displayName?: string | null;
            kind: components["schemas"]["ODataInviteeKind"];
            isGuest: boolean;
            invitee?: components["schemas"]["ODataUser"];
            inviter?: components["schemas"]["ODataUser"];
            /** Format: date-time */
            invitedOn?: string | null;
        };
        ODataSharedLinkInvitationODataCollectionResponse: {
            "@odata.context"?: string | null;
            value?: components["schemas"]["ODataSharedLinkInvitation"][] | null;
            /** Format: int64 */
            "@odata.count"?: number | null;
            "@odata.nextLink"?: string | null;
        };
        ODataSharedLinkODataCollectionResponse: {
            "@odata.context"?: string | null;
            value?: components["schemas"]["ODataSharedLink"][] | null;
            /** Format: int64 */
            "@odata.count"?: number | null;
            "@odata.nextLink"?: string | null;
        };
        /** @enum {string} */
        ODataSharingCapabilities: "unknown" | "noExternalSharing" | "newAndExistingGuests" | "anyone" | "existingGuestsOnly";
        ODataSiteCollection: {
            /** Format: uuid */
            id: string;
            siteId?: string | null;
            displayName?: string | null;
            description?: string | null;
            webUrl?: string | null;
            template?: string | null;
            types: components["schemas"]["ODataResourceType"][];
            sharingCapability: components["schemas"]["ODataSharingCapabilities"];
            /** Format: int64 */
            contentSizeInBytes: number;
            restrictedAccessControl: components["schemas"]["ODataRestrictedAccessControl"];
            restrictedContentDiscovery: components["schemas"]["ODataRestrictedContentDiscovery"];
            everyoneExceptExternalUsersAccessLevels: components["schemas"]["ODataAccessLevel"][];
            sensitivityLabel?: components["schemas"]["ODataSensitivityLabel"];
            ownerUsers: components["schemas"]["ODataUser"][];
            memberUsers: components["schemas"]["ODataUser"][];
            guestUsers: components["schemas"]["ODataUser"][];
            ownerSecurityGroups: components["schemas"]["ODataSecurityGroup"][];
            memberSecurityGroups: components["schemas"]["ODataSecurityGroup"][];
            brokenInheritanceEntities: components["schemas"]["ODataBrokenInheritanceEntity"][];
            /** Format: int32 */
            ownersCount: number;
            /** Format: int32 */
            membersCount: number;
            /** Format: int32 */
            guestsCount: number;
            /** Format: int32 */
            brokenInheritanceEntitiesCount: number;
            /** Format: date-time */
            sharePointLastActivity?: string | null;
            /** Format: int64 */
            versionStorageBytes?: number | null;
            /** Format: int64 */
            storageQuotaTotalBytes?: number | null;
            /** Format: double */
            versionStorageQuotaPercent?: number | null;
            /** Format: double */
            versionStorageSitePercent?: number | null;
            /** Format: int64 */
            fileCount?: number | null;
            /** Format: int64 */
            largeFileCount?: number | null;
            /** Format: int64 */
            inactiveFileCount?: number | null;
            /** Format: int64 */
            oldFileCount?: number | null;
            versionLimit: components["schemas"]["ODataVersionLimitPolicy"];
            /** Format: int32 */
            majorVersionLimit?: number | null;
            enableAutoExpirationVersionTrim?: boolean | null;
            /** Format: int32 */
            expireVersionsAfterDays?: number | null;
            permissionCrawlStatus: components["schemas"]["ODataPermissionCrawlStatus"];
            allowFileArchive?: boolean | null;
        };
        ODataSiteCollectionODataCollectionResponse: {
            "@odata.context"?: string | null;
            value?: components["schemas"]["ODataSiteCollection"][] | null;
            /** Format: int64 */
            "@odata.count"?: number | null;
            "@odata.nextLink"?: string | null;
        };
        ODataTenantSettings: {
            /** Format: uuid */
            tenantId: string;
            enableAutoExpirationVersionTrim?: boolean | null;
            /** Format: int32 */
            majorVersionLimit?: number | null;
            /** Format: int32 */
            expireVersionsAfterDays?: number | null;
        };
        ODataTenantSettingsODataCollectionResponse: {
            "@odata.context"?: string | null;
            value?: components["schemas"]["ODataTenantSettings"][] | null;
            /** Format: int64 */
            "@odata.count"?: number | null;
            "@odata.nextLink"?: string | null;
        };
        ODataUser: {
            /** Format: uuid */
            id: string;
            userPrincipalName?: string | null;
            displayName?: string | null;
            department?: string | null;
            jobTitle?: string | null;
            email?: string | null;
            type: components["schemas"]["ODataUserType"];
            isEnabled: components["schemas"]["ODataUserIsEnabled"];
            /** Format: int32 */
            ownerGroupsCount: number;
            /** Format: int32 */
            memberGroupsCount: number;
            /** Format: int32 */
            ownerSitesCount: number;
            /** Format: int32 */
            memberSitesCount: number;
            /** Format: int32 */
            assignedLicensesCount: number;
            isEligibleForOneDrive: components["schemas"]["ODataEligibleForOneDrive"];
            /** Format: date-time */
            lastSignInDate?: string | null;
            /** Format: date */
            lastSharePointActivityDate?: string | null;
            /** Format: date */
            lastOneDriveActivityDate?: string | null;
            /** Format: date */
            lastTeamsActivityDate?: string | null;
            /** Format: date */
            lastMailboxActivityDate?: string | null;
            /** Format: date */
            lastCopilotActivityDate?: string | null;
            /** Format: date */
            lastM365ActivityDate?: string | null;
            /** Format: int32 */
            sharedLinksCount: number;
            ownerGroups: components["schemas"]["ODataGroup"][];
            memberGroups: components["schemas"]["ODataGroup"][];
            ownerSites: components["schemas"]["ODataSiteCollection"][];
            memberSites: components["schemas"]["ODataSiteCollection"][];
            userLicensesRelationship: components["schemas"]["ODataUserLicense"][];
            sharedLinks?: components["schemas"]["ODataSharedLink"][] | null;
        };
        /** @enum {string} */
        ODataUserIsEnabled: "deactivated" | "active";
        ODataUserLicense: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            userId: string;
            /** Format: uuid */
            licenseId: string;
            userDisplayName?: string | null;
            licenseProductName?: string | null;
            assignedBy: components["schemas"]["ODataUserLicenseAssignedBy"];
            user?: components["schemas"]["ODataUser"];
            license?: components["schemas"]["ODataLicense"];
        };
        /** @enum {string} */
        ODataUserLicenseAssignedBy: "direct" | "group" | "directAndGroup" | "unassigned";
        ODataUserLicenseODataCollectionResponse: {
            "@odata.context"?: string | null;
            value?: components["schemas"]["ODataUserLicense"][] | null;
            /** Format: int64 */
            "@odata.count"?: number | null;
            "@odata.nextLink"?: string | null;
        };
        ODataUserODataCollectionResponse: {
            "@odata.context"?: string | null;
            value?: components["schemas"]["ODataUser"][] | null;
            /** Format: int64 */
            "@odata.count"?: number | null;
            "@odata.nextLink"?: string | null;
        };
        /** @enum {string} */
        ODataUserType: "member" | "guest";
        /** @enum {string} */
        ODataVersionLimitPolicy: "unknown" | "default" | "automatic" | "custom";
        /** @enum {string} */
        ODataVersionTrimMode: "unknown" | "noExpiration" | "expireAfter" | "autoExpiration" | "other";
        ODataWorkspace: {
            /** Format: uuid */
            id: string;
            displayName: string;
            /** Format: date-time */
            lastActivity?: string | null;
            associatedWorkloads: components["schemas"]["ODataWorkspaceType"][];
            site: components["schemas"]["ODataSiteCollection"];
            group?: components["schemas"]["ODataGroup"];
            sensitivityLabel?: components["schemas"]["ODataSensitivityLabel"];
            /** Format: int64 */
            contentSizeInBytes: number;
            /** Format: int64 */
            versionStorageBytes?: number | null;
            /** Format: int64 */
            fileCount?: number | null;
            /** Format: int64 */
            storageQuotaTotalBytes?: number | null;
            /** Format: double */
            versionStorageQuotaPercent?: number | null;
            /** Format: double */
            versionStorageSitePercent?: number | null;
            links?: components["schemas"]["ODataSharedLink"][] | null;
            /** Format: int32 */
            sharedLinksCount: number;
            /** Format: int32 */
            anyoneLinksCount: number;
            /** Format: int32 */
            peopleInYourOrgLinksCount: number;
            /** Format: int32 */
            internalPeopleLinksCount: number;
            /** Format: int32 */
            externalPeopleLinksCount: number;
            inheritVersionPolicyFromTenant?: boolean | null;
            enableAutoExpirationVersionTrim?: boolean | null;
            versionLimit: components["schemas"]["ODataVersionLimitPolicy"];
            /** Format: int32 */
            majorVersionLimit?: number | null;
            /** Format: int32 */
            expireVersionsAfterDays?: number | null;
            review?: components["schemas"]["ODataWorkspaceReview"];
        };
        ODataWorkspaceODataCollectionResponse: {
            "@odata.context"?: string | null;
            value?: components["schemas"]["ODataWorkspace"][] | null;
            /** Format: int64 */
            "@odata.count"?: number | null;
            "@odata.nextLink"?: string | null;
        };
        ODataWorkspaceReview: {
            /** Format: uuid */
            id: string;
            /** Format: date-time */
            lastReviewedAt?: string | null;
            /** Format: date-time */
            lastLifecycleReviewedAt?: string | null;
            /** Format: date-time */
            lastExternalSharingReviewedAt?: string | null;
            /** Format: date-time */
            lastInternalSharingReviewedAt?: string | null;
            /** Format: date-time */
            lastGuestsReviewedAt?: string | null;
            /** Format: date-time */
            lastMembersReviewedAt?: string | null;
        };
        /** @enum {string} */
        ODataWorkspaceType: "unknown" | "group" | "sharePointSite" | "teams";
        OneGroupGuestParameter: {
            /** Format: uuid */
            guestId: string;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "OneGroupGuestParameter";
        };
        OneGroupMemberParameter: {
            /** Format: uuid */
            userId: string;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "OneGroupMemberParameter";
        };
        OneGroupOwnerParameter: {
            /** Format: uuid */
            userId: string;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "OneGroupOwnerParameter";
        };
        OrgContext: {
            promptBlock: string;
        };
        OrgContextEnvelope: {
            sgWorkspaceId: string;
            workspaceName?: string | null;
            persona?: string | null;
            answers?: components["schemas"]["QuestionnaireAnswers"] | null;
            context?: components["schemas"]["OrgContext"] | null;
            source: string;
            note?: string | null;
        };
        PaginationInfo: {
            /** Format: int32 */
            page: number;
            /** Format: int32 */
            pageSize: number;
            /** Format: int64 */
            totalUnfiltered: number;
            /** Format: int64 */
            totalFiltered: number;
        };
        PartnerProduct: {
            tier: string;
            canCreateWorkspace: boolean;
            canOpenLegacyAssessment: boolean;
        };
        PatchReviewRequest: {
            title?: string | null;
            /**
             * @description Optional custom message attached to the review. Pass `null` (or omit) to leave it unchanged.
             *     Pass an empty string ("") to clear the existing message.
             */
            customMessage?: string | null;
            reviewTypes?: components["schemas"]["ODataReviewType"][] | null;
            /** Format: int32 */
            expireDays?: number | null;
            settings?: components["schemas"]["ReviewSettingsRequest"];
        };
        PermissionAssignmentDto: {
            node: components["schemas"]["PermissionNodeDto"];
            permissionLevels: components["schemas"]["PermissionLevel"][];
            isFromSiteCollectionAdmin: boolean;
            isProvisionedForUser: boolean;
        };
        /** @enum {string} */
        PermissionLevel: "unknown" | "owner" | "write" | "read" | "limited" | "custom" | "view" | "edit" | "review" | "cantDownload" | "uploadOnly";
        PermissionNodeDto: {
            /** Format: int64 */
            id: number;
            type: components["schemas"]["PermissionNodeType"];
            displayName: string;
            /** Format: int32 */
            directChildrenCount: number;
            principalId: string | null;
            properties?: (components["schemas"]["SharePointGroupPermissionNodeProperties"] | components["schemas"]["SharedLinkPermissionNodeProperties"] | components["schemas"]["SecurityGroupPermissionNodeProperties"] | components["schemas"]["ExternalUserPermissionNodeProperties"]) | null;
        };
        PermissionNodeDtoPaginated: {
            data: components["schemas"]["PermissionNodeDto"][];
            pagination: components["schemas"]["PaginationInfo"];
        };
        PermissionNodeProperties: {
            $type: string;
        } & (components["schemas"]["SharePointGroupPermissionNodeProperties"] | components["schemas"]["SharedLinkPermissionNodeProperties"] | components["schemas"]["SecurityGroupPermissionNodeProperties"] | components["schemas"]["ExternalUserPermissionNodeProperties"]);
        /** @enum {string} */
        PermissionNodeType: "unknown" | "user" | "securityGroup" | "sharePointGroup" | "nonDirectoryObject" | "sharedLink" | "externalUser" | "systemAccount" | "deletedUser";
        PolicyDetails: {
            name: string;
            entitySet: components["schemas"]["EntitySet"];
            filter: string;
            actionType: components["schemas"]["AutomationActionType"];
            actionParameter?: (components["schemas"]["RemoveEeeuActionParameter"] | components["schemas"]["TrimSiteFileVersionsActionParameter"] | components["schemas"]["UpdateSiteFileVersionPolicyActionParameter"]) | null;
        };
        PricingResponse: {
            currency: components["schemas"]["Currency"];
            /** Format: double */
            overAllowanceStorageCostPerGb: number;
            /** Format: double */
            archivedStorageCostPerGb: number;
            licenses: components["schemas"]["LicensePricing"][];
        };
        PrimaryTenantInfoDto: {
            displayName: string;
            domain: string | null;
            /** Format: date-time */
            connectedOn: string | null;
        };
        /** @description A grant held by a principal: the reported principal itself, or a group it is a transitive member of. */
        PrincipalAccessDto: {
            principalType: components["schemas"]["PrincipalType"];
            /**
             * @description The granting principal's display name. For a Microsoft 365 group, it names the claim that granted the access,
             *     members or owners.
             */
            displayName: string;
            /**
             * @description The granting principal's key, in the format the report endpoints take as principalId, so a caller can re-run
             *     the report with this principal as the subject.
             */
            principalId: string;
            /** @description True when the grant comes from site collection admin status rather than an explicit assignment. */
            isFromSiteCollectionAdmin: boolean;
        } & (components["schemas"]["AccessGrantDto"] & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            grantedTo: "principal";
        });
        PrincipalMembershipPathNodeDto: {
            principalType: components["schemas"]["PrincipalType"];
            /**
             * @description The principal's key, in the format the report endpoints take as principalId, so a caller can re-run the
             *     report with this principal as the subject.
             */
            principalId: string;
        } & (components["schemas"]["MembershipPathNodeFieldsDto"] & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            kind: "principal";
        });
        PrincipalRemovedFromSPGroupPayload: {
            spGroupDisplayName: string;
            principalDisplayName: string;
            nodeType: components["schemas"]["PermissionNodeType"];
            siteCollectionDisplayName: string;
            siteCollectionTypes?: components["schemas"]["ResourceType"][] | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "PrincipalRemovedFromSPGroupPayload";
        };
        /**
         * @description The kinds of principal an access report can be run for.
         * @enum {string}
         */
        PrincipalType: "user" | "securityGroup" | "sharePointGroup" | "nonDirectoryObject" | "externalUser" | "systemAccount" | "deletedUser" | "microsoft365Group";
        ProblemDetails: {
            type?: string | null;
            title?: string | null;
            /** Format: int32 */
            status?: number | null;
            detail?: string | null;
            instance?: string | null;
        } & {
            [key: string]: unknown;
        };
        Products: {
            isProvidedByReseller: boolean;
            isPartnerProvisioned: boolean;
            isSharedSubscription: boolean;
            protect: components["schemas"]["ProtectProduct"];
            migrate: components["schemas"]["MigrateProduct"];
            migrationProjects: components["schemas"]["MigrationProjects"];
            partner?: components["schemas"]["PartnerProduct"];
        };
        PropertyMetadata: {
            name: string;
            type: components["schemas"]["EdmTypeKind"];
            primitiveType?: components["schemas"]["EdmPrimitiveTypeKind"];
            collectionType?: components["schemas"]["EdmTypeKind"];
            enumName?: string | null;
            displayName: string;
            description?: string | null;
            filterable: boolean;
            orderable: boolean;
            hidden: boolean;
            format: components["schemas"]["DisplayFormat"];
            crawledBy: components["schemas"]["CrawlerNames"][];
        };
        ProtectProduct: {
            hasAccess: boolean;
            canStartTrial: boolean;
            subscription?: components["schemas"]["ProtectSubscription"] | null;
        };
        ProtectProfileDto: {
            /** Format: uuid */
            workspaceId: string;
            region: components["schemas"]["ProtectRegion"] | null;
            /** Format: uuid */
            primaryTenant: string | null;
            migrateAssessmentTenants: string[];
        };
        /** @enum {string} */
        ProtectRegion: "northAmerica" | "europe";
        ProtectRegionDto: {
            /** Format: uuid */
            workspaceId: string;
            region: components["schemas"]["ProtectRegion"];
        };
        ProtectSubscription: {
            isTrial: boolean;
            /** Format: date-time */
            endDate?: string | null;
            isValid: boolean;
            state?: string | null;
            isPartnerPerk: boolean;
            isBlocked: boolean;
            /** Format: date-time */
            startDate?: string | null;
            isInGracePeriod: boolean;
            /** Format: int32 */
            gracePeriodDays: number;
            hasRemediationAddOn: boolean;
            isNfr: boolean;
        };
        QuestionnaireAnswers: {
            discoveryMethod: string;
            recentIssues: string[];
            governanceOwnership: string;
            selfServiceLatitude: string;
            copilotDeployment: string;
            complianceChallenges: string[];
            industry: string;
            whoActs: string;
            intentionalExceptions: string;
            anythingElse: string;
        };
        /** @enum {string} */
        RecommendationAction: "dismiss" | "save" | "act";
        RecommendationActionRequest: {
            action: components["schemas"]["RecommendationAction"];
            proof?: components["schemas"]["ExternalActionProofDto"];
        };
        RecommendationDto: {
            /** Format: uuid */
            id: string;
            kind: components["schemas"]["RecommendationKind"];
            status: components["schemas"]["RecommendationStatus"];
            message: string;
            insightTemplateKey: components["schemas"]["InsightV2TemplateKey"];
            severity: components["schemas"]["Severity"];
            /** Format: int32 */
            ranking: number;
            /** Format: date-time */
            statusChangedAt?: string | null;
            statusChangedBy?: components["schemas"]["InitiatorDto"];
            bulkAction?: components["schemas"]["BulkActionDetails"];
            policy?: components["schemas"]["PolicyDetails"];
            externalAction?: components["schemas"]["ExternalActionDetails"];
            review?: components["schemas"]["ReviewDetails"];
            /** Format: int64 */
            affectedItemCount: number;
        };
        /** @enum {string} */
        RecommendationKind: "none" | "bulkAction" | "policy" | "externalAction" | "review";
        /** @enum {string} */
        RecommendationRunFailureReason: "unknown" | "modelUnavailable" | "timeout" | "goalNotRelevant";
        /** @enum {string} */
        RecommendationStatus: "pending" | "saved" | "dismissed" | "acted";
        RemediationConsentState: {
            appPrincipalExists: boolean;
            missingScopes?: string[] | null;
            readonly areAllScopesConsented: boolean;
        };
        RemediationImpactItemDto: {
            templateKey: components["schemas"]["RemediationImpactTemplateKey"];
            /** Format: double */
            oldestMetricValue: number;
            /** Format: date-time */
            oldestMetricTimestamp: string;
            /** Format: double */
            currentMetricValue: number;
            /** Format: double */
            remediationValue: number;
            filter: string;
            /** Format: double */
            relativeChange?: number | null;
        };
        RemediationImpactOverviewDto: {
            remediationImpacts: components["schemas"]["RemediationImpactItemDto"][];
        };
        /** @enum {string} */
        RemediationImpactTemplateKey: "unknown" | "workspacesSharedOrgWide" | "externalSharingLinks" | "anyoneSharingLinks" | "ownerlessGroups" | "workspaceStorageUsed";
        RemoveEeeuActionParameter: {
            setGroupPrivate: boolean;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "RemoveEeeuActionParameter";
        };
        RemoveEeeuMetadata: {
            /** Format: int32 */
            publicGroupCount: number;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "RemoveEeeuMetadata";
        };
        RemoveEeeuOptions: {
            setGroupPrivate: boolean;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "RemoveEeeuOptions";
        };
        RemoveGroupGuestParameter: {
            removeGroupGuestIds: string[];
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "RemoveGroupGuestParameter";
        };
        RemoveGroupMembersSelectionParameters: components["schemas"]["GroupUserSelectionParameters"] & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "RemoveGroupMembersSelectionParameters";
        };
        RemoveGroupOwnerRequest: {
            groupId: string;
            ownerId: string;
        };
        RemoveGroupOwnersSelectionParameters: components["schemas"]["GroupUserSelectionParameters"] & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "RemoveGroupOwnersSelectionParameters";
        };
        RemoveGroupUsersSelectionParameters: components["schemas"]["GroupUserSelectionParameters"] & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "RemoveGroupUsersSelectionParameters";
        };
        RemovePrincipalFromSPGroupParameter: {
            /** Format: int64 */
            spGroupNodeId: number;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "RemovePrincipalFromSPGroupParameter";
        };
        RemoveReviewItemsRequest: {
            siteCollectionIds: string[];
        };
        RemoveSharingLinkRecipientNodesParameter: {
            /** Format: int64 */
            sharedLinkNodeId: number;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "RemoveSharingLinkRecipientNodesParameter";
        };
        RemoveSharingLinkRecipientsParameter: {
            inviteeIds: string[];
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "RemoveSharingLinkRecipientsParameter";
        };
        /** @enum {string} */
        ReportGenerationStatus: "success" | "error" | "partialSuccessInvalidSegment" | "partialSuccessInvalidOperation";
        ReportShareCreatedPayload: {
            shareName: string;
            /** Format: int32 */
            recipientCount: number;
            /** Format: date-time */
            expiresAt: string;
            reportKind?: components["schemas"]["ReportShareKind"] | null;
            recipientNames?: string[] | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "ReportShareCreatedPayload";
        };
        ReportShareDeletedPayload: {
            shareName: string;
            reportKind: components["schemas"]["ReportShareKind"];
            /** Format: int32 */
            recipientCount: number;
            recipientNames?: string[] | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "ReportShareDeletedPayload";
        };
        ReportShareExpiryChangedPayload: {
            shareName: string;
            /** Format: date-time */
            previousExpiresAt: string;
            /** Format: date-time */
            expiresAt: string;
            reportKind?: components["schemas"]["ReportShareKind"] | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "ReportShareExpiryChangedPayload";
        };
        /** @enum {string} */
        ReportShareKind: "unknown" | "pmr" | "userAccess" | "groupAccess";
        ReportShareRecipientsAddedPayload: {
            shareName: string;
            /** Format: int32 */
            recipientCount: number;
            reportKind?: components["schemas"]["ReportShareKind"] | null;
            recipientNames?: string[] | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "ReportShareRecipientsAddedPayload";
        };
        ReportShareRecipientsRemovedPayload: {
            shareName: string;
            /** Format: int32 */
            recipientCount: number;
            reportKind?: components["schemas"]["ReportShareKind"] | null;
            recipientNames?: string[] | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "ReportShareRecipientsRemovedPayload";
        };
        ReportShareRenamedPayload: {
            shareName: string;
            previousShareName: string;
            reportKind: components["schemas"]["ReportShareKind"];
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "ReportShareRenamedPayload";
        };
        ReportShareRevokedPayload: {
            shareName: string;
            reportKind?: components["schemas"]["ReportShareKind"] | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "ReportShareRevokedPayload";
        };
        ReportShareSelection: {
            query?: string | null;
            includes: string[];
            excludes: string[];
        };
        ResendReviewNotificationRequest: {
            /** Format: uuid */
            reviewId: string;
        };
        /** @enum {string} */
        ResourceType: "unknown" | "oneDrive" | "group" | "sharePointSite" | "teamsChannel" | "teams" | "redirectSite";
        /** @enum {string} */
        ReviewActivationState: "unknown" | "pending" | "inProgress" | "completed" | "failed";
        ReviewActivationStateResponse: {
            state: components["schemas"]["ReviewActivationState"];
        };
        ReviewDetails: {
            title: string;
            filter: string;
            customMessage?: string | null;
            reviewTypes: components["schemas"]["ReviewType"][];
            settings: components["schemas"]["ReviewSettings"];
            /** Format: int32 */
            expireDays: number;
        };
        ReviewItemDetailsResponse: {
            /** Format: uuid */
            id: string;
            workspaceName: string;
            associatedWorkloads: components["schemas"]["ODataWorkspaceType"][];
            /** Format: date-time */
            completedAt: string;
            completedBy?: components["schemas"]["ReviewItemReviewerResponse"] | null;
            /** Format: uuid */
            completingReviewTaskId?: string | null;
            lifecycleDecision?: components["schemas"]["ReviewItemLifecycleDecisionResponse"] | null;
            /** Format: int32 */
            sharingLinksRemovedCount: number;
            /** Format: int32 */
            membershipAccessRemovedCount: number;
            /** Format: int32 */
            sharingLinksWithRecipientsRemovedCount: number;
            /** Format: int32 */
            filesRemovedCount: number;
            /**
             * Format: int32
             * @deprecated
             */
            readonly guestAccessRemovedCount: number;
        };
        ReviewItemLifecycleDecisionResponse: {
            decision: components["schemas"]["ODataReviewAction"];
            reason: components["schemas"]["ODataReviewAnswerReason"];
            notes?: string | null;
        };
        ReviewItemReviewerResponse: {
            /** Format: uuid */
            userId: string;
            displayName?: string | null;
            email: string;
        };
        /** @enum {string} */
        ReviewLifecycleScope: "unknown" | "all" | "keepAndArchiveOnly" | "keepAndDeleteOnly";
        /** @enum {string} */
        ReviewMaterializationState: "unknown" | "pending" | "inProgress" | "completed" | "failed";
        ReviewMaterializationStateResponse: {
            state: components["schemas"]["ReviewMaterializationState"];
        };
        ReviewResponse: {
            /** Format: uuid */
            id: string;
            title: string;
            status: components["schemas"]["ODataReviewStatus"];
            reviewTypes: components["schemas"]["ODataReviewType"][];
            customMessage?: string | null;
            /** Format: date-time */
            startedAt?: string | null;
            /** Format: date-time */
            expireAt?: string | null;
            /** Format: int32 */
            expireDays: number;
            /** Format: date-time */
            completedAt?: string | null;
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            lastSavedAt: string;
            settings: components["schemas"]["ReviewSettings"];
            /** Format: int32 */
            workspaceCount: number;
            /** Format: int32 */
            reviewedWorkspaceCount: number;
            /** Format: int32 */
            inProgressWorkspaceCount: number;
        };
        ReviewSettings: {
            lifecycleScope?: components["schemas"]["ReviewLifecycleScope"];
            /** Format: int32 */
            maxFilesPerReview?: number | null;
        };
        ReviewSettingsRequest: {
            lifecycleScope?: components["schemas"]["ReviewLifecycleScope"];
            /** Format: int32 */
            maxFilesPerReview?: number | null;
        };
        /** @enum {string} */
        ReviewType: "unknown" | "lifecycle" | "externalSharing" | "guests" | "internalSharing" | "members" | "files";
        ReviewTypeCountResponse: {
            /** Format: int32 */
            count: number;
            /** Format: int32 */
            workspacesCount: number;
        };
        ReviewTypeCountsResponse: {
            lifecycle: components["schemas"]["ReviewTypeCountResponse"];
            externalSharing: components["schemas"]["ReviewTypeCountResponse"];
            internalSharing: components["schemas"]["ReviewTypeCountResponse"];
            guests: components["schemas"]["ReviewTypeCountResponse"];
            members: components["schemas"]["ReviewTypeCountResponse"];
            files: components["schemas"]["ReviewTypeCountResponse"];
        };
        ReviewsSummaryResponse: {
            /** Format: int32 */
            active: number;
            /** Format: int32 */
            draft: number;
            /** Format: int32 */
            closed: number;
        };
        SPGroupMemberItemInfo: {
            siteUrl: string;
            /** Format: int32 */
            spGroupId: number;
            spGroupDisplayName: string;
            /** Format: uuid */
            siteCollectionId: string;
            siteCollectionDisplayName: string;
            siteCollectionTypes?: components["schemas"]["ResourceType"][] | null;
            nodeType: components["schemas"]["PermissionNodeType"];
            principalDisplayName: string;
            /** Format: uuid */
            entraObjectId?: string | null;
            securityGroupClaimKind?: components["schemas"]["SecurityGroupClaimKind"];
            nonDirectoryObjectLoginName?: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "SPGroupMemberItemInfo";
        };
        SearchSensitivityLabelsParameters: {
            /**
             * Format: int32
             * @default 1
             */
            pageNumber: number;
            /**
             * Format: int32
             * @default 10
             */
            pageSize: number;
            sortOrder?: components["schemas"]["SensitivityLabelSortableFieldsSortOrder"];
        };
        SearchSensitivityLabelsResult: {
            sensitivityLabelId: string;
            name?: string | null;
            description?: string | null;
            /** Format: int32 */
            priority: number;
            contentFormats: components["schemas"]["ContentFormat"][];
            isEnabled: boolean;
            sublabels: components["schemas"]["SensitivitySublabelResult"][];
        };
        SearchSensitivityLabelsResultPaginated: {
            data: components["schemas"]["SearchSensitivityLabelsResult"][];
            pagination: components["schemas"]["PaginationInfo"];
        };
        /** @enum {string} */
        SecurityGroupClaimKind: "members" | "owners";
        SecurityGroupPermissionNodeProperties: {
            hasBeenCrawledOnce: boolean;
            isSiteDefaultMicrosoft365Group: boolean;
            groupType: components["schemas"]["SecurityGroupType"];
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "SecurityGroupPermissionNodeProperties";
        };
        /** @enum {string} */
        SecurityGroupType: "security" | "microsoft365";
        SendConsentRequestRequest: {
            /** Format: email */
            adminEmail: string;
            message?: string | null;
            origin?: components["schemas"]["ConsentOrigin"];
        };
        SendTestEmailRequest: {
            /** Format: uuid */
            reviewId: string;
            title: string;
            customMessage?: string | null;
            /** Format: int32 */
            expireDays: number;
        };
        /** @enum {string} */
        SensitivityLabelSortableFields: "name" | "priority" | "sublabels";
        SensitivityLabelSortableFieldsSortOrder: {
            field: components["schemas"]["SensitivityLabelSortableFields"];
            direction: components["schemas"]["SortDirection"];
        };
        SensitivitySublabelResult: {
            sensitivityLabelId: string;
            name?: string | null;
            description?: string | null;
            /** Format: int32 */
            priority: number;
            contentFormats: components["schemas"]["ContentFormat"][];
            isEnabled: boolean;
        };
        Session: {
            accountId: string;
            userDisplayName: string;
            firstName: string;
            email: string;
            /** Format: uuid */
            tenantId?: string | null;
            products?: components["schemas"]["Products"];
            workspaceUserRole?: string | null;
            isTrialReasonRequired: boolean;
        };
        SetProtectRegionRequest: {
            region: components["schemas"]["ProtectRegion"];
        };
        SettingState: {
            sharePointSharingCapability: components["schemas"]["TenantSharingCapabilitiesDataPoint"];
            oneDriveSharingCapability: components["schemas"]["TenantSharingCapabilitiesDataPoint"];
            sharePointSharingSettingStats: components["schemas"]["SiteSharingSettingStatsDataPoint"];
            oneDriveSharingSettingStats: components["schemas"]["SiteSharingSettingStatsDataPoint"];
            updateChannel: components["schemas"]["StringDataPoint"];
            sharingSettingsInformation: components["schemas"]["SharePointSharingSettingsDataPoint"];
            groupExpirationInformation: components["schemas"]["GroupExpirationInformationDataPoint"];
            externalCollaborationSettings: components["schemas"]["ExternalCollaborationSettingsDataPoint"];
            crossTenantAccessSettings: components["schemas"]["CrossTenantAccessSettingsDataPoint"];
            defaultAccessSettings: components["schemas"]["DefaultAccessSettingsDataPoint"];
            sitesRestrictionsSettings: components["schemas"]["SitesRestrictionsSettingsDataPoint"];
        };
        /** @enum {string} */
        Severity: "low" | "medium" | "high";
        SgWorkspace: {
            /** Format: uuid */
            id: string;
            name: string;
            isPartner: boolean;
        };
        SharePointEntityBulkRequest: {
            targets: components["schemas"]["SharePointEntityBulkTarget"][];
            action: components["schemas"]["BulkAction"];
            parameters?: (components["schemas"]["ManageGroupOwnersParameters"] | components["schemas"]["AddGroupUsersParameters"] | components["schemas"]["AddMemberToGroupOwnersSelectionParameters"] | components["schemas"]["AddOwnerToGroupMembersSelectionParameters"] | components["schemas"]["RemoveGroupUsersSelectionParameters"] | components["schemas"]["RemoveGroupMembersSelectionParameters"] | components["schemas"]["RemoveGroupOwnersSelectionParameters"] | components["schemas"]["OneGroupOwnerParameter"] | components["schemas"]["OneGroupMemberParameter"] | components["schemas"]["GroupVisibilityParameter"] | components["schemas"]["RemoveGroupGuestParameter"] | components["schemas"]["OneGroupGuestParameter"] | components["schemas"]["SharingCapabilityParameter"] | components["schemas"]["RemoveEeeuOptions"] | components["schemas"]["TrimSiteFileVersionsParameters"] | components["schemas"]["UpdateSiteFileVersionPolicyParameters"] | components["schemas"]["UpdateTenantFileVersionPolicyParameters"] | components["schemas"]["RemovePrincipalFromSPGroupParameter"] | components["schemas"]["UpdateDocumentLibraryFileVersionPolicyParameters"] | components["schemas"]["TrimDocumentLibraryFileVersionsParameters"] | components["schemas"]["RemoveSharingLinkRecipientsParameter"] | components["schemas"]["RemoveSharingLinkRecipientNodesParameter"]) | null;
        };
        SharePointEntityBulkTarget: {
            /** Format: uuid */
            siteCollectionId: string;
            path: string;
            nodePath?: number[] | null;
            isFromSiteCollectionAdmin: boolean;
        };
        SharePointEntityDto: {
            /** Format: int64 */
            id: number;
            type: components["schemas"]["SharePointEntityType"];
            displayName: string;
            url: string;
            /** Format: uuid */
            siteCollectionId: string;
            hierarchyPath: string;
            /** Format: uuid */
            permissionScopeId: string;
            hasBrokenInheritance: boolean;
            /** Format: int32 */
            childrenWithBrokenInheritanceCount: number;
            permissions: components["schemas"]["PermissionAssignmentDto"][];
        };
        SharePointEntityDtoPaginated: {
            data: components["schemas"]["SharePointEntityDto"][];
            pagination: components["schemas"]["PaginationInfo"];
        };
        /** @enum {string} */
        SharePointEntityType: "unknown" | "siteCollection" | "subsite" | "list" | "documentLibrary" | "folder" | "file";
        /** @enum {string} */
        SharePointGroupAssociatedRole: "unknown" | "custom" | "owner" | "member" | "visitor";
        SharePointGroupPermissionNodeProperties: {
            hasBeenCrawledOnce: boolean;
            associatedRole: components["schemas"]["SharePointGroupAssociatedRole"];
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "SharePointGroupPermissionNodeProperties";
        };
        SharePointSharingSettings: {
            sharingAllowedDomainList: string[];
            sharingBlockedDomainList: string[];
            sharingDomainRestrictionMode: components["schemas"]["SharingDomainRestrictionModes"];
            enabledGuestSharingGroupAllowList: boolean;
            guestSharingGroupAllowListInTenantByGroupId: string[];
            preventExternalUsersFromResharing: boolean;
            externalUserExpirationRequired: boolean;
            /** Format: int32 */
            externalUserExpireInDays: number;
            emailAttestationEnabled: boolean;
            /** Format: int32 */
            emailAttestationReAuthDays: number;
            defaultSharingLinkType: components["schemas"]["SharingLinkType"];
            defaultLinkPermission: components["schemas"]["SharingPermissionType"];
            /** Format: int32 */
            requireAnonymousLinksExpireInDays: number;
            fileAnonymousLinkType: components["schemas"]["AnonymousLinkType"];
            folderAnonymousLinkType: components["schemas"]["AnyoneFolderLinkType"];
            enableRestrictedAccessControl: boolean;
        };
        SharePointSharingSettingsDataPoint: {
            value?: components["schemas"]["SharePointSharingSettings"];
            status: components["schemas"]["DataPointStatus"];
        };
        /** @description A grant through a sharing link. A link is not a principal, so it cannot be the subject of a report. */
        SharedLinkAccessDto: {
            /**
             * Format: int64
             * @description The crawler id of the sharing link that grants the access.
             */
            sharedLinkId: number;
            linkType: components["schemas"]["SharedLinkType"];
            hasPassword: boolean;
            /**
             * Format: date-time
             * @description When the link stops working. Null when it does not expire.
             */
            expirationDate?: string | null;
            /**
             * Format: int32
             * @description How many people the link opens to, through its invited groups too, capped at 100. Null for an Anyone or
             *     organization link, which has no invitees.
             */
            peopleCount?: number | null;
            /** @description True when the real number of people exceeds the cap on peopleCount. */
            hasMorePeople: boolean;
        } & (components["schemas"]["AccessGrantDto"] & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            grantedTo: "sharedLink";
        });
        SharedLinkItemInfo: {
            /** Format: int64 */
            id: number;
            displayName: string;
            linkId: string;
            driveId: string;
            driveItemId: string;
            shareId: string;
            siteCollectionDisplayName: string;
            siteCollectionTypes: components["schemas"]["ResourceType"][];
            /** Format: uuid */
            siteCollectionId?: string | null;
            linkType: components["schemas"]["LinkType"];
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "SharedLinkItemInfo";
        };
        SharedLinkMembershipPathNodeDto: {
            linkType: components["schemas"]["SharedLinkType"];
        } & (components["schemas"]["MembershipPathNodeFieldsDto"] & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            kind: "sharedLink";
        });
        SharedLinkPermissionNodeProperties: {
            sharedLinkType: components["schemas"]["SharedLinkType"];
            hasPassword: boolean;
            /** Format: date-time */
            expirationDate?: string | null;
            /** Format: int64 */
            sharedLinkId: number;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "SharedLinkPermissionNodeProperties";
        };
        /** @enum {string} */
        SharedLinkType: "unknown" | "anyone" | "peopleInYourOrg" | "internalPeople" | "externalPeople" | "bothInternalAndExternalPeople";
        /** @enum {string} */
        SharingCapability: "unknown" | "noExternalSharing" | "newAndExistingGuests" | "anyone" | "existingGuestsOnly";
        SharingCapabilityParameter: {
            sharingCapability: components["schemas"]["SharingCapability"];
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "SharingCapabilityParameter";
        };
        /** @enum {string} */
        SharingDomainRestrictionModes: "none" | "allowList" | "blockList";
        SharingLinkDeletedPayload: {
            /** Format: int64 */
            sharedLinkId: number;
            displayName: string;
            driveId: string;
            driveItemId: string;
            shareId: string;
            siteCollectionDisplayName?: string | null;
            siteCollectionTypes?: components["schemas"]["ResourceType"][] | null;
            linkType?: components["schemas"]["LinkType"];
            permissionLevel?: components["schemas"]["LinkPermissionLevel"];
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "SharingLinkDeletedPayload";
        };
        SharingLinkRecipientItemInfo: {
            /** Format: int64 */
            sharedLinkId: number;
            displayName: string;
            driveId: string;
            driveItemId: string;
            shareId: string;
            linkType: components["schemas"]["LinkType"];
            /** Format: uuid */
            siteCollectionId?: string | null;
            siteCollectionDisplayName: string;
            siteCollectionTypes: components["schemas"]["ResourceType"][];
            inviteeId: string;
            inviteeKind: components["schemas"]["SharingLinkRecipientKind"];
            inviteeDisplayName?: string | null;
            inviteeEmail?: string | null;
            /** Format: uuid */
            inviteeObjectId?: string | null;
            inviteeIsGuest?: boolean | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "SharingLinkRecipientItemInfo";
        };
        /** @enum {string} */
        SharingLinkRecipientKind: "unknown" | "user" | "group" | "externalUser";
        SharingLinkRecipientRemovedPayload: {
            /** Format: int64 */
            sharedLinkId: number;
            displayName: string;
            driveId: string;
            driveItemId: string;
            shareId: string;
            siteCollectionDisplayName?: string | null;
            siteCollectionTypes?: components["schemas"]["ResourceType"][] | null;
            linkType?: components["schemas"]["LinkType"];
            permissionLevel?: components["schemas"]["LinkPermissionLevel"];
            inviteeId: string;
            inviteeKind: components["schemas"]["SharingLinkRecipientKind"];
            inviteeDisplayName?: string | null;
            inviteeEmail?: string | null;
            inviteeIsGuest?: boolean | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "SharingLinkRecipientRemovedPayload";
        };
        /** @enum {string} */
        SharingLinkType: "none" | "direct" | "internal" | "anonymousAccess";
        /** @enum {string} */
        SharingPermissionType: "none" | "view" | "edit";
        SharingSettingStats: {
            isPermitted: boolean;
            /** Format: int64 */
            count: number;
        };
        SiteArchivedPayload: {
            siteId: string;
            displayName: string;
            webUrl: string;
            types: components["schemas"]["ResourceType"][];
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "SiteArchivedPayload";
        };
        SiteCollectionAdminItemInfo: {
            /** Format: uuid */
            siteCollectionId: string;
            siteUrl: string;
            siteCollectionDisplayName: string;
            siteCollectionTypes?: components["schemas"]["ResourceType"][] | null;
            nodeType: components["schemas"]["PermissionNodeType"];
            principalDisplayName: string;
            /** Format: uuid */
            entraObjectId?: string | null;
            securityGroupClaimKind?: components["schemas"]["SecurityGroupClaimKind"];
            nonDirectoryObjectLoginName?: string | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "SiteCollectionAdminItemInfo";
        };
        SiteCollectionAdminRemovedPayload: {
            nodeType: components["schemas"]["PermissionNodeType"];
            principalDisplayName: string;
            siteCollectionDisplayName: string;
            siteCollectionUrl: string;
            siteCollectionTypes?: components["schemas"]["ResourceType"][] | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "SiteCollectionAdminRemovedPayload";
        };
        /** @enum {string} */
        SiteCollectionKind: "unknown" | "sharePointSite" | "oneDrive";
        SiteCollectionSharePointEntities: {
            entities: components["schemas"]["SharePointEntityDto"][];
        };
        SiteDeletedPayload: {
            siteId: string;
            displayName: string;
            webUrl: string;
            types?: components["schemas"]["ResourceType"][] | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "SiteDeletedPayload";
        };
        SiteFileVersionPolicyUpdatedPayload: {
            siteId: string;
            displayName: string;
            webUrl: string;
            types: components["schemas"]["ResourceType"][];
            inheritVersionPolicyFromTenant: boolean;
            enableAutoExpirationVersionTrim?: boolean | null;
            /** Format: int32 */
            majorVersionLimit?: number | null;
            /** Format: int32 */
            expireVersionsAfterDays?: number | null;
            versionLimit: components["schemas"]["VersionLimitPolicy"];
            applyToExistingDocumentLibraries?: boolean | null;
            /** Format: int64 */
            librariesProcessed?: number | null;
            /** Format: int64 */
            librariesFailed?: number | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "SiteFileVersionPolicyUpdatedPayload";
        };
        SiteFileVersionsTrimmedPayload: {
            siteId: string;
            displayName: string;
            webUrl: string;
            types: components["schemas"]["ResourceType"][];
            /** Format: int32 */
            targetVersionCount?: number | null;
            /** Format: int32 */
            targetVersionAgeDays?: number | null;
            /** Format: int64 */
            versionsProcessed?: number | null;
            /** Format: int64 */
            versionsDeleted?: number | null;
            /** Format: int64 */
            versionsFailed?: number | null;
            /** Format: int64 */
            storageReleasedInBytes?: number | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "SiteFileVersionsTrimmedPayload";
        };
        SiteItemInfo: {
            /** Format: uuid */
            id: string;
            siteId: string;
            webUrl: string;
            displayName: string;
            types: components["schemas"]["ResourceType"][];
            /** Format: int64 */
            contentSizeInBytes: number;
            template?: string | null;
            everyoneExceptExternalUsersAccessLevels?: components["schemas"]["AccessLevel"][] | null;
            sharingCapability?: components["schemas"]["SharingCapability"];
            group?: components["schemas"]["GroupItemInfo"];
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "SiteItemInfo";
        };
        SiteSharingCapabilityUpdatedPayload: {
            siteId: string;
            displayName: string;
            webUrl: string;
            previousSharingCapability: components["schemas"]["SharingCapability"];
            newSharingCapability: components["schemas"]["SharingCapability"];
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "SiteSharingCapabilityUpdatedPayload";
        };
        SiteSharingSettingStats: {
            organizationOnly: components["schemas"]["SharingSettingStats"];
            anyone: components["schemas"]["SharingSettingStats"];
            newAndExistingGuests: components["schemas"]["SharingSettingStats"];
            existingGuests: components["schemas"]["SharingSettingStats"];
        };
        SiteSharingSettingStatsDataPoint: {
            value?: components["schemas"]["SiteSharingSettingStats"];
            status: components["schemas"]["DataPointStatus"];
        };
        SiteStats: {
            totalSiteCount: components["schemas"]["Int32DataPoint"];
            assessedSiteCount: components["schemas"]["Int32DataPoint"];
            sharePointSiteCount: components["schemas"]["Int32DataPoint"];
            inactiveSiteCount: components["schemas"]["Int32DataPoint"];
            oneDriveCount: components["schemas"]["Int32DataPoint"];
            tenantStorage: components["schemas"]["Int64DataPoint"];
        };
        SitesRestrictionsCounts: {
            /** Format: int32 */
            restrictedAccessControlCount?: number | null;
            /** Format: int32 */
            restrictedContentDiscoveryCount?: number | null;
        };
        SitesRestrictionsCountsDataPoint: {
            value?: components["schemas"]["SitesRestrictionsCounts"];
            status: components["schemas"]["DataPointStatus"];
        };
        SitesRestrictionsSettings: {
            sitesRestrictionsCounts: components["schemas"]["SitesRestrictionsCountsDataPoint"];
        };
        SitesRestrictionsSettingsDataPoint: {
            value?: components["schemas"]["SitesRestrictionsSettings"];
            status: components["schemas"]["DataPointStatus"];
        };
        /** @enum {string} */
        SortDirection: "ascending" | "descending";
        StartRunFailedResponse: {
            failureReason: components["schemas"]["RecommendationRunFailureReason"];
        };
        StartRunResponse: {
            /** Format: uuid */
            runId: string;
        };
        StaticBulkActionDetails: {
            action: components["schemas"]["BulkAction"];
            actionParameters?: (components["schemas"]["ManageGroupOwnersParameters"] | components["schemas"]["AddGroupUsersParameters"] | components["schemas"]["AddMemberToGroupOwnersSelectionParameters"] | components["schemas"]["AddOwnerToGroupMembersSelectionParameters"] | components["schemas"]["RemoveGroupUsersSelectionParameters"] | components["schemas"]["RemoveGroupMembersSelectionParameters"] | components["schemas"]["RemoveGroupOwnersSelectionParameters"] | components["schemas"]["OneGroupOwnerParameter"] | components["schemas"]["OneGroupMemberParameter"] | components["schemas"]["GroupVisibilityParameter"] | components["schemas"]["RemoveGroupGuestParameter"] | components["schemas"]["OneGroupGuestParameter"] | components["schemas"]["SharingCapabilityParameter"] | components["schemas"]["RemoveEeeuOptions"] | components["schemas"]["TrimSiteFileVersionsParameters"] | components["schemas"]["UpdateSiteFileVersionPolicyParameters"] | components["schemas"]["UpdateTenantFileVersionPolicyParameters"] | components["schemas"]["RemovePrincipalFromSPGroupParameter"] | components["schemas"]["UpdateDocumentLibraryFileVersionPolicyParameters"] | components["schemas"]["TrimDocumentLibraryFileVersionsParameters"] | components["schemas"]["RemoveSharingLinkRecipientsParameter"] | components["schemas"]["RemoveSharingLinkRecipientNodesParameter"]) | null;
        };
        StaticExternalActionDetails: {
            actionToBeTaken?: string | null;
        };
        StaticInsightRecommendationsResponse: {
            recommendations: components["schemas"]["StaticRecommendationDto"][];
        };
        StaticPolicyDetails: {
            name: string;
            actionType: components["schemas"]["AutomationActionType"];
            actionParameter?: (components["schemas"]["RemoveEeeuActionParameter"] | components["schemas"]["TrimSiteFileVersionsActionParameter"] | components["schemas"]["UpdateSiteFileVersionPolicyActionParameter"]) | null;
        };
        StaticRecommendationDto: {
            /** Format: uuid */
            id: string;
            definitionKey: string;
            kind: components["schemas"]["RecommendationKind"];
            reason: string;
            severity: components["schemas"]["Severity"];
            /** Format: int64 */
            objectCount: number;
            entitySet: components["schemas"]["EntitySet"];
            filter: string;
            bulkAction?: components["schemas"]["StaticBulkActionDetails"] | null;
            policy?: components["schemas"]["StaticPolicyDetails"] | null;
            review?: components["schemas"]["StaticReviewDetails"] | null;
            externalAction?: components["schemas"]["StaticExternalActionDetails"] | null;
        };
        StaticReviewDetails: {
            title: string;
            customMessage?: string | null;
            reviewTypes: components["schemas"]["ReviewType"][];
            settings: components["schemas"]["ReviewSettings"];
            /** Format: int32 */
            expireDays: number;
        };
        StringDataPoint: {
            value?: string | null;
            status: components["schemas"]["DataPointStatus"];
        };
        SubmitTrialReasonRequest: {
            featureName: string;
        };
        TelemetryEventBody: {
            eventName: string;
            properties: {
                [key: string]: unknown;
            };
        };
        TenantAccessSettings: {
            tenantId: string;
            name: string;
            isInboundAccessConfigured: boolean;
            isOutboundAccessConfigured: boolean;
        };
        TenantCrawlOverviewDto: {
            /** Format: uuid */
            tenantId: string;
            displayName: string | null;
            domain: string | null;
            isPeopleAndGroupsInitializing: boolean;
            isSitesAndActivityInitializing: boolean;
            isPermissionsInitializing: boolean;
            isSharingAndExposureInitializing: boolean;
            isTenantConfigurationsInitializing: boolean;
        };
        TenantFileVersionPolicyUpdatedPayload: {
            /** Format: uuid */
            tenantId: string;
            enableAutoExpirationVersionTrim: boolean;
            /** Format: int32 */
            majorVersionLimit?: number | null;
            /** Format: int32 */
            expireVersionsAfterDays?: number | null;
            versionLimit: components["schemas"]["VersionLimitPolicy"];
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "TenantFileVersionPolicyUpdatedPayload";
        };
        TenantInfo: {
            displayName: string;
            domain?: string | null;
        };
        TenantOverview: {
            setting: components["schemas"]["SettingState"];
            group: components["schemas"]["GroupStats"];
            user: components["schemas"]["UserStats"];
            site: components["schemas"]["SiteStats"];
            sensitivityLabel: components["schemas"]["LabelStats"];
            contentSize: components["schemas"]["ContentStats"];
            link: components["schemas"]["LinkStatsDataPoint"];
            workspacesWithGuests: components["schemas"]["Int64DataPoint"];
            licenses: components["schemas"]["LicensesStatsDataPoint"];
            brokenInheritance: components["schemas"]["BrokenInheritanceStatsDataPoint"];
            workspaceActivities: components["schemas"]["WorkspaceActivitiesStatsDataPoint"];
            isPollingRequired: boolean;
        };
        TenantOverviewDto: {
            sharePointSites: components["schemas"]["Int32DataPoint"];
            groups: components["schemas"]["Int32DataPoint"];
            teams: components["schemas"]["Int32DataPoint"];
            oneDrives: components["schemas"]["Int32DataPoint"];
            activeUsers: components["schemas"]["Int32DataPoint"];
            tenantSize: components["schemas"]["Int64DataPoint"];
            isPollingRequired: boolean;
        };
        TenantSettingsItemInfo: {
            /** Format: uuid */
            tenantId: string;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "TenantSettingsItemInfo";
        };
        /** @enum {string} */
        TenantSharingCapabilities: "organizationOnly" | "anyone" | "newAndExistingGuests" | "existingGuests" | "unknownFutureValue" | "unknown";
        TenantSharingCapabilitiesDataPoint: {
            value: components["schemas"]["TenantSharingCapabilities"];
            status: components["schemas"]["DataPointStatus"];
        };
        ToggleAutomationEnabledRequest: {
            isEnabled: boolean;
            /** Format: uuid */
            expectedVersionId: string;
        };
        TrimDocumentLibraryFileVersionsParameters: {
            /** Format: int32 */
            majorVersionLimit?: number | null;
            /** Format: int32 */
            majorWithMinorVersionsLimit?: number | null;
            /** Format: int32 */
            deleteOlderThanDays?: number | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "TrimDocumentLibraryFileVersionsParameters";
        };
        TrimSiteFileVersionsActionParameter: {
            /** Format: int32 */
            majorVersionLimit?: number | null;
            /** Format: int32 */
            deleteOlderThanDays?: number | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "TrimSiteFileVersionsActionParameter";
        };
        TrimSiteFileVersionsParameters: {
            /** Format: int32 */
            majorVersionLimit?: number | null;
            /** Format: int32 */
            deleteOlderThanDays?: number | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "TrimSiteFileVersionsParameters";
        };
        UpdateAutomationRequest: {
            name: string;
            filter?: string | null;
            action: components["schemas"]["AutomationAction"];
            isEnabled: boolean;
            /** Format: uuid */
            expectedVersionId: string;
        };
        UpdateCustomReportRequest: {
            title: string;
            entitySet: components["schemas"]["ODataEntitySet"];
            properties: string[];
            filter?: string | null;
            orderBy?: string | null;
        };
        UpdateDocumentLibraryFileVersionPolicyParameters: {
            enableVersioning: boolean;
            enableMinorVersions: boolean;
            enableAutoExpirationVersionTrim: boolean;
            /** Format: int32 */
            majorVersionLimit?: number | null;
            /** Format: int32 */
            majorWithMinorVersionsLimit?: number | null;
            /** Format: int32 */
            expireVersionsAfterDays?: number | null;
            shouldTrimToNewLimit?: boolean | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "UpdateDocumentLibraryFileVersionPolicyParameters";
        };
        UpdateGroupVisibilityRequest: {
            groupId: string;
            visibilityOptions: components["schemas"]["GroupVisibilityOption"];
        };
        UpdateReportShareRequest: {
            name?: string | null;
            /** Format: date-time */
            expiresAt?: string | null;
            addedRecipientIds: string[];
            removedRecipientIds: string[];
            emailAddedRecipients?: boolean | null;
            message?: string | null;
            timeZone?: string | null;
        };
        UpdateSiteFileVersionPolicyActionParameter: {
            inheritVersionPolicyFromTenant: boolean;
            enableAutoExpirationVersionTrim?: boolean | null;
            /** Format: int32 */
            majorVersionLimit?: number | null;
            /** Format: int32 */
            expireVersionsAfterDays?: number | null;
            applyToExistingDocumentLibraries?: boolean | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "UpdateSiteFileVersionPolicyActionParameter";
        };
        UpdateSiteFileVersionPolicyParameters: {
            inheritVersionPolicyFromTenant: boolean;
            enableAutoExpirationVersionTrim?: boolean | null;
            /** Format: int32 */
            majorVersionLimit?: number | null;
            /** Format: int32 */
            expireVersionsAfterDays?: number | null;
            shouldTrimToNewLimit?: boolean | null;
            applyToExistingDocumentLibraries?: boolean | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "UpdateSiteFileVersionPolicyParameters";
        };
        UpdateTenantFileVersionPolicyParameters: {
            enableAutoExpirationVersionTrim: boolean;
            /** Format: int32 */
            majorVersionLimit?: number | null;
            /** Format: int32 */
            expireVersionsAfterDays?: number | null;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "UpdateTenantFileVersionPolicyParameters";
        };
        UserBatchResult: {
            id: string;
            displayName: string;
            jobTitle?: string | null;
            email?: string | null;
            type: components["schemas"]["UserType"];
        };
        UserItemInfo: {
            /** Format: uuid */
            id: string;
            displayName: string;
            email: string;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "UserItemInfo";
        };
        UserLicenseItemInfo: {
            /** Format: uuid */
            id: string;
            user?: components["schemas"]["UserItemInfo"];
            /** Format: uuid */
            licenseId: string;
            licenseProductName: string;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "UserLicenseItemInfo";
        };
        UserLicenseUnassignedPayload: {
            /** Format: uuid */
            userLicenseId: string;
            /** Format: uuid */
            userId?: string | null;
            userDisplayName?: string | null;
            userEmail?: string | null;
            /** Format: uuid */
            licenseId: string;
            licenseProductName: string;
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "UserLicenseUnassignedPayload";
        };
        UserStats: {
            count: components["schemas"]["Int32DataPoint"];
            inactiveCount: components["schemas"]["Int32DataPoint"];
            privilegedUsersCount: components["schemas"]["Int32DataPoint"];
            guestCount: components["schemas"]["Int32DataPoint"];
        };
        /** @enum {string} */
        UserType: "unknown" | "member" | "guest";
        /** @enum {string} */
        VersionLimitPolicy: "unknown" | "default" | "automatic" | "custom";
        WorkspaceActivitiesStats: {
            /** Format: int64 */
            workspacesCount: number;
            /** Format: int64 */
            inactiveWorkspacesCount: number;
        };
        WorkspaceActivitiesStatsDataPoint: {
            value?: components["schemas"]["WorkspaceActivitiesStats"];
            status: components["schemas"]["DataPointStatus"];
        };
        WorkspaceConsentRequest: {
            requesterDisplayName: string;
            requesterUserId: string;
            requesterEmail: string;
            workspaceName: string;
            workspaceId: string;
            consentUrl: string;
            consentOrigin: components["schemas"]["ConsentOrigin"];
        };
        WorkspaceContentSize: {
            workspaceType: components["schemas"]["ContentWorkspaceType"];
            /** Format: int64 */
            contentSize: number;
        };
        WorkspaceContentSizeListDataPoint: {
            value?: components["schemas"]["WorkspaceContentSize"][] | null;
            status: components["schemas"]["DataPointStatus"];
        };
        WorkspaceReconsentRequest: {
            requesterDisplayName: string;
            requesterUserId: string;
            requesterEmail: string;
            workspaceName: string;
            workspaceId: string;
            consentUrl: string;
            missingPermissions: string[];
        };
        WorkspaceVersionStorageChartData: {
            points: components["schemas"]["WorkspaceVersionStorageChartDataPoint"][];
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            $type: "WorkspaceVersionStorageChartData";
        };
        WorkspaceVersionStorageChartDataPoint: {
            displayName: string;
            /** Format: int64 */
            versionStorageBytes: number;
        };
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
    Login: {
        parameters: {
            query?: {
                returnUrl?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    LogOut: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetWorkspaceTenantConsentRequestToken: {
        parameters: {
            query?: {
                origin?: components["schemas"]["ConsentOrigin"];
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["EncryptedPayload"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    GetWorkspaceTenantReconsentRequestToken: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["EncryptedPayload"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    GetWorkspaceConsentStatus: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ConsentStatus"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    Get: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path: {
                automationId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataAutomation"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    Update: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path: {
                automationId: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["UpdateAutomationRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataAutomation"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    Delete: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path: {
                automationId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    Create: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["CreateAutomationRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataAutomation"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    Toggle: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path: {
                automationId: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ToggleAutomationEnabledRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataAutomation"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    ODataPlan: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ODataBulkRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["BulkOperationSummary"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string;
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    SharePointEntityPlan: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["SharePointEntityBulkRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["BulkOperationSummary"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string;
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    Start: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path: {
                bulkId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string;
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    GetSummary: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path: {
                bulkId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["BulkOperationSummary"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string;
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    GetBulkItems: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path: {
                bulkId: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["GetBulkItemsParameters"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["BulkItemDtoPaginated"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string;
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    GetAllSummaries: {
        parameters: {
            query?: {
                byStatus?: components["schemas"]["BulkOperationStatus"];
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["BulkCountSummary"][];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    SearchBulkOperations: {
        parameters: {
            query: {
                entityId: string;
                entityType: components["schemas"]["BulkItemType"];
                statuses: components["schemas"]["BulkOperationStatus"][];
                action?: components["schemas"]["BulkAction"];
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["BulkOperationDto"][];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string;
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    Dismiss: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path: {
                bulkId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string;
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    CheckArchivingEnabled: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ArchivingEnabledResponse"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    GetStatus: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RemediationConsentState"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
        };
    };
    GetConsentRequestStatus: {
        parameters: {
            query?: {
                origin?: components["schemas"]["ConsentOrigin"];
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ConsentRequestStatusResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/plain": components["schemas"]["ProblemDetails"];
                    "application/json": components["schemas"]["ProblemDetails"];
                    "text/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/plain": components["schemas"]["ProblemDetails"];
                    "application/json": components["schemas"]["ProblemDetails"];
                    "text/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/plain": components["schemas"]["ProblemDetails"];
                    "application/json": components["schemas"]["ProblemDetails"];
                    "text/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    SendConsentRequest: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["SendConsentRequestRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ConsentRequestResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/plain": components["schemas"]["ProblemDetails"];
                    "application/json": components["schemas"]["ProblemDetails"];
                    "text/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/plain": components["schemas"]["ProblemDetails"];
                    "application/json": components["schemas"]["ProblemDetails"];
                    "text/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/plain": components["schemas"]["ProblemDetails"];
                    "application/json": components["schemas"]["ProblemDetails"];
                    "text/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/plain": components["schemas"]["ProblemDetails"];
                    "application/json": components["schemas"]["ProblemDetails"];
                    "text/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/plain": components["schemas"]["ProblemDetails"];
                    "application/json": components["schemas"]["ProblemDetails"];
                    "text/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    GetCrawlingStatusesV2: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        archivedSiteCollections: components["schemas"]["CrawlingStatus"];
                        groups: components["schemas"]["CrawlingStatus"];
                        permissions: components["schemas"]["CrawlingStatus"];
                        permissionsEnrichment: components["schemas"]["CrawlingStatus"];
                        securityGroups: components["schemas"]["CrawlingStatus"];
                        sensitivityLabels: components["schemas"]["CrawlingStatus"];
                        siteActivity: components["schemas"]["CrawlingStatus"];
                        siteSettings: components["schemas"]["CrawlingStatus"];
                        tenantLicenses: components["schemas"]["CrawlingStatus"];
                        tenantSettings: components["schemas"]["CrawlingStatus"];
                        users: components["schemas"]["CrawlingStatus"];
                        sharePointGroups: components["schemas"]["CrawlingStatus"];
                    };
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    UpdateGroupVisibility: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["UpdateGroupVisibilityRequest"];
            };
        };
        responses: {
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    AddGroupOwner: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["AddGroupOwnerRequest"];
            };
        };
        responses: {
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    RemoveGroupOwner: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["RemoveGroupOwnerRequest"];
            };
        };
        responses: {
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    GetInitialCrawlOverview: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["InitialCrawlOverviewDto"];
                };
            };
        };
    };
    GetInsightCategories: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["InsightCategoriesResponse"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
        };
    };
    GetInsightCategoriesOverview: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CategoriesOverviewResponse"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
        };
    };
    GetInsightV2: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path: {
                insightTemplateKey: components["schemas"]["InsightV2TemplateKey"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["InsightV2"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetTenantOverviewV2: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TenantOverviewDto"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
        };
    };
    GetLicenses: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
        };
    };
    GetODataActivityLogs: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataActivityLogODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExportODataActivityLogs: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ExportCsvParameters"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetODataArchivedSiteCollections: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataArchivedSiteCollectionODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExportODataArchivedSiteCollections: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ExportCsvParameters"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    QueryODataArchivedSiteCollections: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": string;
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataArchivedSiteCollectionODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetODataAutomations: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataAutomationODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetODataBrokenInheritanceEntities: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataBrokenInheritanceEntityODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExportODataBrokenInheritanceEntities: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ExportCsvParameters"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetODataBulkOperations: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataBulkOperationODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExportODataBulkOperations: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ExportCsvParameters"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetODataCustomReports: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataCustomReportODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/plain": components["schemas"]["ProblemDetails"];
                    "application/json": components["schemas"]["ProblemDetails"];
                    "text/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    CreateCustomReport: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["CreateCustomReportRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataCustomReport"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    GetODataCustomReport: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataCustomReport"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    UpdateCustomReport: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["UpdateCustomReportRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataCustomReport"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    DeleteCustomReport: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    GetODataDocumentLibraries: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataDocumentLibraryODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExportODataDocumentLibraries: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ExportCsvParameters"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    QueryODataDocumentLibraries: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": string;
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataDocumentLibraryODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetODataDoNotDisturbUsers: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataDoNotDisturbUserODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExportODataDoNotDisturbUsers: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ExportCsvParameters"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetODataDoNotDisturbWorkspaces: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataDoNotDisturbWorkspaceODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExportODataDoNotDisturbWorkspaces: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ExportCsvParameters"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetODataGroupPrincipals: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataGroupPrincipalODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExportODataGroupPrincipals: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ExportCsvParameters"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    QueryODataGroupPrincipals: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": string;
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataGroupPrincipalODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetODataGroups: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataGroupODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExportODataGroups: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ExportCsvParameters"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    QueryODataGroups: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": string;
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataGroupODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetODataLicenses: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataLicenseODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExportODataLicenses: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ExportCsvParameters"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetODataMetadata: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["EntitySetMetadataModel"];
                };
            };
        };
    };
    GetODataOneDrives: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataOneDriveODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExportODataOneDrives: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ExportCsvParameters"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    QueryODataOneDrives: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": string;
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataOneDriveODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetODataReportShares: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataReportShareODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetODataReportShare: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataReportShare"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetODataReviewAnswerFiles: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataReviewAnswerFileODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExportODataReviewAnswerFiles: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ExportCsvParameters"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetODataReviewAnswerMembership: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataReviewAnswerMembershipODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExportODataReviewAnswerMembership: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ExportCsvParameters"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetODataReviewAnswerSharedLinkRecipients: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataReviewAnswerSharedLinkRecipientODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExportODataReviewAnswerSharedLinkRecipients: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ExportCsvParameters"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetODataReviewAnswerSharedLinks: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataReviewAnswerSharedLinkODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExportODataReviewAnswerSharedLinks: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ExportCsvParameters"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetODataReviewItems: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataReviewItemODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExportODataReviewItems: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ExportCsvParameters"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetODataReviewNotificationRecipients: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataReviewNotificationRecipientODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExportODataReviewNotificationRecipients: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ExportCsvParameters"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetODataReviewReviewers: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataReviewReviewerODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExportODataReviewReviewers: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ExportCsvParameters"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetODataReviews: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataReviewODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExportODataReviews: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ExportCsvParameters"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetODataReviewSelectedWorkspaces: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataReviewSelectedWorkspaceODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExportODataReviewSelectedWorkspaces: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ExportCsvParameters"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetODataSecurityGroups: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataSecurityGroupODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExportODataSecurityGroups: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ExportCsvParameters"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetODataSensitivityLabels: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataSensitivityLabelODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExportODataSensitivityLabels: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ExportCsvParameters"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetODataSharedLinkInvitations: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataSharedLinkInvitationODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExportODataSharedLinkInvitations: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ExportCsvParameters"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetODataSharedLinks: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataSharedLinkODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExportODataSharedLinks: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ExportCsvParameters"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    QueryODataSharedLinks: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": string;
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataSharedLinkODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetODataSiteCollections: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataSiteCollectionODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExportODataSiteCollections: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ExportCsvParameters"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    QueryODataSiteCollections: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": string;
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataSiteCollectionODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetODataTenantSettings: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataTenantSettingsODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExportODataTenantSettings: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ExportCsvParameters"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetODataUserLicenses: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataUserLicenseODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExportODataUserLicenses: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ExportCsvParameters"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    QueryODataUserLicenses: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": string;
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataUserLicenseODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetODataUsers: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataUserODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExportODataUsers: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ExportCsvParameters"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    QueryODataUsers: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": string;
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataUserODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetODataWorkspaces: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataWorkspaceODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExportODataWorkspaces: {
        parameters: {
            query?: {
                $filter?: string;
                $orderby?: string;
                $top?: number;
                $skip?: number;
                $select?: string;
                $expand?: string;
                $count?: boolean;
                $apply?: string;
                $search?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ExportCsvParameters"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    QueryODataWorkspaces: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": string;
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataWorkspaceODataCollectionResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ODataErrorResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    SubmitTrialReason: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["SubmitTrialReasonRequest"];
            };
        };
        responses: {
            /** @description Accepted */
            202: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetRemediationImpactOverview: {
        parameters: {
            query?: {
                timeframe?: number;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RemediationImpactOverviewDto"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
        };
    };
    GetSharePointHierarchy: {
        parameters: {
            query?: {
                siteCollectionId?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SiteCollectionSharePointEntities"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
        };
    };
    GetChildrenOfSharePointEntity: {
        parameters: {
            query?: {
                siteCollectionId?: string;
                parentEntityId?: number;
                pageNumber?: number;
                pageSize?: number;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SharePointEntityDtoPaginated"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
        };
    };
    GetChildrenPermissions: {
        parameters: {
            query?: {
                nodeId?: number;
                pageNumber?: number;
                pageSize?: number;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PermissionNodeDtoPaginated"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
        };
    };
    GetPrincipalAccessibleSiteCollections: {
        parameters: {
            query: {
                /**
                 * @description The kind of principal to report on. A securityGroup covers both of the group's claims: a Microsoft 365 group is
                 *     two permission nodes, members and owners, and each access names which one granted it.
                 */
                principalType: components["schemas"]["PrincipalType"];
                /**
                 * @description The crawler's surrogate Guid for user, securityGroup and sharePointGroup, an email address for externalUser, and
                 *     a login name for nonDirectoryObject, systemAccount and deletedUser.
                 */
                principalId: string;
                /** @description The 1-based page to return. */
                pageNumber?: number;
                /** @description The number of site collections per page. */
                pageSize?: number;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AccessibleEntityDtoPaginated"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["HttpValidationProblemDetails"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
        };
    };
    GetPrincipalAccessibleChildren: {
        parameters: {
            query: {
                /** @description The kind of principal to report on, as in getPrincipalAccessibleSiteCollections. */
                principalType: components["schemas"]["PrincipalType"];
                /** @description The principal's key, in the same format as getPrincipalAccessibleSiteCollections. */
                principalId: string;
                /** @description The site collection the parent entity belongs to. */
                siteCollectionId: string;
                /** @description The entity whose children to list: the id of a row returned by either report endpoint. */
                parentEntityId: number;
                /** @description The 1-based page to return. */
                pageNumber?: number;
                /** @description The number of children per page. */
                pageSize?: number;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AccessibleEntityDtoPaginated"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["HttpValidationProblemDetails"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
        };
    };
    GetPrincipalMembershipPaths: {
        parameters: {
            query: {
                /** @description The kind of principal to report on, as in getPrincipalAccessibleSiteCollections. */
                principalType: components["schemas"]["PrincipalType"];
                /** @description The principal's key, in the same format as getPrincipalAccessibleSiteCollections. */
                principalId: string;
                /** @description The granting node: the nodeId of an access returned by either report endpoint. */
                nodeId: number;
                /** @description The 1-based page to return. */
                pageNumber?: number;
                /** @description The number of paths per page. */
                pageSize?: number;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["MembershipPathDtoPaginated"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["HttpValidationProblemDetails"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
        };
    };
    GetPrincipalSiteCollectionAdminPaths: {
        parameters: {
            query: {
                /** @description The kind of principal to report on, as in getPrincipalAccessibleSiteCollections. */
                principalType: components["schemas"]["PrincipalType"];
                /** @description The principal's key, in the same format as getPrincipalAccessibleSiteCollections. */
                principalId: string;
                /** @description The site collection whose admins to explain. */
                siteCollectionId: string;
                /** @description The 1-based page to return. */
                pageNumber?: number;
                /** @description The number of paths per page. */
                pageSize?: number;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["MembershipPathDtoPaginated"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["HttpValidationProblemDetails"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
        };
    };
    GetPricing: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PricingResponse"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
        };
    };
    GetAll: {
        parameters: {
            query?: {
                runId?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RecommendationDto"][];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    PerformAction: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["RecommendationActionRequest"];
            };
        };
        responses: {
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string;
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    GenerateGoalSummary: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["GoalSummaryRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GoalSummaryResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["HttpValidationProblemDetails"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetOrgContext: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OrgContextEnvelope"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetCorrelatedContext: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CorrelatedContextEnvelope"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    StartRun: {
        parameters: {
            query?: {
                useLlmGeneration?: boolean;
                includeOrgContext?: boolean;
                includeCorrelatedContext?: boolean;
                includeQueryTools?: boolean;
                goalCategoryKey?: components["schemas"]["CategoryV2TemplateKey"];
                goalText?: string;
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["StartRunResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/problem+json": components["schemas"]["HttpValidationProblemDetails"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["StartRunFailedResponse"];
                };
            };
        };
    };
    GenerateReport: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["GenerateReportRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GenerateReportResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GenerateReportErrorResponse"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/plain": components["schemas"]["ProblemDetails"];
                    "application/json": components["schemas"]["ProblemDetails"];
                    "text/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    CreateReportShare: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["CreateReportShareRequest"];
            };
        };
        responses: {
            /** @description Created */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    DeleteReportShare: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path: {
                shareId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    UpdateReportShare: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path: {
                shareId: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["UpdateReportShareRequest"];
            };
        };
        responses: {
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    RevokeReportShare: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path: {
                shareId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    GetReview: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path: {
                reviewId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ReviewResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    DeleteReview: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path: {
                reviewId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    PatchReview: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path: {
                reviewId: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["PatchReviewRequest"];
            };
        };
        responses: {
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    GetReviewMaterializationState: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path: {
                reviewId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ReviewMaterializationStateResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetReviewActivationState: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path: {
                reviewId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ReviewActivationStateResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetReviewItemDetails: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path: {
                reviewId: string;
                reviewItemId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ReviewItemDetailsResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    CreateDraftReview: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["CreateDraftReviewRequest"];
            };
        };
        responses: {
            /** @description Created */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    GetAffectedWorkspaces: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["GetAffectedWorkspacesRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetAffectedWorkspacesResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    ActivateReview: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path: {
                reviewId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    CloseReview: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path: {
                reviewId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    AddReviewItems: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path: {
                reviewId: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["AddReviewItemsRequest"];
            };
        };
        responses: {
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    RemoveReviewItems: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path: {
                reviewId: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["RemoveReviewItemsRequest"];
            };
        };
        responses: {
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    GetReviewsSummary: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ReviewsSummaryResponse"];
                };
            };
        };
    };
    GetReviewTypeCounts: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path: {
                reviewId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ReviewTypeCountsResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    AddDoNotDisturbUsers: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["AddDoNotDisturbUsersRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AddDoNotDisturbUsersResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    RemoveDoNotDisturbWorkspace: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    AddDoNotDisturbWorkspaces: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["AddDoNotDisturbWorkspacesRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AddDoNotDisturbWorkspacesResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    RemoveDoNotDisturbUser: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetDoNotDisturbSummary: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DoNotDisturbSummaryResponse"];
                };
            };
        };
    };
    ResendNotification: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ResendReviewNotificationRequest"];
            };
        };
        responses: {
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    SendTestEmail: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["SendTestEmailRequest"];
            };
        };
        responses: {
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    SearchSensitivityLabels: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["SearchSensitivityLabelsParameters"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SearchSensitivityLabelsResultPaginated"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    ExportSensitivityLabels: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ExportSensitivityLabelBody"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": string;
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
        };
    };
    GetSession: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Session"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
        };
    };
    GetPrimaryTenantInfo: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PrimaryTenantInfoDto"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    DeleteSite: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["DeleteSiteRequest"];
            };
        };
        responses: {
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string;
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    GetByInsight: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path: {
                insightTemplateKey: components["schemas"]["InsightV2TemplateKey"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["StaticInsightRecommendationsResponse"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetProtectProfile: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProtectProfileDto"];
                };
            };
        };
    };
    SetRegion: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["SetProtectRegionRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProtectRegionDto"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProtectRegionDto"];
                };
            };
        };
    };
    GetWorkspaces: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetSgWorkspacesResponse"];
                };
            };
        };
    };
    TrackTelemetryEvents: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["TelemetryEventBody"][];
            };
        };
        responses: {
            /** @description Accepted */
            202: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    TrackSingleTelemetryEvent: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["TelemetryEventBody"];
            };
        };
        responses: {
            /** @description Accepted */
            202: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    GetTenantInfo: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TenantInfo"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    GetOverview: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TenantOverview"];
                };
            };
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    StartProductTrial: {
        parameters: {
            query?: never;
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
            };
            path: {
                productIdentifier: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    GetUsersBatch: {
        parameters: {
            query: {
                ids: string[];
            };
            header?: {
                /** @description Identifier of the ShareGate workspace the request targets. */
                "X-SG-Workspace-Id"?: string;
                /** @description Identifier of the Microsoft 365 tenant the request targets. Must be linked to the workspace. Send this header for tenant-scoped requests so the tenant can be resolved. */
                "X-SG-Tenant-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UserBatchResult"][];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AuthorizationFailureReasons"][];
                };
            };
        };
    };
    GetTenantConsentRequest: {
        parameters: {
            query?: {
                consentRedirectUrl?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["WorkspaceConsentRequest"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
    GetWorkspaceTenantReconsentRequest: {
        parameters: {
            query?: {
                consentRedirectUrl?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["WorkspaceReconsentRequest"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProblemDetails"];
                };
            };
        };
    };
}
type FlattenedDeepRequired<T> = {
    [K in keyof T]-?: FlattenedDeepRequired<T[K] extends unknown[] | undefined | null ? Extract<T[K], unknown[]>[number] : T[K]>;
};
type ReadonlyArray<T> = [
    Exclude<T, undefined>
] extends [
    unknown[]
] ? Readonly<Exclude<T, undefined>> : Readonly<Exclude<T, undefined>[]>;
export const accessLevelValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["AccessLevel"]> = ["unknown", "none", "read", "limited", "fullControl", "contribute", "viewOnly", "design", "custom"];
export const addGroupUsersParameters$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["AddGroupUsersParameters"]["$type"]> = ["AddGroupUsersParameters"];
export const addMemberToGroupOwnersSelectionParameters$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["AddMemberToGroupOwnersSelectionParameters"]["$type"]> = ["AddMemberToGroupOwnersSelectionParameters"];
export const addOwnerToGroupMembersSelectionParameters$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["AddOwnerToGroupMembersSelectionParameters"]["$type"]> = ["AddOwnerToGroupMembersSelectionParameters"];
export const allowInvitesFromValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["AllowInvitesFrom"]> = ["none", "adminsAndGuestInviters", "adminsGuestInvitersAndAllMembers", "everyone", "unknownFutureValue"];
export const anonymousLinkTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["AnonymousLinkType"]> = ["none", "view", "edit", "viewUpload"];
export const anyoneFolderLinkTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["AnyoneFolderLinkType"]> = ["none", "view", "viewEditUpload", "viewUpload"];
export const archiveSiteMetadata$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ArchiveSiteMetadata"]["$type"]> = ["ArchiveSiteMetadata"];
export const archivedSiteDeletedPayload$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ArchivedSiteDeletedPayload"]["$type"]> = ["ArchivedSiteDeletedPayload"];
export const authorizationFailureReasonsValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["AuthorizationFailureReasons"]> = ["unknown", "notConsented", "missingShareGateLicense", "invalidMsalToken", "missingMsalUserRole", "invalidGoogleToken", "invalidGoogleAccessStatus", "missingMsalAdminRole", "invalidSgWorkspace", "noSgWorkspaceProductAccess", "missingRemediationAddOn", "invalidSgTenant", "notWorkspaceAdmin", "noMigrationProjectsEntitlement", "noMigrationProjectsSubscription", "notAPartner", "missingPartnerCreationAddOn"];
export const automationActionTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["AutomationActionType"]> = ["deleteSharingLink", "deleteSite", "archiveSite", "removeEveryoneExceptExternalUsersPermission", "trimSiteFileVersions", "updateSiteFileVersionPolicy"];
export const bulkActionValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["BulkAction"]> = ["deleteSharingLink", "addGroupOwner", "removeGroupOwner", "manageGroupOwners", "deleteGroup", "removeGroupGuest", "updateGroupVisibility", "deleteSite", "archiveSite", "deleteArchivedSite", "unassignUserLicense", "removeEveryoneExceptExternalUsersPermission", "updateSiteSharingCapability", "trimSiteFileVersions", "updateSiteFileVersionPolicy", "updateTenantFileVersionPolicy", "addGroupMember", "manageGroupUsers", "removeGroupMember", "removeDirectPermission", "removePrincipalFromSPGroup", "updateDocumentLibraryFileVersionPolicy", "addGroupUsers", "trimDocumentLibraryFileVersions", "removeSiteCollectionAdmin", "archiveFile", "deleteFile", "removeSharingLinkRecipient"];
export const bulkItemSortableFieldsValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["BulkItemSortableFields"]> = ["none", "status", "workspaceType"];
export const bulkItemStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["BulkItemStatus"]> = ["planned", "success", "failure", "waitingOnCrawlerResponse", "attempted", "waitingOnSpoJob"];
export const bulkItemTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["BulkItemType"]> = ["user", "group", "site", "sharedLink", "oneDrive", "team", "teamsChannel", "archivedSite", "userLicense", "tenantSettings", "documentLibrary", "permission", "spGroup", "file", "sharingLinkRecipient"];
export const bulkOperationStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["BulkOperationStatus"]> = ["planned", "inProgress", "success", "failure", "partialFailure", "skipped"];
export const capabilityStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["CapabilityStatus"]> = ["unknown", "enabled", "warning", "suspended", "deleted", "lockedOut"];
export const categoryV2TemplateKeyValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["CategoryV2TemplateKey"]> = ["preventOversharing", "reduceCosts", "controlSprawl", "improveCopilotResults"];
export const consentOriginValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ConsentOrigin"]> = ["governance", "migrateAssessment"];
export const contentFormatValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ContentFormat"]> = ["unknown", "file", "email", "site", "unifiedGroup", "teamwork", "notAvailable"];
export const contentWorkspaceTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ContentWorkspaceType"]> = ["sharePointSite", "group", "teams", "oneDrive"];
export const crawlStateValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["CrawlState"]> = ["initializing", "upToDate", "pendingDeletion"];
export const crawlerNamesValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["CrawlerNames"]> = ["archivedSiteCollections", "groups", "permissions", "permissionsEnrichment", "securityGroups", "sensitivityLabels", "siteActivity", "siteSettings", "tenantLicenses", "tenantSettings", "users", "sharePointGroups"];
export const currencyValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["Currency"]> = ["usd"];
export const dataPointStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["DataPointStatus"]> = ["notInitialized", "completed", "failed"];
export const defaultAccessSettingsAppliedToValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["DefaultAccessSettingsAppliedTo"]> = ["externalUsersAndGroups", "applications", "notAvailable"];
export const defaultAccessSettingsStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["DefaultAccessSettingsStatus"]> = ["allAllowed", "someAllowed", "someBlocked", "allBlocked", "disabled", "enabled"];
export const defaultAccessSettingsTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["DefaultAccessSettingsType"]> = ["b2bCollaboration", "b2bDirectConnect", "trustSettings"];
export const directPermissionItemInfo$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["DirectPermissionItemInfo"]["$type"]> = ["DirectPermissionItemInfo"];
export const directPermissionRemovedPayload$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["DirectPermissionRemovedPayload"]["$type"]> = ["DirectPermissionRemovedPayload"];
export const displayFormatValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["DisplayFormat"]> = ["default", "filesize", "sharePointUrl", "percent"];
export const documentLibraryFileVersionPolicyUpdatedPayload$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["DocumentLibraryFileVersionPolicyUpdatedPayload"]["$type"]> = ["DocumentLibraryFileVersionPolicyUpdatedPayload"];
export const documentLibraryFileVersionsTrimmedPayload$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["DocumentLibraryFileVersionsTrimmedPayload"]["$type"]> = ["DocumentLibraryFileVersionsTrimmedPayload"];
export const edmPrimitiveTypeKindValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["EdmPrimitiveTypeKind"]> = ["none", "binary", "boolean", "byte", "dateTimeOffset", "decimal", "double", "guid", "int16", "int32", "int64", "sByte", "single", "string", "stream", "duration", "geography", "geographyPoint", "geographyLineString", "geographyPolygon", "geographyCollection", "geographyMultiPolygon", "geographyMultiLineString", "geographyMultiPoint", "geometry", "geometryPoint", "geometryLineString", "geometryPolygon", "geometryCollection", "geometryMultiPolygon", "geometryMultiLineString", "geometryMultiPoint", "date", "timeOfDay", "primitiveType"];
export const edmTypeKindValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["EdmTypeKind"]> = ["none", "primitive", "entity", "complex", "collection", "entityReference", "enum", "typeDefinition", "untyped", "path"];
export const entitySetValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["EntitySet"]> = ["licenses", "sensitivityLabels", "siteCollections", "groups", "users", "sharedLinks", "securityGroups", "brokenInheritanceEntities", "oneDrives", "workspaces", "activityLogs", "sharedLinkInvitations", "customReports", "automations", "archivedSiteCollections", "userLicenses", "dynamicGroups", "reviews", "reviewItems", "reviewTasks", "reviewAnswers", "doNotDisturbUsers", "doNotDisturbWorkspaces", "reviewNotificationRecipients", "reviewSelectedWorkspaces", "reviewUsers", "reviewReviewers", "reviewAnswerSharedLinks", "tenantSettings", "documentLibraries", "bulkOperations", "reviewAnswerMembership", "workspaceReviews", "groupPrincipals", "reviewAnswerSharedLinkRecipients", "reviewAnswerFiles", "reportShares", "reportShareRecipients"];
export const everyoneExceptExternalUsersPermissionRemovedPayload$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["EveryoneExceptExternalUsersPermissionRemovedPayload"]["$type"]> = ["EveryoneExceptExternalUsersPermissionRemovedPayload"];
export const externalUserPermissionNodeProperties$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ExternalUserPermissionNodeProperties"]["$type"]> = ["ExternalUserPermissionNodeProperties"];
export const fileArchivedPayload$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["FileArchivedPayload"]["$type"]> = ["FileArchivedPayload"];
export const fileDeletedPayload$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["FileDeletedPayload"]["$type"]> = ["FileDeletedPayload"];
export const fileItemInfo$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["FileItemInfo"]["$type"]> = ["FileItemInfo"];
export const goalSummaryStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["GoalSummaryStatus"]> = ["success", "error"];
export const groupDeletedPayload$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["GroupDeletedPayload"]["$type"]> = ["GroupDeletedPayload"];
export const groupGuestRemovedPayload$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["GroupGuestRemovedPayload"]["$type"]> = ["GroupGuestRemovedPayload"];
export const groupItemInfo$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["GroupItemInfo"]["$type"]> = ["GroupItemInfo"];
export const groupMemberAddedPayload$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["GroupMemberAddedPayload"]["$type"]> = ["GroupMemberAddedPayload"];
export const groupMemberRemovedPayload$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["GroupMemberRemovedPayload"]["$type"]> = ["GroupMemberRemovedPayload"];
export const groupOwnerAddedPayload$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["GroupOwnerAddedPayload"]["$type"]> = ["GroupOwnerAddedPayload"];
export const groupOwnerRemovedPayload$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["GroupOwnerRemovedPayload"]["$type"]> = ["GroupOwnerRemovedPayload"];
export const groupVisibilityOptionValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["GroupVisibilityOption"]> = ["unknown", "private", "public"];
export const groupVisibilityParameter$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["GroupVisibilityParameter"]["$type"]> = ["GroupVisibilityParameter"];
export const groupVisibilityStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["GroupVisibilityStatus"]> = ["unknown", "public", "private", "hiddenMembership"];
export const groupVisibilityUpdatedPayload$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["GroupVisibilityUpdatedPayload"]["$type"]> = ["GroupVisibilityUpdatedPayload"];
export const guestUserRoleIdValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["GuestUserRoleId"]> = ["user", "guestUser", "restrictedGuestUser"];
export const initiatorSourceValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["InitiatorSource"]> = ["unknown", "web", "automation", "mcp"];
export const insightDisplayTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["InsightDisplayType"]> = ["numeric", "chart", "graph"];
export const insightV2TemplateKeyValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["InsightV2TemplateKey"]> = ["unknown", "inactiveLicenses", "unallocatedLicenses", "inactiveSites", "orphanedOneDrives", "privateGroupsWithEeeuAccess", "usersWithHighAmountsOfDirectPermissions", "allWorkspacesWithEeeuAccess", "siteCollectionObjectsWithBrokenInheritance", "inactiveWorkspaces", "inactiveOnedrives", "externalGuestsWithAccessToLargeNumbersOfWorkspaces", "documentsSharedUsingPeopleInYourOrgLinks", "onedriveAccountsWithLargeAmountsOfStorage", "inactiveCopilotLicenses", "workspacesWithExcessiveVersionStorage", "oneDrivesWithHeavyVersionStorage", "anyoneLinksWithoutExpiration", "anyoneLinksWithEditAccess", "specificPeopleLinksWithExternalRecipients", "expiredSharingLinks", "sharePointSitesWithNoSensitivityLabel"];
export const isEligibleForCopilotValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["IsEligibleForCopilot"]> = ["true", "false", "unknown"];
export const libraryItemInfo$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["LibraryItemInfo"]["$type"]> = ["LibraryItemInfo"];
export const licenseChartData$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["LicenseChartData"]["$type"]> = ["LicenseChartData"];
export const licenseTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["LicenseType"]> = ["exchangeKiosk", "exchangePlan1", "exchangePlan2", "microsoft365A1", "microsoft365A3", "microsoft365A5", "microsoft365AppsForBusiness", "microsoft365AppsForEnterprise", "microsoft365BusinessBasic", "microsoft365BusinessPremium", "microsoft365BusinessStandard", "microsoft365E3", "microsoft365E5", "microsoft365F1", "microsoft365F3", "microsoftClipChamp", "microsoftPlannerPlan1", "microsoftProjectPlan3", "microsoftProjectPlan5", "microsoftTeamsEea", "microsoftTeamsEssentials", "microsoftTeamsEnterprise", "office365A1", "office365A3", "office365A5", "office365E1", "office365E3", "office365E5", "office365F3", "oneDriveForWorkAndSchoolPlan1", "oneDriveForWorkAndSchoolPlan2", "projectOnlineEssentials", "sharePointPlan1", "sharePointPlan2", "visioPlan1", "visioPlan2", "microsoftCopilot", "unknown"];
export const linkPermissionLevelValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["LinkPermissionLevel"]> = ["unknown", "view", "edit", "review", "cantDownload", "uploadOnly"];
export const linkTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["LinkType"]> = ["unknown", "anyone", "peopleInYourOrg", "internalPeople", "externalPeople", "bothInternalAndExternalPeople"];
export const manageGroupOwnersParameters$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ManageGroupOwnersParameters"]["$type"]> = ["ManageGroupOwnersParameters"];
export const managedGroupTypesValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ManagedGroupTypes"]> = ["none", "selected", "all", "notAvailable"];
export const metricTemplateKeyValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["MetricTemplateKey"]> = ["privateGroupsWithEeeuAccess", "usersWithHighAmountsOfDirectPermissions", "allWorkspacesWithEeeuAccess", "siteCollectionObjectsWithBrokenInheritance", "inactiveWorkspaces", "inactiveOnedrives", "externalGuestsWithAccessToLargeNumbersOfWorkspaces", "documentsSharedUsingPeopleInYourOrgLinks", "onedriveAccountsWithLargeAmountsOfStorage", "teamCount", "sitesWithAnyoneSharingCapability", "sitesWithNewAndExistingGuestsSharingCapability", "sitesWithExistingGuestsSharingCapability", "sitesWithOrganizationOnlySharingCapability", "oneDrivesWithAnyoneSharingCapability", "oneDrivesWithNewAndExistingGuestsSharingCapability", "oneDrivesWithExistingGuestsSharingCapability", "oneDrivesWithOrganizationOnlySharingCapability", "totalSiteCount", "sharePointSiteCount", "inactiveSiteCount", "oneDriveCount", "workspacesWithGuestsCount", "sensitivityLabelCount", "sharePointSiteContentSize", "teamsContentSize", "groupContentSize", "oneDriveContentSize", "tenantContentSize", "sitesWithRestrictedAccessControlCount", "sitesWithRestrictedContentDiscoveryCount", "nonOneDriveSiteCount", "sitesWithBrokenEntitiesCount", "totalBrokenEntityCount", "brokenSubsiteCount", "brokenDocumentLibraryCount", "brokenListCount", "totalLinkCount", "anyoneLinkCount", "peopleInOrganizationLinkCount", "internalPeopleLinkCount", "externalPeopleLinkCount", "totalPeopleLinkCount", "workspacesWithLinksCount", "inactiveUserCount", "guestCount", "userCount", "publicTeamsCount", "publicGroupsCount", "dynamicGroupCount", "groupCount", "inactiveWorkspacesCount", "securityGroupCount", "inactiveGroupCount", "workspacesSharedOrgWide", "externalSharingLinks", "anyoneSharingLinks", "ownerlessGroups", "workspaceStorageUsed", "inactiveLicensesCount", "unallocatedLicensesCount", "inactiveSitesContentSize", "orphanedOneDrivesCount", "orphanedOneDrivesContentSize", "inactiveLicensesTotalCost", "unallocatedLicensesTotalCost", "purchasedSharePointStorageLicenses", "inactiveCopilotLicensesCount", "inactiveCopilotLicensesTotalCost", "unlicensedUsersCount", "oneDrivesWithLargeContentSizeCount", "oneDrivesWithManyFilesCount", "teamsCount", "teamsLargeContentSizeCount", "teamsTooManyMembersCount", "teamsInactiveCount", "teamsOrphanedCount", "sharePointSitesWithLargeContentSizeCount", "sharePointSitesWithManyFilesCount", "sharePointSitesInactiveCount", "licensedUsersCount", "versionStorageSize", "workspacesWithExcessiveVersionStorageCount", "oneDrivesWithHeavyVersionStorageCount", "oneDriveVersionStorageSize", "anyoneLinksWithoutExpiration", "anyoneLinksWithEditAccess", "specificPeopleLinksWithExternalRecipients", "expiredSharingLinks", "sharePointSitesWithNoSensitivityLabel", "teamsWithManyFilesCount"];
export const multiplicityValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["Multiplicity"]> = ["one", "zeroOrOne", "many"];
export const oDataAccessLevelValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataAccessLevel"]> = ["unknown", "none", "read", "limited", "fullControl", "contribute", "viewOnly", "design", "custom"];
export const oDataActivityLogSourceValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataActivityLogSource"]> = ["user", "automation", "mcp", "review"];
export const oDataActivityStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataActivityStatus"]> = ["pending", "done", "failed"];
export const oDataActivityTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataActivityType"]> = ["unknown", "sharingLinkDeleted", "groupOwnerAdded", "groupOwnerRemoved", "groupDeleted", "groupGuestRemoved", "groupVisibilityUpdated", "siteDeleted", "siteArchived", "archivedSiteDeleted", "userLicenseUnassigned", "everyoneExceptExternalUsersPermissionRemoved", "siteSharingCapabilityUpdated", "siteFileVersionsTrimmed", "siteFileVersionPolicyUpdated", "tenantFileVersionPolicyUpdated", "groupMemberAdded", "groupMemberRemoved", "principalRemovedFromSPGroup", "documentLibraryFileVersionPolicyUpdated", "directPermissionRemoved", "documentLibraryFileVersionsTrimmed", "siteCollectionAdminRemoved", "reportShareCreated", "fileArchived", "fileDeleted", "sharingLinkRecipientRemoved", "reportShareRecipientsAdded", "reportShareRecipientsRemoved", "reportShareRevoked", "reportShareExpiryChanged", "reportShareRenamed", "reportShareDeleted"];
export const oDataArchiveStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataArchiveStatus"]> = ["unknown", "archiving", "archived"];
export const oDataAutomationActionTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataAutomationActionType"]> = ["deleteSharingLink", "deleteSite", "archiveSite", "removeEveryoneExceptExternalUsersPermission", "trimSiteFileVersions", "updateSiteFileVersionPolicy", "unknown"];
export const oDataAutomationEntitySetValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataAutomationEntitySet"]> = ["sharedLinks", "oneDrives", "workspaces", "unknown"];
export const oDataAutomationRunStateValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataAutomationRunState"]> = ["success", "failure", "partialFailure", "inProgress", "unknown"];
export const oDataAutomationStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataAutomationStatus"]> = ["disabled", "enabled"];
export const oDataBulkActionValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataBulkAction"]> = ["deleteSharingLink", "addGroupOwner", "removeGroupOwner", "manageGroupOwners", "deleteGroup", "removeGroupGuest", "updateGroupVisibility", "deleteSite", "archiveSite", "deleteArchivedSite", "unassignUserLicense", "removeEveryoneExceptExternalUsersPermission", "updateSiteSharingCapability", "trimSiteFileVersions", "updateSiteFileVersionPolicy", "updateTenantFileVersionPolicy", "addGroupMember", "manageGroupUsers", "removeGroupMember", "removeDirectPermission", "removePrincipalFromSPGroup", "updateDocumentLibraryFileVersionPolicy", "addGroupUsers", "trimDocumentLibraryFileVersions", "removeSiteCollectionAdmin", "archiveFile", "deleteFile", "removeSharingLinkRecipient"];
export const oDataBulkOperationStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataBulkOperationStatus"]> = ["planned", "inProgress", "success", "failure", "partialFailure", "skipped"];
export const oDataCapabilityStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataCapabilityStatus"]> = ["unknown", "enabled", "warning", "suspended", "deleted", "lockedOut"];
export const oDataContentFormatValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataContentFormat"]> = ["unknown", "file", "email", "site", "unifiedGroup", "teamwork", "notAvailable"];
export const oDataCopilotIncludedValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataCopilotIncluded"]> = ["no", "yes"];
export const oDataCustomReportSourceValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataCustomReportSource"]> = ["user", "template", "ai"];
export const oDataDocumentLibraryVersionLimitPolicyValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataDocumentLibraryVersionLimitPolicy"]> = ["unknown", "automatic", "custom", "deactivated"];
export const oDataEligibleForCopilotValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataEligibleForCopilot"]> = ["alreadyIncluded", "no", "yes"];
export const oDataEligibleForOneDriveValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataEligibleForOneDrive"]> = ["no", "yes"];
export const oDataEntitySetValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataEntitySet"]> = ["licenses", "sensitivityLabels", "siteCollections", "groups", "users", "sharedLinks", "securityGroups", "brokenInheritanceEntities", "oneDrives", "workspaces", "activityLogs", "sharedLinkInvitations", "customReports", "automations", "archivedSiteCollections", "userLicenses", "reviews", "reviewItems", "reviewTasks", "reviewAnswers", "doNotDisturbUsers", "doNotDisturbWorkspaces", "reviewNotificationRecipients", "reviewSelectedWorkspaces", "reviewUsers", "reviewReviewers", "reviewAnswerSharedLinks", "tenantSettings", "documentLibraries", "bulkOperations", "reviewAnswerMembership", "workspaceReviews", "groupPrincipals", "reviewAnswerSharedLinkRecipients", "reviewAnswerFiles", "reportShares"];
export const oDataEntityTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataEntityType"]> = ["unknown", "siteCollection", "subsite", "list", "documentLibrary", "folder", "file"];
export const oDataFileTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataFileType"]> = ["unknown", "root", "folder", "file"];
export const oDataGroupPrincipalMembershipTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataGroupPrincipalMembershipType"]> = ["assigned", "dynamic"];
export const oDataGroupPrincipalTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataGroupPrincipalType"]> = ["m365", "securityGroup", "builtIn"];
export const oDataGroupVisibilityValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataGroupVisibility"]> = ["unknown", "private", "public", "hiddenMembership"];
export const oDataInviteeKindValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataInviteeKind"]> = ["unknown", "user", "group", "externalUser"];
export const oDataLinkKindValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataLinkKind"]> = ["unknown", "direct", "organizationView", "organizationEdit", "anonymousView", "anonymousEdit", "flexible"];
export const oDataLinkPermissionLevelValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataLinkPermissionLevel"]> = ["unknown", "view", "edit", "review", "cantDownload", "uploadOnly"];
export const oDataLinkTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataLinkType"]> = ["unknown", "anyone", "peopleInYourOrg", "internalPeople", "externalPeople", "bothInternalAndExternalPeople"];
export const oDataPermissionCrawlStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataPermissionCrawlStatus"]> = ["pending", "inProgress", "done"];
export const oDataRemediationImpactTemplateKeyValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataRemediationImpactTemplateKey"]> = ["unknown", "workspacesSharedOrgWide", "externalSharingLinks", "anyoneSharingLinks", "ownerlessGroups", "workspaceStorageUsed"];
export const oDataReportShareKindValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataReportShareKind"]> = ["unknown", "pmr", "userAccess", "groupAccess"];
export const oDataReportShareStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataReportShareStatus"]> = ["active", "expired", "stopped"];
export const oDataResourceTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataResourceType"]> = ["unknown", "oneDrive", "group", "sharePointSite", "teamsChannel", "teams"];
export const oDataRestrictedAccessControlValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataRestrictedAccessControl"]> = ["disabled", "enabled"];
export const oDataRestrictedContentDiscoveryValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataRestrictedContentDiscovery"]> = ["disabled", "enabled"];
export const oDataReviewActionValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataReviewAction"]> = ["unknown", "keepWorkspace", "archiveWorkspace", "deleteWorkspace", "deleteSharedLink", "removeGuest", "deferWorkspaceToAnotherReviewer", "removeMembership", "archiveFile", "deleteFile", "removeSharedLinkRecipients"];
export const oDataReviewAnswerReasonValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataReviewAnswerReason"]> = ["unknown", "notProvided", "other", "noLongerNeeded", "securityRisk", "leftOrganization", "excessivePermissions", "sharedInError", "stillActivelyUsed", "neededForReference", "sharedWithExternalPartners", "noLongerUsed", "projectOrInitiativeEnded", "replacedWithSomethingElse", "duplicateWorkspace", "createdInError"];
export const oDataReviewItemStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataReviewItemStatus"]> = ["unknown", "pending", "completed", "inProgress"];
export const oDataReviewStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataReviewStatus"]> = ["unknown", "active", "draft", "closed", "deleting"];
export const oDataReviewTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataReviewType"]> = ["unknown", "lifecycle", "externalSharing", "guests", "internalSharing", "members", "files"];
export const oDataSensitivityLabelStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataSensitivityLabelStatus"]> = ["unknown", "disabled", "enabled"];
export const oDataSharingCapabilitiesValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataSharingCapabilities"]> = ["unknown", "noExternalSharing", "newAndExistingGuests", "anyone", "existingGuestsOnly"];
export const oDataUserIsEnabledValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataUserIsEnabled"]> = ["deactivated", "active"];
export const oDataUserLicenseAssignedByValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataUserLicenseAssignedBy"]> = ["direct", "group", "directAndGroup", "unassigned"];
export const oDataUserTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataUserType"]> = ["member", "guest"];
export const oDataVersionLimitPolicyValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataVersionLimitPolicy"]> = ["unknown", "default", "automatic", "custom"];
export const oDataVersionTrimModeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataVersionTrimMode"]> = ["unknown", "noExpiration", "expireAfter", "autoExpiration", "other"];
export const oDataWorkspaceTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ODataWorkspaceType"]> = ["unknown", "group", "sharePointSite", "teams"];
export const oneGroupGuestParameter$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["OneGroupGuestParameter"]["$type"]> = ["OneGroupGuestParameter"];
export const oneGroupMemberParameter$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["OneGroupMemberParameter"]["$type"]> = ["OneGroupMemberParameter"];
export const oneGroupOwnerParameter$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["OneGroupOwnerParameter"]["$type"]> = ["OneGroupOwnerParameter"];
export const permissionLevelValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["PermissionLevel"]> = ["unknown", "owner", "write", "read", "limited", "custom", "view", "edit", "review", "cantDownload", "uploadOnly"];
export const permissionNodeTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["PermissionNodeType"]> = ["unknown", "user", "securityGroup", "sharePointGroup", "nonDirectoryObject", "sharedLink", "externalUser", "systemAccount", "deletedUser"];
export const principalAccessDtoGrantedToValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["PrincipalAccessDto"]["grantedTo"]> = ["principal"];
export const principalMembershipPathNodeDtoKindValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["PrincipalMembershipPathNodeDto"]["kind"]> = ["principal"];
export const principalRemovedFromSPGroupPayload$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["PrincipalRemovedFromSPGroupPayload"]["$type"]> = ["PrincipalRemovedFromSPGroupPayload"];
export const principalTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["PrincipalType"]> = ["user", "securityGroup", "sharePointGroup", "nonDirectoryObject", "externalUser", "systemAccount", "deletedUser", "microsoft365Group"];
export const protectRegionValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ProtectRegion"]> = ["northAmerica", "europe"];
export const recommendationActionValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["RecommendationAction"]> = ["dismiss", "save", "act"];
export const recommendationKindValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["RecommendationKind"]> = ["none", "bulkAction", "policy", "externalAction", "review"];
export const recommendationRunFailureReasonValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["RecommendationRunFailureReason"]> = ["unknown", "modelUnavailable", "timeout", "goalNotRelevant"];
export const recommendationStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["RecommendationStatus"]> = ["pending", "saved", "dismissed", "acted"];
export const remediationImpactTemplateKeyValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["RemediationImpactTemplateKey"]> = ["unknown", "workspacesSharedOrgWide", "externalSharingLinks", "anyoneSharingLinks", "ownerlessGroups", "workspaceStorageUsed"];
export const removeEeeuActionParameter$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["RemoveEeeuActionParameter"]["$type"]> = ["RemoveEeeuActionParameter"];
export const removeEeeuMetadata$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["RemoveEeeuMetadata"]["$type"]> = ["RemoveEeeuMetadata"];
export const removeEeeuOptions$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["RemoveEeeuOptions"]["$type"]> = ["RemoveEeeuOptions"];
export const removeGroupGuestParameter$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["RemoveGroupGuestParameter"]["$type"]> = ["RemoveGroupGuestParameter"];
export const removeGroupMembersSelectionParameters$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["RemoveGroupMembersSelectionParameters"]["$type"]> = ["RemoveGroupMembersSelectionParameters"];
export const removeGroupOwnersSelectionParameters$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["RemoveGroupOwnersSelectionParameters"]["$type"]> = ["RemoveGroupOwnersSelectionParameters"];
export const removeGroupUsersSelectionParameters$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["RemoveGroupUsersSelectionParameters"]["$type"]> = ["RemoveGroupUsersSelectionParameters"];
export const removePrincipalFromSPGroupParameter$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["RemovePrincipalFromSPGroupParameter"]["$type"]> = ["RemovePrincipalFromSPGroupParameter"];
export const removeSharingLinkRecipientNodesParameter$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["RemoveSharingLinkRecipientNodesParameter"]["$type"]> = ["RemoveSharingLinkRecipientNodesParameter"];
export const removeSharingLinkRecipientsParameter$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["RemoveSharingLinkRecipientsParameter"]["$type"]> = ["RemoveSharingLinkRecipientsParameter"];
export const reportGenerationStatusValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ReportGenerationStatus"]> = ["success", "error", "partialSuccessInvalidSegment", "partialSuccessInvalidOperation"];
export const reportShareCreatedPayload$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ReportShareCreatedPayload"]["$type"]> = ["ReportShareCreatedPayload"];
export const reportShareDeletedPayload$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ReportShareDeletedPayload"]["$type"]> = ["ReportShareDeletedPayload"];
export const reportShareExpiryChangedPayload$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ReportShareExpiryChangedPayload"]["$type"]> = ["ReportShareExpiryChangedPayload"];
export const reportShareKindValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ReportShareKind"]> = ["unknown", "pmr", "userAccess", "groupAccess"];
export const reportShareRecipientsAddedPayload$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ReportShareRecipientsAddedPayload"]["$type"]> = ["ReportShareRecipientsAddedPayload"];
export const reportShareRecipientsRemovedPayload$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ReportShareRecipientsRemovedPayload"]["$type"]> = ["ReportShareRecipientsRemovedPayload"];
export const reportShareRenamedPayload$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ReportShareRenamedPayload"]["$type"]> = ["ReportShareRenamedPayload"];
export const reportShareRevokedPayload$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ReportShareRevokedPayload"]["$type"]> = ["ReportShareRevokedPayload"];
export const resourceTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ResourceType"]> = ["unknown", "oneDrive", "group", "sharePointSite", "teamsChannel", "teams", "redirectSite"];
export const reviewActivationStateValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ReviewActivationState"]> = ["unknown", "pending", "inProgress", "completed", "failed"];
export const reviewLifecycleScopeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ReviewLifecycleScope"]> = ["unknown", "all", "keepAndArchiveOnly", "keepAndDeleteOnly"];
export const reviewMaterializationStateValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ReviewMaterializationState"]> = ["unknown", "pending", "inProgress", "completed", "failed"];
export const reviewTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ReviewType"]> = ["unknown", "lifecycle", "externalSharing", "guests", "internalSharing", "members", "files"];
export const sPGroupMemberItemInfo$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SPGroupMemberItemInfo"]["$type"]> = ["SPGroupMemberItemInfo"];
export const securityGroupClaimKindValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SecurityGroupClaimKind"]> = ["members", "owners"];
export const securityGroupPermissionNodeProperties$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SecurityGroupPermissionNodeProperties"]["$type"]> = ["SecurityGroupPermissionNodeProperties"];
export const securityGroupTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SecurityGroupType"]> = ["security", "microsoft365"];
export const sensitivityLabelSortableFieldsValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SensitivityLabelSortableFields"]> = ["name", "priority", "sublabels"];
export const severityValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["Severity"]> = ["low", "medium", "high"];
export const sharePointEntityTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SharePointEntityType"]> = ["unknown", "siteCollection", "subsite", "list", "documentLibrary", "folder", "file"];
export const sharePointGroupAssociatedRoleValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SharePointGroupAssociatedRole"]> = ["unknown", "custom", "owner", "member", "visitor"];
export const sharePointGroupPermissionNodeProperties$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SharePointGroupPermissionNodeProperties"]["$type"]> = ["SharePointGroupPermissionNodeProperties"];
export const sharedLinkAccessDtoGrantedToValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SharedLinkAccessDto"]["grantedTo"]> = ["sharedLink"];
export const sharedLinkItemInfo$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SharedLinkItemInfo"]["$type"]> = ["SharedLinkItemInfo"];
export const sharedLinkMembershipPathNodeDtoKindValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SharedLinkMembershipPathNodeDto"]["kind"]> = ["sharedLink"];
export const sharedLinkPermissionNodeProperties$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SharedLinkPermissionNodeProperties"]["$type"]> = ["SharedLinkPermissionNodeProperties"];
export const sharedLinkTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SharedLinkType"]> = ["unknown", "anyone", "peopleInYourOrg", "internalPeople", "externalPeople", "bothInternalAndExternalPeople"];
export const sharingCapabilityValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SharingCapability"]> = ["unknown", "noExternalSharing", "newAndExistingGuests", "anyone", "existingGuestsOnly"];
export const sharingCapabilityParameter$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SharingCapabilityParameter"]["$type"]> = ["SharingCapabilityParameter"];
export const sharingDomainRestrictionModesValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SharingDomainRestrictionModes"]> = ["none", "allowList", "blockList"];
export const sharingLinkDeletedPayload$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SharingLinkDeletedPayload"]["$type"]> = ["SharingLinkDeletedPayload"];
export const sharingLinkRecipientItemInfo$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SharingLinkRecipientItemInfo"]["$type"]> = ["SharingLinkRecipientItemInfo"];
export const sharingLinkRecipientKindValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SharingLinkRecipientKind"]> = ["unknown", "user", "group", "externalUser"];
export const sharingLinkRecipientRemovedPayload$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SharingLinkRecipientRemovedPayload"]["$type"]> = ["SharingLinkRecipientRemovedPayload"];
export const sharingLinkTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SharingLinkType"]> = ["none", "direct", "internal", "anonymousAccess"];
export const sharingPermissionTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SharingPermissionType"]> = ["none", "view", "edit"];
export const siteArchivedPayload$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SiteArchivedPayload"]["$type"]> = ["SiteArchivedPayload"];
export const siteCollectionAdminItemInfo$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SiteCollectionAdminItemInfo"]["$type"]> = ["SiteCollectionAdminItemInfo"];
export const siteCollectionAdminRemovedPayload$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SiteCollectionAdminRemovedPayload"]["$type"]> = ["SiteCollectionAdminRemovedPayload"];
export const siteCollectionKindValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SiteCollectionKind"]> = ["unknown", "sharePointSite", "oneDrive"];
export const siteDeletedPayload$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SiteDeletedPayload"]["$type"]> = ["SiteDeletedPayload"];
export const siteFileVersionPolicyUpdatedPayload$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SiteFileVersionPolicyUpdatedPayload"]["$type"]> = ["SiteFileVersionPolicyUpdatedPayload"];
export const siteFileVersionsTrimmedPayload$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SiteFileVersionsTrimmedPayload"]["$type"]> = ["SiteFileVersionsTrimmedPayload"];
export const siteItemInfo$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SiteItemInfo"]["$type"]> = ["SiteItemInfo"];
export const siteSharingCapabilityUpdatedPayload$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SiteSharingCapabilityUpdatedPayload"]["$type"]> = ["SiteSharingCapabilityUpdatedPayload"];
export const sortDirectionValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SortDirection"]> = ["ascending", "descending"];
export const tenantFileVersionPolicyUpdatedPayload$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["TenantFileVersionPolicyUpdatedPayload"]["$type"]> = ["TenantFileVersionPolicyUpdatedPayload"];
export const tenantSettingsItemInfo$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["TenantSettingsItemInfo"]["$type"]> = ["TenantSettingsItemInfo"];
export const tenantSharingCapabilitiesValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["TenantSharingCapabilities"]> = ["organizationOnly", "anyone", "newAndExistingGuests", "existingGuests", "unknownFutureValue", "unknown"];
export const trimDocumentLibraryFileVersionsParameters$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["TrimDocumentLibraryFileVersionsParameters"]["$type"]> = ["TrimDocumentLibraryFileVersionsParameters"];
export const trimSiteFileVersionsActionParameter$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["TrimSiteFileVersionsActionParameter"]["$type"]> = ["TrimSiteFileVersionsActionParameter"];
export const trimSiteFileVersionsParameters$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["TrimSiteFileVersionsParameters"]["$type"]> = ["TrimSiteFileVersionsParameters"];
export const updateDocumentLibraryFileVersionPolicyParameters$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["UpdateDocumentLibraryFileVersionPolicyParameters"]["$type"]> = ["UpdateDocumentLibraryFileVersionPolicyParameters"];
export const updateSiteFileVersionPolicyActionParameter$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["UpdateSiteFileVersionPolicyActionParameter"]["$type"]> = ["UpdateSiteFileVersionPolicyActionParameter"];
export const updateSiteFileVersionPolicyParameters$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["UpdateSiteFileVersionPolicyParameters"]["$type"]> = ["UpdateSiteFileVersionPolicyParameters"];
export const updateTenantFileVersionPolicyParameters$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["UpdateTenantFileVersionPolicyParameters"]["$type"]> = ["UpdateTenantFileVersionPolicyParameters"];
export const userItemInfo$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["UserItemInfo"]["$type"]> = ["UserItemInfo"];
export const userLicenseItemInfo$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["UserLicenseItemInfo"]["$type"]> = ["UserLicenseItemInfo"];
export const userLicenseUnassignedPayload$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["UserLicenseUnassignedPayload"]["$type"]> = ["UserLicenseUnassignedPayload"];
export const userTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["UserType"]> = ["unknown", "member", "guest"];
export const versionLimitPolicyValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["VersionLimitPolicy"]> = ["unknown", "default", "automatic", "custom"];
export const workspaceVersionStorageChartData$typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["WorkspaceVersionStorageChartData"]["$type"]> = ["WorkspaceVersionStorageChartData"];

export type AccessDto = components["schemas"]["AccessDto"];
export type AccessGrantDto = components["schemas"]["AccessGrantDto"];
export type AccessLevel = components["schemas"]["AccessLevel"];
export type AccessSettings = components["schemas"]["AccessSettings"];
export type AccessibleEntityDto = components["schemas"]["AccessibleEntityDto"];
export type AccessibleEntityDtoPaginated = components["schemas"]["AccessibleEntityDtoPaginated"];
export type ActivityLogPayload = components["schemas"]["ActivityLogPayload"];
export type AddDoNotDisturbUsersRequest = components["schemas"]["AddDoNotDisturbUsersRequest"];
export type AddDoNotDisturbUsersResponse = components["schemas"]["AddDoNotDisturbUsersResponse"];
export type AddDoNotDisturbWorkspacesRequest = components["schemas"]["AddDoNotDisturbWorkspacesRequest"];
export type AddDoNotDisturbWorkspacesResponse = components["schemas"]["AddDoNotDisturbWorkspacesResponse"];
export type AddGroupOwnerRequest = components["schemas"]["AddGroupOwnerRequest"];
export type AddGroupUsersParameters = components["schemas"]["AddGroupUsersParameters"];
export type AddMemberToGroupOwnersSelectionParameters = components["schemas"]["AddMemberToGroupOwnersSelectionParameters"];
export type AddOwnerToGroupMembersSelectionParameters = components["schemas"]["AddOwnerToGroupMembersSelectionParameters"];
export type AddReviewItemsRequest = components["schemas"]["AddReviewItemsRequest"];
export type AllowInvitesFrom = components["schemas"]["AllowInvitesFrom"];
export type AnonymousLinkType = components["schemas"]["AnonymousLinkType"];
export type AnyoneFolderLinkType = components["schemas"]["AnyoneFolderLinkType"];
export type ArchiveSiteMetadata = components["schemas"]["ArchiveSiteMetadata"];
export type ArchivedSiteDeletedPayload = components["schemas"]["ArchivedSiteDeletedPayload"];
export type ArchivingEnabledResponse = components["schemas"]["ArchivingEnabledResponse"];
export type AuthorizationFailureReasons = components["schemas"]["AuthorizationFailureReasons"];
export type AutomationAction = components["schemas"]["AutomationAction"];
export type AutomationActionParameter = components["schemas"]["AutomationActionParameter"];
export type AutomationActionType = components["schemas"]["AutomationActionType"];
export type BooleanDataPoint = components["schemas"]["BooleanDataPoint"];
export type BooleanNullableDataPoint = components["schemas"]["BooleanNullableDataPoint"];
export type BrokenInheritanceStats = components["schemas"]["BrokenInheritanceStats"];
export type BrokenInheritanceStatsDataPoint = components["schemas"]["BrokenInheritanceStatsDataPoint"];
export type BulkAction = components["schemas"]["BulkAction"];
export type BulkActionDetails = components["schemas"]["BulkActionDetails"];
export type BulkActionParameters = components["schemas"]["BulkActionParameters"];
export type BulkCountSummary = components["schemas"]["BulkCountSummary"];
export type BulkItemDto = components["schemas"]["BulkItemDto"];
export type BulkItemDtoPaginated = components["schemas"]["BulkItemDtoPaginated"];
export type BulkItemSortableFields = components["schemas"]["BulkItemSortableFields"];
export type BulkItemSortableFieldsSortOrder = components["schemas"]["BulkItemSortableFieldsSortOrder"];
export type BulkItemStatus = components["schemas"]["BulkItemStatus"];
export type BulkItemStatusCounts = components["schemas"]["BulkItemStatusCounts"];
export type BulkItemType = components["schemas"]["BulkItemType"];
export type BulkOperationDto = components["schemas"]["BulkOperationDto"];
export type BulkOperationMetadata = components["schemas"]["BulkOperationMetadata"];
export type BulkOperationStatus = components["schemas"]["BulkOperationStatus"];
export type BulkOperationSummary = components["schemas"]["BulkOperationSummary"];
export type CapabilityStatus = components["schemas"]["CapabilityStatus"];
export type CategoriesOverviewResponse = components["schemas"]["CategoriesOverviewResponse"];
export type CategoryOverview = components["schemas"]["CategoryOverview"];
export type CategoryOverviewMetric = components["schemas"]["CategoryOverviewMetric"];
export type CategoryV2TemplateKey = components["schemas"]["CategoryV2TemplateKey"];
export type ChartData = components["schemas"]["ChartData"];
export type ConsentOrigin = components["schemas"]["ConsentOrigin"];
export type ConsentRequestResponse = components["schemas"]["ConsentRequestResponse"];
export type ConsentRequestStatusResponse = components["schemas"]["ConsentRequestStatusResponse"];
export type ConsentStatus = components["schemas"]["ConsentStatus"];
export type ContentFormat = components["schemas"]["ContentFormat"];
export type ContentStats = components["schemas"]["ContentStats"];
export type ContentWorkspaceType = components["schemas"]["ContentWorkspaceType"];
export type CorrelatedContextEnvelope = components["schemas"]["CorrelatedContextEnvelope"];
export type CrawlState = components["schemas"]["CrawlState"];
export type CrawlerNames = components["schemas"]["CrawlerNames"];
export type CrawlingStatus = components["schemas"]["CrawlingStatus"];
export type CreateAutomationRequest = components["schemas"]["CreateAutomationRequest"];
export type CreateCustomReportRequest = components["schemas"]["CreateCustomReportRequest"];
export type CreateDraftReviewRequest = components["schemas"]["CreateDraftReviewRequest"];
export type CreateReportShareRequest = components["schemas"]["CreateReportShareRequest"];
export type CrossTenantAccessSettings = components["schemas"]["CrossTenantAccessSettings"];
export type CrossTenantAccessSettingsDataPoint = components["schemas"]["CrossTenantAccessSettingsDataPoint"];
export type Currency = components["schemas"]["Currency"];
export type DataPointStatus = components["schemas"]["DataPointStatus"];
export type DefaultAccessSettings = components["schemas"]["DefaultAccessSettings"];
export type DefaultAccessSettingsAppliedTo = components["schemas"]["DefaultAccessSettingsAppliedTo"];
export type DefaultAccessSettingsDataPoint = components["schemas"]["DefaultAccessSettingsDataPoint"];
export type DefaultAccessSettingsStatus = components["schemas"]["DefaultAccessSettingsStatus"];
export type DefaultAccessSettingsType = components["schemas"]["DefaultAccessSettingsType"];
export type DeleteSiteRequest = components["schemas"]["DeleteSiteRequest"];
export type DirectPermissionItemInfo = components["schemas"]["DirectPermissionItemInfo"];
export type DirectPermissionRemovedPayload = components["schemas"]["DirectPermissionRemovedPayload"];
export type DisplayFormat = components["schemas"]["DisplayFormat"];
export type DoNotDisturbSummaryResponse = components["schemas"]["DoNotDisturbSummaryResponse"];
export type DocumentLibraryFileVersionPolicyUpdatedPayload = components["schemas"]["DocumentLibraryFileVersionPolicyUpdatedPayload"];
export type DocumentLibraryFileVersionsTrimmedPayload = components["schemas"]["DocumentLibraryFileVersionsTrimmedPayload"];
export type EdmPrimitiveTypeKind = components["schemas"]["EdmPrimitiveTypeKind"];
export type EdmTypeKind = components["schemas"]["EdmTypeKind"];
export type EncryptedPayload = components["schemas"]["EncryptedPayload"];
export type EntitySelection = components["schemas"]["EntitySelection"];
export type EntitySet = components["schemas"]["EntitySet"];
export type EntitySetEntitySetMetadata = components["schemas"]["EntitySetEntitySetMetadata"];
export type EntitySetMetadataModel = components["schemas"]["EntitySetMetadataModel"];
export type EntitySetNavigationPropertyMetadata = components["schemas"]["EntitySetNavigationPropertyMetadata"];
export type EnumMetadata = components["schemas"]["EnumMetadata"];
export type EnumValueMetadata = components["schemas"]["EnumValueMetadata"];
export type EveryoneExceptExternalUsersPermissionRemovedPayload = components["schemas"]["EveryoneExceptExternalUsersPermissionRemovedPayload"];
export type ExportCsvParameters = components["schemas"]["ExportCsvParameters"];
export type ExportSensitivityLabelBody = components["schemas"]["ExportSensitivityLabelBody"];
export type ExternalActionDetails = components["schemas"]["ExternalActionDetails"];
export type ExternalActionProofDto = components["schemas"]["ExternalActionProofDto"];
export type ExternalCollaborationSettings = components["schemas"]["ExternalCollaborationSettings"];
export type ExternalCollaborationSettingsDataPoint = components["schemas"]["ExternalCollaborationSettingsDataPoint"];
export type ExternalUserPermissionNodeProperties = components["schemas"]["ExternalUserPermissionNodeProperties"];
export type FileArchivedPayload = components["schemas"]["FileArchivedPayload"];
export type FileDeletedPayload = components["schemas"]["FileDeletedPayload"];
export type FileItemInfo = components["schemas"]["FileItemInfo"];
export type GenerateReportErrorResponse = components["schemas"]["GenerateReportErrorResponse"];
export type GenerateReportRequest = components["schemas"]["GenerateReportRequest"];
export type GenerateReportResponse = components["schemas"]["GenerateReportResponse"];
export type GetAffectedWorkspacesRequest = components["schemas"]["GetAffectedWorkspacesRequest"];
export type GetAffectedWorkspacesResponse = components["schemas"]["GetAffectedWorkspacesResponse"];
export type GetBulkItemsParameters = components["schemas"]["GetBulkItemsParameters"];
export type GetSgWorkspacesResponse = components["schemas"]["GetSgWorkspacesResponse"];
export type GoalSummaryRequest = components["schemas"]["GoalSummaryRequest"];
export type GoalSummaryResponse = components["schemas"]["GoalSummaryResponse"];
export type GoalSummaryStatus = components["schemas"]["GoalSummaryStatus"];
export type GroupDeletedPayload = components["schemas"]["GroupDeletedPayload"];
export type GroupExpirationInformation = components["schemas"]["GroupExpirationInformation"];
export type GroupExpirationInformationDataPoint = components["schemas"]["GroupExpirationInformationDataPoint"];
export type GroupGuestRemovedPayload = components["schemas"]["GroupGuestRemovedPayload"];
export type GroupItemInfo = components["schemas"]["GroupItemInfo"];
export type GroupMemberAddedPayload = components["schemas"]["GroupMemberAddedPayload"];
export type GroupMemberRemovedPayload = components["schemas"]["GroupMemberRemovedPayload"];
export type GroupOwnerAddedPayload = components["schemas"]["GroupOwnerAddedPayload"];
export type GroupOwnerRemovedPayload = components["schemas"]["GroupOwnerRemovedPayload"];
export type GroupStats = components["schemas"]["GroupStats"];
export type GroupUserSelectionParameters = components["schemas"]["GroupUserSelectionParameters"];
export type GroupVisibilityOption = components["schemas"]["GroupVisibilityOption"];
export type GroupVisibilityParameter = components["schemas"]["GroupVisibilityParameter"];
export type GroupVisibilityStatus = components["schemas"]["GroupVisibilityStatus"];
export type GroupVisibilityUpdatedPayload = components["schemas"]["GroupVisibilityUpdatedPayload"];
export type GuestUserRoleId = components["schemas"]["GuestUserRoleId"];
export type HttpValidationProblemDetails = components["schemas"]["HttpValidationProblemDetails"];
export type InitialCrawlOverviewDto = components["schemas"]["InitialCrawlOverviewDto"];
export type InitiatorDto = components["schemas"]["InitiatorDto"];
export type InitiatorSource = components["schemas"]["InitiatorSource"];
export type InsightCategoriesResponse = components["schemas"]["InsightCategoriesResponse"];
export type InsightCategorySummary = components["schemas"]["InsightCategorySummary"];
export type InsightChart = components["schemas"]["InsightChart"];
export type InsightDisplayType = components["schemas"]["InsightDisplayType"];
export type InsightMetric = components["schemas"]["InsightMetric"];
export type InsightV2 = components["schemas"]["InsightV2"];
export type InsightV2TemplateKey = components["schemas"]["InsightV2TemplateKey"];
export type Int32DataPoint = components["schemas"]["Int32DataPoint"];
export type Int64DataPoint = components["schemas"]["Int64DataPoint"];
export type IsEligibleForCopilot = components["schemas"]["IsEligibleForCopilot"];
export type ItemInfo = components["schemas"]["ItemInfo"];
export type ItemSummary = components["schemas"]["ItemSummary"];
export type LabelStats = components["schemas"]["LabelStats"];
export type LibraryItemInfo = components["schemas"]["LibraryItemInfo"];
export type LicenseChartData = components["schemas"]["LicenseChartData"];
export type LicenseChartDataPoint = components["schemas"]["LicenseChartDataPoint"];
export type LicensePricing = components["schemas"]["LicensePricing"];
export type LicenseStats = components["schemas"]["LicenseStats"];
export type LicenseType = components["schemas"]["LicenseType"];
export type LicensesStats = components["schemas"]["LicensesStats"];
export type LicensesStatsDataPoint = components["schemas"]["LicensesStatsDataPoint"];
export type LinkStats = components["schemas"]["LinkStats"];
export type LinkStatsDataPoint = components["schemas"]["LinkStatsDataPoint"];
export type LinkPermissionLevel = components["schemas"]["LinkPermissionLevel"];
export type LinkType = components["schemas"]["LinkType"];
export type ManageGroupOwnersParameters = components["schemas"]["ManageGroupOwnersParameters"];
export type ManagedGroupTypes = components["schemas"]["ManagedGroupTypes"];
export type Measurement = components["schemas"]["Measurement"];
export type MembershipPathDto = components["schemas"]["MembershipPathDto"];
export type MembershipPathDtoPaginated = components["schemas"]["MembershipPathDtoPaginated"];
export type MembershipPathNodeDto = components["schemas"]["MembershipPathNodeDto"];
export type MembershipPathNodeFieldsDto = components["schemas"]["MembershipPathNodeFieldsDto"];
export type MetricTemplateKey = components["schemas"]["MetricTemplateKey"];
export type MigrateProduct = components["schemas"]["MigrateProduct"];
export type MigrateSubscription = components["schemas"]["MigrateSubscription"];
export type MigrationProjectSubscription = components["schemas"]["MigrationProjectSubscription"];
export type MigrationProjects = components["schemas"]["MigrationProjects"];
export type Multiplicity = components["schemas"]["Multiplicity"];
export type ODataAccessLevel = components["schemas"]["ODataAccessLevel"];
export type ODataActivityLog = components["schemas"]["ODataActivityLog"];
export type ODataActivityLogMetadata = components["schemas"]["ODataActivityLogMetadata"];
export type ODataActivityLogODataCollectionResponse = components["schemas"]["ODataActivityLogODataCollectionResponse"];
export type ODataActivityLogSource = components["schemas"]["ODataActivityLogSource"];
export type ODataActivityStatus = components["schemas"]["ODataActivityStatus"];
export type ODataActivityType = components["schemas"]["ODataActivityType"];
export type ODataArchiveStatus = components["schemas"]["ODataArchiveStatus"];
export type ODataArchivedSiteCollection = components["schemas"]["ODataArchivedSiteCollection"];
export type ODataArchivedSiteCollectionODataCollectionResponse = components["schemas"]["ODataArchivedSiteCollectionODataCollectionResponse"];
export type ODataAutomation = components["schemas"]["ODataAutomation"];
export type ODataAutomationActionType = components["schemas"]["ODataAutomationActionType"];
export type ODataAutomationEntitySet = components["schemas"]["ODataAutomationEntitySet"];
export type ODataAutomationODataCollectionResponse = components["schemas"]["ODataAutomationODataCollectionResponse"];
export type ODataAutomationRunState = components["schemas"]["ODataAutomationRunState"];
export type ODataAutomationStatus = components["schemas"]["ODataAutomationStatus"];
export type ODataBrokenInheritanceEntity = components["schemas"]["ODataBrokenInheritanceEntity"];
export type ODataBrokenInheritanceEntityODataCollectionResponse = components["schemas"]["ODataBrokenInheritanceEntityODataCollectionResponse"];
export type ODataBulkAction = components["schemas"]["ODataBulkAction"];
export type ODataBulkOperation = components["schemas"]["ODataBulkOperation"];
export type ODataBulkOperationODataCollectionResponse = components["schemas"]["ODataBulkOperationODataCollectionResponse"];
export type ODataBulkOperationStatus = components["schemas"]["ODataBulkOperationStatus"];
export type ODataBulkRequest = components["schemas"]["ODataBulkRequest"];
export type ODataCapabilityStatus = components["schemas"]["ODataCapabilityStatus"];
export type ODataContentFormat = components["schemas"]["ODataContentFormat"];
export type ODataCopilotIncluded = components["schemas"]["ODataCopilotIncluded"];
export type ODataCustomReport = components["schemas"]["ODataCustomReport"];
export type ODataCustomReportODataCollectionResponse = components["schemas"]["ODataCustomReportODataCollectionResponse"];
export type ODataCustomReportSource = components["schemas"]["ODataCustomReportSource"];
export type ODataDoNotDisturbUser = components["schemas"]["ODataDoNotDisturbUser"];
export type ODataDoNotDisturbUserODataCollectionResponse = components["schemas"]["ODataDoNotDisturbUserODataCollectionResponse"];
export type ODataDoNotDisturbWorkspace = components["schemas"]["ODataDoNotDisturbWorkspace"];
export type ODataDoNotDisturbWorkspaceODataCollectionResponse = components["schemas"]["ODataDoNotDisturbWorkspaceODataCollectionResponse"];
export type ODataDocumentLibrary = components["schemas"]["ODataDocumentLibrary"];
export type ODataDocumentLibraryODataCollectionResponse = components["schemas"]["ODataDocumentLibraryODataCollectionResponse"];
export type ODataDocumentLibraryVersionLimitPolicy = components["schemas"]["ODataDocumentLibraryVersionLimitPolicy"];
export type ODataEligibleForCopilot = components["schemas"]["ODataEligibleForCopilot"];
export type ODataEligibleForOneDrive = components["schemas"]["ODataEligibleForOneDrive"];
export type ODataEntitySet = components["schemas"]["ODataEntitySet"];
export type ODataEntityType = components["schemas"]["ODataEntityType"];
export type ODataError = components["schemas"]["ODataError"];
export type ODataErrorResponse = components["schemas"]["ODataErrorResponse"];
export type ODataFileType = components["schemas"]["ODataFileType"];
export type ODataGroup = components["schemas"]["ODataGroup"];
export type ODataGroupODataCollectionResponse = components["schemas"]["ODataGroupODataCollectionResponse"];
export type ODataGroupPrincipal = components["schemas"]["ODataGroupPrincipal"];
export type ODataGroupPrincipalMembershipType = components["schemas"]["ODataGroupPrincipalMembershipType"];
export type ODataGroupPrincipalODataCollectionResponse = components["schemas"]["ODataGroupPrincipalODataCollectionResponse"];
export type ODataGroupPrincipalType = components["schemas"]["ODataGroupPrincipalType"];
export type ODataGroupVisibility = components["schemas"]["ODataGroupVisibility"];
export type ODataInviteeKind = components["schemas"]["ODataInviteeKind"];
export type ODataLicense = components["schemas"]["ODataLicense"];
export type ODataLicenseODataCollectionResponse = components["schemas"]["ODataLicenseODataCollectionResponse"];
export type ODataLinkKind = components["schemas"]["ODataLinkKind"];
export type ODataLinkPermissionLevel = components["schemas"]["ODataLinkPermissionLevel"];
export type ODataLinkType = components["schemas"]["ODataLinkType"];
export type ODataOneDrive = components["schemas"]["ODataOneDrive"];
export type ODataOneDriveODataCollectionResponse = components["schemas"]["ODataOneDriveODataCollectionResponse"];
export type ODataPermissionCrawlStatus = components["schemas"]["ODataPermissionCrawlStatus"];
export type ODataRemediationImpactTemplateKey = components["schemas"]["ODataRemediationImpactTemplateKey"];
export type ODataReportShare = components["schemas"]["ODataReportShare"];
export type ODataReportShareKind = components["schemas"]["ODataReportShareKind"];
export type ODataReportShareODataCollectionResponse = components["schemas"]["ODataReportShareODataCollectionResponse"];
export type ODataReportShareRecipient = components["schemas"]["ODataReportShareRecipient"];
export type ODataReportShareStatus = components["schemas"]["ODataReportShareStatus"];
export type ODataResourceType = components["schemas"]["ODataResourceType"];
export type ODataRestrictedAccessControl = components["schemas"]["ODataRestrictedAccessControl"];
export type ODataRestrictedContentDiscovery = components["schemas"]["ODataRestrictedContentDiscovery"];
export type ODataReview = components["schemas"]["ODataReview"];
export type ODataReviewAction = components["schemas"]["ODataReviewAction"];
export type ODataReviewAnswerFile = components["schemas"]["ODataReviewAnswerFile"];
export type ODataReviewAnswerFileODataCollectionResponse = components["schemas"]["ODataReviewAnswerFileODataCollectionResponse"];
export type ODataReviewAnswerMembership = components["schemas"]["ODataReviewAnswerMembership"];
export type ODataReviewAnswerMembershipODataCollectionResponse = components["schemas"]["ODataReviewAnswerMembershipODataCollectionResponse"];
export type ODataReviewAnswerReason = components["schemas"]["ODataReviewAnswerReason"];
export type ODataReviewAnswerSharedLink = components["schemas"]["ODataReviewAnswerSharedLink"];
export type ODataReviewAnswerSharedLinkODataCollectionResponse = components["schemas"]["ODataReviewAnswerSharedLinkODataCollectionResponse"];
export type ODataReviewAnswerSharedLinkRecipient = components["schemas"]["ODataReviewAnswerSharedLinkRecipient"];
export type ODataReviewAnswerSharedLinkRecipientODataCollectionResponse = components["schemas"]["ODataReviewAnswerSharedLinkRecipientODataCollectionResponse"];
export type ODataReviewItem = components["schemas"]["ODataReviewItem"];
export type ODataReviewItemODataCollectionResponse = components["schemas"]["ODataReviewItemODataCollectionResponse"];
export type ODataReviewItemStatus = components["schemas"]["ODataReviewItemStatus"];
export type ODataReviewNotificationRecipient = components["schemas"]["ODataReviewNotificationRecipient"];
export type ODataReviewNotificationRecipientODataCollectionResponse = components["schemas"]["ODataReviewNotificationRecipientODataCollectionResponse"];
export type ODataReviewODataCollectionResponse = components["schemas"]["ODataReviewODataCollectionResponse"];
export type ODataReviewReviewer = components["schemas"]["ODataReviewReviewer"];
export type ODataReviewReviewerODataCollectionResponse = components["schemas"]["ODataReviewReviewerODataCollectionResponse"];
export type ODataReviewSelectedWorkspace = components["schemas"]["ODataReviewSelectedWorkspace"];
export type ODataReviewSelectedWorkspaceODataCollectionResponse = components["schemas"]["ODataReviewSelectedWorkspaceODataCollectionResponse"];
export type ODataReviewStatus = components["schemas"]["ODataReviewStatus"];
export type ODataReviewType = components["schemas"]["ODataReviewType"];
export type ODataReviewUser = components["schemas"]["ODataReviewUser"];
export type ODataSecurityGroup = components["schemas"]["ODataSecurityGroup"];
export type ODataSecurityGroupODataCollectionResponse = components["schemas"]["ODataSecurityGroupODataCollectionResponse"];
export type ODataSensitivityLabel = components["schemas"]["ODataSensitivityLabel"];
export type ODataSensitivityLabelODataCollectionResponse = components["schemas"]["ODataSensitivityLabelODataCollectionResponse"];
export type ODataSensitivityLabelStatus = components["schemas"]["ODataSensitivityLabelStatus"];
export type ODataSharedLink = components["schemas"]["ODataSharedLink"];
export type ODataSharedLinkInvitation = components["schemas"]["ODataSharedLinkInvitation"];
export type ODataSharedLinkInvitationODataCollectionResponse = components["schemas"]["ODataSharedLinkInvitationODataCollectionResponse"];
export type ODataSharedLinkODataCollectionResponse = components["schemas"]["ODataSharedLinkODataCollectionResponse"];
export type ODataSharingCapabilities = components["schemas"]["ODataSharingCapabilities"];
export type ODataSiteCollection = components["schemas"]["ODataSiteCollection"];
export type ODataSiteCollectionODataCollectionResponse = components["schemas"]["ODataSiteCollectionODataCollectionResponse"];
export type ODataTenantSettings = components["schemas"]["ODataTenantSettings"];
export type ODataTenantSettingsODataCollectionResponse = components["schemas"]["ODataTenantSettingsODataCollectionResponse"];
export type ODataUser = components["schemas"]["ODataUser"];
export type ODataUserIsEnabled = components["schemas"]["ODataUserIsEnabled"];
export type ODataUserLicense = components["schemas"]["ODataUserLicense"];
export type ODataUserLicenseAssignedBy = components["schemas"]["ODataUserLicenseAssignedBy"];
export type ODataUserLicenseODataCollectionResponse = components["schemas"]["ODataUserLicenseODataCollectionResponse"];
export type ODataUserODataCollectionResponse = components["schemas"]["ODataUserODataCollectionResponse"];
export type ODataUserType = components["schemas"]["ODataUserType"];
export type ODataVersionLimitPolicy = components["schemas"]["ODataVersionLimitPolicy"];
export type ODataVersionTrimMode = components["schemas"]["ODataVersionTrimMode"];
export type ODataWorkspace = components["schemas"]["ODataWorkspace"];
export type ODataWorkspaceODataCollectionResponse = components["schemas"]["ODataWorkspaceODataCollectionResponse"];
export type ODataWorkspaceReview = components["schemas"]["ODataWorkspaceReview"];
export type ODataWorkspaceType = components["schemas"]["ODataWorkspaceType"];
export type OneGroupGuestParameter = components["schemas"]["OneGroupGuestParameter"];
export type OneGroupMemberParameter = components["schemas"]["OneGroupMemberParameter"];
export type OneGroupOwnerParameter = components["schemas"]["OneGroupOwnerParameter"];
export type OrgContext = components["schemas"]["OrgContext"];
export type OrgContextEnvelope = components["schemas"]["OrgContextEnvelope"];
export type PaginationInfo = components["schemas"]["PaginationInfo"];
export type PartnerProduct = components["schemas"]["PartnerProduct"];
export type PatchReviewRequest = components["schemas"]["PatchReviewRequest"];
export type PermissionAssignmentDto = components["schemas"]["PermissionAssignmentDto"];
export type PermissionLevel = components["schemas"]["PermissionLevel"];
export type PermissionNodeDto = components["schemas"]["PermissionNodeDto"];
export type PermissionNodeDtoPaginated = components["schemas"]["PermissionNodeDtoPaginated"];
export type PermissionNodeProperties = components["schemas"]["PermissionNodeProperties"];
export type PermissionNodeType = components["schemas"]["PermissionNodeType"];
export type PolicyDetails = components["schemas"]["PolicyDetails"];
export type PricingResponse = components["schemas"]["PricingResponse"];
export type PrimaryTenantInfoDto = components["schemas"]["PrimaryTenantInfoDto"];
export type PrincipalAccessDto = components["schemas"]["PrincipalAccessDto"];
export type PrincipalMembershipPathNodeDto = components["schemas"]["PrincipalMembershipPathNodeDto"];
export type PrincipalRemovedFromSPGroupPayload = components["schemas"]["PrincipalRemovedFromSPGroupPayload"];
export type PrincipalType = components["schemas"]["PrincipalType"];
export type ProblemDetails = components["schemas"]["ProblemDetails"];
export type Products = components["schemas"]["Products"];
export type PropertyMetadata = components["schemas"]["PropertyMetadata"];
export type ProtectProduct = components["schemas"]["ProtectProduct"];
export type ProtectProfileDto = components["schemas"]["ProtectProfileDto"];
export type ProtectRegion = components["schemas"]["ProtectRegion"];
export type ProtectRegionDto = components["schemas"]["ProtectRegionDto"];
export type ProtectSubscription = components["schemas"]["ProtectSubscription"];
export type QuestionnaireAnswers = components["schemas"]["QuestionnaireAnswers"];
export type RecommendationAction = components["schemas"]["RecommendationAction"];
export type RecommendationActionRequest = components["schemas"]["RecommendationActionRequest"];
export type RecommendationDto = components["schemas"]["RecommendationDto"];
export type RecommendationKind = components["schemas"]["RecommendationKind"];
export type RecommendationRunFailureReason = components["schemas"]["RecommendationRunFailureReason"];
export type RecommendationStatus = components["schemas"]["RecommendationStatus"];
export type RemediationConsentState = components["schemas"]["RemediationConsentState"];
export type RemediationImpactItemDto = components["schemas"]["RemediationImpactItemDto"];
export type RemediationImpactOverviewDto = components["schemas"]["RemediationImpactOverviewDto"];
export type RemediationImpactTemplateKey = components["schemas"]["RemediationImpactTemplateKey"];
export type RemoveEeeuActionParameter = components["schemas"]["RemoveEeeuActionParameter"];
export type RemoveEeeuMetadata = components["schemas"]["RemoveEeeuMetadata"];
export type RemoveEeeuOptions = components["schemas"]["RemoveEeeuOptions"];
export type RemoveGroupGuestParameter = components["schemas"]["RemoveGroupGuestParameter"];
export type RemoveGroupMembersSelectionParameters = components["schemas"]["RemoveGroupMembersSelectionParameters"];
export type RemoveGroupOwnerRequest = components["schemas"]["RemoveGroupOwnerRequest"];
export type RemoveGroupOwnersSelectionParameters = components["schemas"]["RemoveGroupOwnersSelectionParameters"];
export type RemoveGroupUsersSelectionParameters = components["schemas"]["RemoveGroupUsersSelectionParameters"];
export type RemovePrincipalFromSPGroupParameter = components["schemas"]["RemovePrincipalFromSPGroupParameter"];
export type RemoveReviewItemsRequest = components["schemas"]["RemoveReviewItemsRequest"];
export type RemoveSharingLinkRecipientNodesParameter = components["schemas"]["RemoveSharingLinkRecipientNodesParameter"];
export type RemoveSharingLinkRecipientsParameter = components["schemas"]["RemoveSharingLinkRecipientsParameter"];
export type ReportGenerationStatus = components["schemas"]["ReportGenerationStatus"];
export type ReportShareCreatedPayload = components["schemas"]["ReportShareCreatedPayload"];
export type ReportShareDeletedPayload = components["schemas"]["ReportShareDeletedPayload"];
export type ReportShareExpiryChangedPayload = components["schemas"]["ReportShareExpiryChangedPayload"];
export type ReportShareKind = components["schemas"]["ReportShareKind"];
export type ReportShareRecipientsAddedPayload = components["schemas"]["ReportShareRecipientsAddedPayload"];
export type ReportShareRecipientsRemovedPayload = components["schemas"]["ReportShareRecipientsRemovedPayload"];
export type ReportShareRenamedPayload = components["schemas"]["ReportShareRenamedPayload"];
export type ReportShareRevokedPayload = components["schemas"]["ReportShareRevokedPayload"];
export type ReportShareSelection = components["schemas"]["ReportShareSelection"];
export type ResendReviewNotificationRequest = components["schemas"]["ResendReviewNotificationRequest"];
export type ResourceType = components["schemas"]["ResourceType"];
export type ReviewActivationState = components["schemas"]["ReviewActivationState"];
export type ReviewActivationStateResponse = components["schemas"]["ReviewActivationStateResponse"];
export type ReviewDetails = components["schemas"]["ReviewDetails"];
export type ReviewItemDetailsResponse = components["schemas"]["ReviewItemDetailsResponse"];
export type ReviewItemLifecycleDecisionResponse = components["schemas"]["ReviewItemLifecycleDecisionResponse"];
export type ReviewItemReviewerResponse = components["schemas"]["ReviewItemReviewerResponse"];
export type ReviewLifecycleScope = components["schemas"]["ReviewLifecycleScope"];
export type ReviewMaterializationState = components["schemas"]["ReviewMaterializationState"];
export type ReviewMaterializationStateResponse = components["schemas"]["ReviewMaterializationStateResponse"];
export type ReviewResponse = components["schemas"]["ReviewResponse"];
export type ReviewSettings = components["schemas"]["ReviewSettings"];
export type ReviewSettingsRequest = components["schemas"]["ReviewSettingsRequest"];
export type ReviewType = components["schemas"]["ReviewType"];
export type ReviewTypeCountResponse = components["schemas"]["ReviewTypeCountResponse"];
export type ReviewTypeCountsResponse = components["schemas"]["ReviewTypeCountsResponse"];
export type ReviewsSummaryResponse = components["schemas"]["ReviewsSummaryResponse"];
export type SPGroupMemberItemInfo = components["schemas"]["SPGroupMemberItemInfo"];
export type SearchSensitivityLabelsParameters = components["schemas"]["SearchSensitivityLabelsParameters"];
export type SearchSensitivityLabelsResult = components["schemas"]["SearchSensitivityLabelsResult"];
export type SearchSensitivityLabelsResultPaginated = components["schemas"]["SearchSensitivityLabelsResultPaginated"];
export type SecurityGroupClaimKind = components["schemas"]["SecurityGroupClaimKind"];
export type SecurityGroupPermissionNodeProperties = components["schemas"]["SecurityGroupPermissionNodeProperties"];
export type SecurityGroupType = components["schemas"]["SecurityGroupType"];
export type SendConsentRequestRequest = components["schemas"]["SendConsentRequestRequest"];
export type SendTestEmailRequest = components["schemas"]["SendTestEmailRequest"];
export type SensitivityLabelSortableFields = components["schemas"]["SensitivityLabelSortableFields"];
export type SensitivityLabelSortableFieldsSortOrder = components["schemas"]["SensitivityLabelSortableFieldsSortOrder"];
export type SensitivitySublabelResult = components["schemas"]["SensitivitySublabelResult"];
export type Session = components["schemas"]["Session"];
export type SetProtectRegionRequest = components["schemas"]["SetProtectRegionRequest"];
export type SettingState = components["schemas"]["SettingState"];
export type Severity = components["schemas"]["Severity"];
export type SgWorkspace = components["schemas"]["SgWorkspace"];
export type SharePointEntityBulkRequest = components["schemas"]["SharePointEntityBulkRequest"];
export type SharePointEntityBulkTarget = components["schemas"]["SharePointEntityBulkTarget"];
export type SharePointEntityDto = components["schemas"]["SharePointEntityDto"];
export type SharePointEntityDtoPaginated = components["schemas"]["SharePointEntityDtoPaginated"];
export type SharePointEntityType = components["schemas"]["SharePointEntityType"];
export type SharePointGroupAssociatedRole = components["schemas"]["SharePointGroupAssociatedRole"];
export type SharePointGroupPermissionNodeProperties = components["schemas"]["SharePointGroupPermissionNodeProperties"];
export type SharePointSharingSettings = components["schemas"]["SharePointSharingSettings"];
export type SharePointSharingSettingsDataPoint = components["schemas"]["SharePointSharingSettingsDataPoint"];
export type SharedLinkAccessDto = components["schemas"]["SharedLinkAccessDto"];
export type SharedLinkItemInfo = components["schemas"]["SharedLinkItemInfo"];
export type SharedLinkMembershipPathNodeDto = components["schemas"]["SharedLinkMembershipPathNodeDto"];
export type SharedLinkPermissionNodeProperties = components["schemas"]["SharedLinkPermissionNodeProperties"];
export type SharedLinkType = components["schemas"]["SharedLinkType"];
export type SharingCapability = components["schemas"]["SharingCapability"];
export type SharingCapabilityParameter = components["schemas"]["SharingCapabilityParameter"];
export type SharingDomainRestrictionModes = components["schemas"]["SharingDomainRestrictionModes"];
export type SharingLinkDeletedPayload = components["schemas"]["SharingLinkDeletedPayload"];
export type SharingLinkRecipientItemInfo = components["schemas"]["SharingLinkRecipientItemInfo"];
export type SharingLinkRecipientKind = components["schemas"]["SharingLinkRecipientKind"];
export type SharingLinkRecipientRemovedPayload = components["schemas"]["SharingLinkRecipientRemovedPayload"];
export type SharingLinkType = components["schemas"]["SharingLinkType"];
export type SharingPermissionType = components["schemas"]["SharingPermissionType"];
export type SharingSettingStats = components["schemas"]["SharingSettingStats"];
export type SiteArchivedPayload = components["schemas"]["SiteArchivedPayload"];
export type SiteCollectionAdminItemInfo = components["schemas"]["SiteCollectionAdminItemInfo"];
export type SiteCollectionAdminRemovedPayload = components["schemas"]["SiteCollectionAdminRemovedPayload"];
export type SiteCollectionKind = components["schemas"]["SiteCollectionKind"];
export type SiteCollectionSharePointEntities = components["schemas"]["SiteCollectionSharePointEntities"];
export type SiteDeletedPayload = components["schemas"]["SiteDeletedPayload"];
export type SiteFileVersionPolicyUpdatedPayload = components["schemas"]["SiteFileVersionPolicyUpdatedPayload"];
export type SiteFileVersionsTrimmedPayload = components["schemas"]["SiteFileVersionsTrimmedPayload"];
export type SiteItemInfo = components["schemas"]["SiteItemInfo"];
export type SiteSharingCapabilityUpdatedPayload = components["schemas"]["SiteSharingCapabilityUpdatedPayload"];
export type SiteSharingSettingStats = components["schemas"]["SiteSharingSettingStats"];
export type SiteSharingSettingStatsDataPoint = components["schemas"]["SiteSharingSettingStatsDataPoint"];
export type SiteStats = components["schemas"]["SiteStats"];
export type SitesRestrictionsCounts = components["schemas"]["SitesRestrictionsCounts"];
export type SitesRestrictionsCountsDataPoint = components["schemas"]["SitesRestrictionsCountsDataPoint"];
export type SitesRestrictionsSettings = components["schemas"]["SitesRestrictionsSettings"];
export type SitesRestrictionsSettingsDataPoint = components["schemas"]["SitesRestrictionsSettingsDataPoint"];
export type SortDirection = components["schemas"]["SortDirection"];
export type StartRunFailedResponse = components["schemas"]["StartRunFailedResponse"];
export type StartRunResponse = components["schemas"]["StartRunResponse"];
export type StaticBulkActionDetails = components["schemas"]["StaticBulkActionDetails"];
export type StaticExternalActionDetails = components["schemas"]["StaticExternalActionDetails"];
export type StaticInsightRecommendationsResponse = components["schemas"]["StaticInsightRecommendationsResponse"];
export type StaticPolicyDetails = components["schemas"]["StaticPolicyDetails"];
export type StaticRecommendationDto = components["schemas"]["StaticRecommendationDto"];
export type StaticReviewDetails = components["schemas"]["StaticReviewDetails"];
export type StringDataPoint = components["schemas"]["StringDataPoint"];
export type SubmitTrialReasonRequest = components["schemas"]["SubmitTrialReasonRequest"];
export type TelemetryEventBody = components["schemas"]["TelemetryEventBody"];
export type TenantAccessSettings = components["schemas"]["TenantAccessSettings"];
export type TenantCrawlOverviewDto = components["schemas"]["TenantCrawlOverviewDto"];
export type TenantFileVersionPolicyUpdatedPayload = components["schemas"]["TenantFileVersionPolicyUpdatedPayload"];
export type TenantInfo = components["schemas"]["TenantInfo"];
export type TenantOverview = components["schemas"]["TenantOverview"];
export type TenantOverviewDto = components["schemas"]["TenantOverviewDto"];
export type TenantSettingsItemInfo = components["schemas"]["TenantSettingsItemInfo"];
export type TenantSharingCapabilities = components["schemas"]["TenantSharingCapabilities"];
export type TenantSharingCapabilitiesDataPoint = components["schemas"]["TenantSharingCapabilitiesDataPoint"];
export type ToggleAutomationEnabledRequest = components["schemas"]["ToggleAutomationEnabledRequest"];
export type TrimDocumentLibraryFileVersionsParameters = components["schemas"]["TrimDocumentLibraryFileVersionsParameters"];
export type TrimSiteFileVersionsActionParameter = components["schemas"]["TrimSiteFileVersionsActionParameter"];
export type TrimSiteFileVersionsParameters = components["schemas"]["TrimSiteFileVersionsParameters"];
export type UpdateAutomationRequest = components["schemas"]["UpdateAutomationRequest"];
export type UpdateCustomReportRequest = components["schemas"]["UpdateCustomReportRequest"];
export type UpdateDocumentLibraryFileVersionPolicyParameters = components["schemas"]["UpdateDocumentLibraryFileVersionPolicyParameters"];
export type UpdateGroupVisibilityRequest = components["schemas"]["UpdateGroupVisibilityRequest"];
export type UpdateReportShareRequest = components["schemas"]["UpdateReportShareRequest"];
export type UpdateSiteFileVersionPolicyActionParameter = components["schemas"]["UpdateSiteFileVersionPolicyActionParameter"];
export type UpdateSiteFileVersionPolicyParameters = components["schemas"]["UpdateSiteFileVersionPolicyParameters"];
export type UpdateTenantFileVersionPolicyParameters = components["schemas"]["UpdateTenantFileVersionPolicyParameters"];
export type UserBatchResult = components["schemas"]["UserBatchResult"];
export type UserItemInfo = components["schemas"]["UserItemInfo"];
export type UserLicenseItemInfo = components["schemas"]["UserLicenseItemInfo"];
export type UserLicenseUnassignedPayload = components["schemas"]["UserLicenseUnassignedPayload"];
export type UserStats = components["schemas"]["UserStats"];
export type UserType = components["schemas"]["UserType"];
export type VersionLimitPolicy = components["schemas"]["VersionLimitPolicy"];
export type WorkspaceActivitiesStats = components["schemas"]["WorkspaceActivitiesStats"];
export type WorkspaceActivitiesStatsDataPoint = components["schemas"]["WorkspaceActivitiesStatsDataPoint"];
export type WorkspaceConsentRequest = components["schemas"]["WorkspaceConsentRequest"];
export type WorkspaceContentSize = components["schemas"]["WorkspaceContentSize"];
export type WorkspaceContentSizeListDataPoint = components["schemas"]["WorkspaceContentSizeListDataPoint"];
export type WorkspaceReconsentRequest = components["schemas"]["WorkspaceReconsentRequest"];
export type WorkspaceVersionStorageChartData = components["schemas"]["WorkspaceVersionStorageChartData"];
export type WorkspaceVersionStorageChartDataPoint = components["schemas"]["WorkspaceVersionStorageChartDataPoint"];
export type Endpoints = keyof paths;
